import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, EventEmitter, Directive, Output, HostListener, inject, input, ChangeDetectorRef, ChangeDetectionStrategy, signal, Optional, NgModule } from '@angular/core';
import * as i1 from '@ngrx/store';
import { createFeatureSelector, createSelector, Store, select, StoreModule } from '@ngrx/store';
import * as i2 from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@ng-bootstrap/ng-bootstrap';
import { NgbPopover, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1$1 from '@angular/forms';
import { UntypedFormControl, UntypedFormArray, ReactiveFormsModule, FormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Subscription, combineLatest, switchMap, of, map, filter as filter$1, first } from 'rxjs';
import { filter, mergeMap, map as map$1, distinctUntilChanged, take } from 'rxjs/operators';
import * as i3 from '@seco/core';
import { ModalManagerService, LocalStorageService, ReactiveFormUtilsService } from '@seco/core';
import { toDataURL } from 'qrcode';
import * as i6 from '@ng-select/ng-select';
import * as i5 from '@design-factory/design-factory';
import { DfAdvancedInputModule, DfPopoverModule, DfAlertModule, DfSelectModule } from '@design-factory/design-factory';
import * as i1$2 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';

var LoginAlertType;
(function (LoginAlertType) {
    LoginAlertType["error"] = "E";
    LoginAlertType["warning"] = "W";
    LoginAlertType["info"] = "I";
    LoginAlertType["success"] = "S";
})(LoginAlertType || (LoginAlertType = {}));
class LoginAlertModel {
    constructor(result) {
        if (typeof result === 'object' && 'message' in result) {
            this.convertResult(result);
        }
        else {
            this.convertResult({ message: result.toString() });
        }
    }
    /**
     * Convert the result.
     * @param result
     */
    convertResult(result) {
        this.type = result.type || LoginAlertType.error;
        this.error = new Error(result.message);
        if (result.code) {
            this.code = parseInt(result.code, 10);
        }
        this.localisation = result.localisation || false;
        this.details = result.details;
    }
}

const CLP_ACTION = {
    CLP_INIT: '[ClpActions] Init clp service',
    CLP_INITIALIZED: '[ClpActions] Clp is initialized',
    OTP_ERROR_RECEIVED: '[ClpActions] Received otp has been sent error, go to otp state',
    PASSWORD_RULES_REQUEST: '[ClpActions] Send password rules request',
    PASSWORD_RULES_RECEIVED: '[ClpActions] Received password rules',
    PASSWORD_RULES_ERROR_RECEIVED: '[ClpActions] Received password rules error',
    ERROR_RECEIVED: '[ClpActions] Received clp errors',
    OTP_EMULATE_ERROR_RECEIVED: '[ClpActions] Received otp has been sent error, go to otp state'
};
class ClpInit {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.CLP_INIT;
    }
}
class ClpInitialized {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.CLP_INITIALIZED;
    }
}
class OtpErrorReceived {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.OTP_ERROR_RECEIVED;
    }
}
class OtpEmulateErrorReceived {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.OTP_EMULATE_ERROR_RECEIVED;
    }
}
class ClpErrorReceived {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.ERROR_RECEIVED;
    }
}
class PasswordRulesRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.PASSWORD_RULES_REQUEST;
    }
}
class PasswordRulesReceived {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.PASSWORD_RULES_RECEIVED;
    }
}
class PasswordRulesErrorReceived {
    constructor(payload) {
        this.payload = payload;
        this.type = CLP_ACTION.PASSWORD_RULES_ERROR_RECEIVED;
    }
}

class ClpLoaderService {
    constructor(store) {
        this.store = store;
        this.isClpAPIRequested = false;
        this.loadDdnaSdk();
    }
    loadClpAPI(clpBaseUrl) {
        if (!this.isClpAPIRequested) {
            this.isClpAPIRequested = true;
            const node = document.createElement('script');
            node.src = `${clpBaseUrl}/LoginService/embedUiLess?v=2.1`;
            node.type = 'text/javascript';
            node.async = true;
            document.getElementsByTagName('head')[0].appendChild(node);
            node.onerror = (err) => {
                this.store.dispatch(new ClpErrorReceived([
                    new LoginAlertModel($localize `:@@login.clp.apiError:An issue occured during CLP API load. Please reload the application.`)
                ]));
            };
        }
        else {
            throw Error('[LOGIN MODULE ERROR] CLP API has been already requested. You can not load it twice.');
        }
    }
    /**
     * Useful for the DDNA SDK, the extension will analyze the meta tag and add DDNA scripts in the DOM
     * @private
     */
    loadDdnaSdk() {
        const meta = document.createElement('meta');
        meta.setAttribute('use-1a-ddna', 'true');
        document.getElementsByTagName('head')[0].appendChild(meta);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpLoaderService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.Store }] });

var MFA_ID;
(function (MFA_ID) {
    MFA_ID["TOTP"] = "TOTP_OTP_EMAIL";
    MFA_ID["DDNA"] = "DDNA_OTP_EMAIL";
    MFA_ID["OTP_SMS"] = "LOC_OTP_SMS";
    MFA_ID["OTP_VOICE_CALL"] = "LOC_OTP_VOICE";
})(MFA_ID || (MFA_ID = {}));
var ClpApi;
(function (ClpApi) {
    ClpApi[ClpApi["LOGIN"] = 0] = "LOGIN";
    ClpApi[ClpApi["RESET_PASSWORD"] = 1] = "RESET_PASSWORD";
    ClpApi[ClpApi["VALID_PASSWORD"] = 2] = "VALID_PASSWORD";
    ClpApi[ClpApi["LOGOUT"] = 3] = "LOGOUT";
    ClpApi[ClpApi["JUMP_LOGIN"] = 4] = "JUMP_LOGIN";
})(ClpApi || (ClpApi = {}));
class ClpConfigModel {
}

class ClpService {
    constructor(store, http, zone) {
        this.store = store;
        this.http = http;
        this.zone = zone;
        this.forceSignIn = false;
        this.referenceQualifier = 'WIN';
    }
    /**
     * Init CLP.
     * @param clpInitConfig
     * @param clpApi
     */
    setClpConfig(clpInitConfig, clpApi) {
        this.cleanupGettersCallbacks(clpApi);
        this.getters.getLogin(() => clpInitConfig.username);
        this.getters.getOfficeId(() => clpInitConfig.officeId);
        this.getters.getLanguage(() => this.loginConfig.language);
        this.callbacks.onSuccess(clpInitConfig.onClpSuccess);
        switch (clpApi) {
            case ClpApi.LOGIN:
                this.getters.getForceSignIn(() => this.forceSignIn);
                this.getters.getOneTimePassword(() => clpInitConfig.otp);
                this.getters.getPhoneNumber(() => clpInitConfig.phoneNumber);
                this.getters.getPhoneValidationCode(() => clpInitConfig.phoneValidationCode);
                this.getters.getDutyCode(() => clpInitConfig.dutyCode);
                this.getters.getUseDefaultOffice(() => clpInitConfig.useDefaultoffice);
                if (!clpInitConfig.newPassword) {
                    this.getters.getPassword(() => clpInitConfig.password);
                    this.getters.getNewPassword1(() => '');
                    this.getters.getNewPassword2(() => '');
                }
                this.callbacks.onOneTimePasswordRequest(clpInitConfig.onOneTimePasswordRequest);
                this.callbacks.onPasswordRequest(clpInitConfig.onPasswordRequest);
                this.callbacks.onPhoneRegistrationRequest(clpInitConfig.onPhoneRegistrationRequest);
                this.callbacks.onPhoneValidationCodeRequest(clpInitConfig.onPhoneValidationCodeRequest);
                this.callbacks.onMonosignError(clpInitConfig.onMonosignError);
                this.callbacks.onDdnaCheckStart(clpInitConfig.onDdnaCheckStart);
                this.callbacks.onDdnaCheckEnd(clpInitConfig.onDdnaCheckEnd);
                this.callbacks.onDdnaRegistrationRequest(clpInitConfig.onDdnaRegistrationRequest);
                this.callbacks.onPasswordChangeRequest(clpInitConfig.onPasswordChangeRequest);
                this.callbacks.onError(this.onClpError.bind(this));
                this.callbacks.onOfficeListRetrieved(clpInitConfig.onOfficeList);
                if (this.clpInitConfig.loginParameters.mfaSelfRegistrationActivated) {
                    this.callbacks.onSelectMFARequest(clpInitConfig.onSelectMFARequest);
                    this.getters.getSelectedMFAId(() => clpInitConfig.selectedMFAId);
                    this.callbacks.onTimeBasedOtpRequest(clpInitConfig.onTimeBasedOtpRequest);
                    this.getters.getTimeBasedOtp(() => clpInitConfig.timeBasedOtp);
                    this.callbacks.onTimeBasedOtpRegistrationRequest(clpInitConfig.onTimeBasedOtpRegistrationRequest);
                }
                break;
            case ClpApi.RESET_PASSWORD:
                this.getters.getNewPassword1(() => clpInitConfig.newPassword);
                this.getters.getNewPassword2(() => clpInitConfig.confirmPassword);
                this.callbacks.onError(this.onClpError.bind(this));
                break;
            case ClpApi.JUMP_LOGIN:
                this.getters.getOrganization(() => clpInitConfig.organization);
                this.getters.getOneTimePassword(() => clpInitConfig.otp);
                this.getters.getReferenceNumber(() => this.loginConfig.referenceNumber);
                this.getters.getReferenceQualifier(() => this.referenceQualifier);
                this.getters.getUseDefaultOffice(() => clpInitConfig.useDefaultoffice);
                this.getters.getImpersonateToken(() => clpInitConfig.ott);
                this.callbacks.onOneTimePasswordRequest(clpInitConfig.onOneTimePasswordRequest);
                this.callbacks.onImpersonateTokenRequest(clpInitConfig.onImpersonateTokenRequest);
                this.callbacks.onError(this.onEmulateClpError.bind(this));
                break;
        }
    }
    /**
     * Identify through clp.
     *
     * @param isSSO
     */
    identify(isSSO) {
        window.clp.login.init(this.getters, this.callbacks);
        window.clp.login.identify(isSSO);
    }
    /**
     * authenticate through clp.
     *
     */
    authenticate() {
        window.clp.login.authenticate();
    }
    /**
     * Login with OTP through CLP.
     * @param otp
     * @param password
     */
    loginWithOtp(otp, password, isSelectedMFAFlow = false) {
        window.clp.login.setOneTimePasswordGetter(() => otp);
        if (!isSelectedMFAFlow) {
            window.clp.login.setPasswordGetter(() => password);
        }
        this.authenticate();
    }
    /**
     * Login with TOTP through CLP.
     * @param totp
     * @param password
     */
    loginWithTotp(totp, password) {
        window.clp.login.setTimeBasedOtpGetter(() => totp);
        window.clp.login.setPasswordGetter(() => password);
        this.authenticate();
    }
    /**
     * register phone number through CLP.
     * @param phoneNumber
     * @param password
     */
    registerPhoneNumber(phoneNumber) {
        // phonenumber+updateFactor
        window.clp.login.setPhoneNumberGetter(() => phoneNumber);
        window.clp.login.updateFactor();
    }
    /**
     * Login with phone validaton code through CLP.
     * @param phoneValidationCode
     * @param password
     */
    loginWithPhoneValidationCode(phoneValidationCode, password) {
        window.clp.login.setPhoneValidationCodeGetter(() => phoneValidationCode);
        password && window.clp.login.setPasswordGetter(() => password);
        window.clp.login.updateFactor();
    }
    /**
     * register Authenticator code
     *
     */
    registrationTotpWithAuthenticatorCode(authenticatorValidationCode) {
        window.clp.login.setTimeBasedOtpGetter(() => authenticatorValidationCode);
        window.clp.login.updateFactor();
    }
    /* Jump login through CLP.
     * @param username
     * @param officeID
     * @param accessToken
     * @param idToken
     */
    jumpLogin(username, officeID, accessToken, idToken) {
        window.clp.impersonate.init(accessToken, idToken, this.getters, this.callbacks);
        window.clp.validators.isLogin(username);
        window.clp.validators.isOfficeId(officeID);
        window.clp.impersonate.impersonate();
    }
    /**
     * Login after force sign out.
     */
    loginAfterForcedSignOut() {
        this.forceSignIn = true;
        this.authenticate();
    }
    /**
     * Triggers the start of the authentication process with change password (even if no expired/default password error in context).
     * @param newPassword
     * @param confirmPassword
     */
    loginAndChangePassword(newPassword, confirmPassword) {
        window.clp.login.setNewPassword1Getter(() => newPassword);
        window.clp.login.setNewPassword2Getter(() => confirmPassword);
        window.clp.login.updateFactor();
    }
    /**
     * Set office id getter, call authenticate
     * @param officeID
     */
    loginWithOfficeId(officeID) {
        window.clp.login.setOfficeIdGetter(() => officeID);
        window.clp.login.identify(false);
    }
    /**
     * Set label and ids for ddna registration, call updateFactor to update getters
     * @param label
     * @param deviceIds
     */
    ddnaRegister(label, deviceIds) {
        window.clp.login.setDeviceLabelGetter(() => label);
        window.clp.login.setDeviceIdsGetter(() => deviceIds);
        window.clp.login.updateFactor();
    }
    /**
     * Reset password.
     */
    resetPassword() {
        window.clp.resetPassword.init(this.getters, this.callbacks);
        window.clp.resetPassword.resetPassword();
    }
    /**
     * Get the input config of CLP.
     * @return the input config
     */
    getClpInitConfig() {
        return this.clpInitConfig;
    }
    /**
     * Validate password.
     * @param newPassword
     * @param onSuccess
     */
    validatePassword(newPassword, onSuccess) {
        this.cleanupGettersCallbacks(ClpApi.VALID_PASSWORD);
        this.getters.getPassword(() => newPassword);
        this.getters.getLanguage(() => this.loginConfig.language);
        this.callbacks.onSuccess(onSuccess);
        this.callbacks.onError(this.onClpError.bind(this));
        window.clp.validatePassword.init(window.location.hash, this.getters, this.callbacks);
        window.clp.validatePassword.validatePassword();
    }
    /**
     * Init CLP config.
     * @param config
     */
    initClpConfig(config, loginConfig) {
        this.clpInitConfig = config;
        this.loginConfig = loginConfig;
        this.store.dispatch(new ClpInit());
        if (window.clp) {
            this.callClpInit();
        }
        else {
            window.onClpApiLoaded = this.callClpInit.bind(this);
        }
    }
    /**
     * Logout action
     */
    logout(data, onSuccess) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        const CLP_SIGNOUT_URL = `${this.clpInitConfig.baseUrl}/LoginService/rs/auth2.0/signOut?responseType=JSON\
&service=${this.loginConfig.clpAppId}&nonce=${this.clpInitConfig.nonce}`;
        const body = new HttpParams().set('data', data);
        this.wrapPostWithHeaders(CLP_SIGNOUT_URL, headers, body.toString(), onSuccess, this.onClpError.bind(this));
    }
    /**
     * Return login configuration
     */
    getLoginConfig() {
        return this.loginConfig;
    }
    /**
     *
     * @param mfa
     */
    setSelectedMFA(mfa) {
        window.clp.login.setSelectedMFAIdGetter(() => mfa.id);
        window.clp.login.authenticate();
    }
    _convertErrorsToLoginAlertModel(errors) {
        const alertModels = [];
        for (const error of errors) {
            if (error) {
                const alert = new LoginAlertModel(error);
                if (alert.code === 35000) {
                    // DDNA extension error code
                    const installUrl = `${this.clpInitConfig?.baseUrl}/LoginService/${alert.details?.url}`;
                    alert.error.message = $localize `:@@clp.ddna.error.extension:Extension is not installed, please download and install it : ${installUrl}`;
                }
                alert.code += 2000000;
                alertModels.push(alert);
            }
        }
        return alertModels;
    }
    /**
     * On Api error.
     * @param errors
     */
    onClpError(errors) {
        const alertModels = this._convertErrorsToLoginAlertModel(errors);
        const hasOtpError = alertModels.find((error) => error.code === 26355);
        if (hasOtpError) {
            this.store.dispatch(new OtpErrorReceived(alertModels));
        }
        else {
            this.store.dispatch(new ClpErrorReceived(alertModels));
        }
    }
    /**
     * On Api error for emulate.
     * @param errors
     */
    onEmulateClpError(errors) {
        const alertModels = this._convertErrorsToLoginAlertModel(errors);
        const hasOtpError = alertModels.find((error) => error.code === 26355);
        if (hasOtpError) {
            this.store.dispatch(new OtpEmulateErrorReceived(alertModels));
        }
        else {
            this.store.dispatch(new ClpErrorReceived(alertModels));
        }
    }
    /**
     * Wrap get request.
     * @param url
     * @param onSuccess
     * @param onError
     */
    wrapGet(url, onSuccess, onError) {
        this.http.get(url).subscribe({ next: onSuccess, error: onError });
    }
    /**
     * Wrap post with headers manually created
     * @param url
     * @param headers
     * @param body
     * @param onSuccess
     * @param onError
     */
    wrapPostWithHeaders(url, headers, body, onSuccess, onError) {
        this.http.post(url, body, { headers, withCredentials: true }).subscribe({ next: onSuccess, error: onError });
    }
    /**
     * Wrap post request.
     * @param url
     * @param body
     * @param onSuccess
     * @param onError
     */
    wrapPost(url, body, onSuccess, onError) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
        this.wrapPostWithHeaders(url, headers, body, onSuccess, onError);
    }
    /**
     * Callback when clp is initialized.
     * @param usedConfig
     * @param isSSO - indicates if sso can be performed
     */
    clpInitialized(usedConfig, isSSO) {
        // Zone explicit call is needed as this callback is executed
        // through a different asynchronous context (CLP Api) and not related to handlers
        this.zone.run(() => {
            this.store.dispatch(new ClpInitialized({ initConfig: usedConfig, isSSO: isSSO && this.loginConfig.useSSO }));
        });
    }
    /**
     * Cleanup getters and callbacks of clp.
     * @param clpApi
     */
    cleanupGettersCallbacks(clpApi) {
        let api;
        switch (clpApi) {
            case ClpApi.LOGIN:
                api = window.clp.login;
                break;
            case ClpApi.RESET_PASSWORD:
                api = window.clp.resetPassword;
                break;
            case ClpApi.VALID_PASSWORD:
                api = window.clp.validatePassword;
                break;
            case ClpApi.LOGOUT:
                api = window.clp.logout;
                break;
            case ClpApi.JUMP_LOGIN:
                api = window.clp.impersonate;
                break;
        }
        this.getters = new api.Getters();
        this.callbacks = new api.Callbacks();
    }
    /**
     * Call CLP init method.
     */
    callClpInit() {
        this.utils = new window.clp.Utils();
        this.utils.post(this.wrapPost.bind(this));
        this.utils.get(this.wrapGet.bind(this));
        window.clp.init(this.loginConfig.clpAppId, this.clpInitConfig, this.utils, this.clpInitialized.bind(this, this.clpInitConfig));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpService, deps: [{ token: i1.Store }, { token: i2.HttpClient }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ClpService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.Store }, { type: i2.HttpClient }, { type: i0.NgZone }] });

const DEFAULT_INDICATOR = {
    length: false,
    lowercase: false,
    uppercase: false,
    specialchar: false,
    number: false,
    letter: false
};

const DDNA_DOWNLOADED = 'DDNA_DOWNLOADED';
class Utils {
    static checkPasswordRules(passwordRules, value) {
        const min = passwordRules.min;
        const max = passwordRules.max ?? '';
        let exp = `(?=^.{${min},${max}}$)`;
        if (passwordRules.uplc === 'Y') {
            exp += '(?=.*[a-z])(?=.*[A-Z])';
        }
        if (passwordRules.sc === 1) {
            exp += "(?=.*[~!@#$^&*_+\\-=(){}[\\]|:;'<>?,.\\/])";
        }
        if (passwordRules.an === 'Y') {
            exp += '(?=.*[0-9])(?=.*[a-zA-Z])';
        }
        const pwdRegex = new RegExp(exp);
        return pwdRegex.test(value) ? null : { error: 'invalidRules' };
    }
    static passwordIndicator(password, passwordRules) {
        const indicator = { ...DEFAULT_INDICATOR };
        const min = passwordRules.min;
        const max = passwordRules.max ?? '';
        let pwdRegex = new RegExp(`(?=^.{${min},${max}}$)`);
        indicator.length = pwdRegex.test(password);
        // UPPERCASE AND LOWERCASE
        if (passwordRules.uplc === 'Y') {
            pwdRegex = new RegExp('(?=.*[a-z])');
            indicator.lowercase = pwdRegex.test(password);
            pwdRegex = new RegExp('(?=.*[A-Z])');
            indicator.uppercase = pwdRegex.test(password);
        }
        // SPECIAL CHARACTER
        if (passwordRules.sc === 1) {
            pwdRegex = new RegExp("(?=.*[~!@#$^&*_+\\-=(){}[\\]|:;'<>?,.\\/])");
            indicator.specialchar = pwdRegex.test(password);
        }
        // ALPHANUM
        if (passwordRules.an === 'Y') {
            pwdRegex = new RegExp('(?=.*[0-9])');
            indicator.number = pwdRegex.test(password);
            pwdRegex = new RegExp('(?=.*[a-zA-Z])');
            indicator.letter = pwdRegex.test(password);
        }
        return indicator;
    }
    static passwordStrength(password, passwordRules) {
        const rules = passwordRules || { uplc: 'N', an: 'N', sc: 0 };
        const pwdState = this.getPwdState(password);
        let score = 0; // the score is initally 0.
        // LOWER CASE
        if (pwdState.lower > 0) {
            score += 3 + (pwdState.lower - 1);
        }
        // UPPER CASE
        if (pwdState.upper > 0) {
            if (rules.uplc === 'Y') {
                score += 4 + (pwdState.upper - 1);
            }
            else {
                score += 5 + (pwdState.upper - 1);
            }
        }
        // NUMERIC
        if (pwdState.number > 0) {
            if (rules.an === 'Y') {
                score += 4 + (pwdState.number - 1);
            }
            else {
                score += 5 + (pwdState.number - 1);
            }
        }
        // SPECIAL
        if (pwdState.special > 0) {
            if (rules.sc === 1) {
                score += 4 + (pwdState.special - 1);
            }
            else {
                score += 6 + (pwdState.special - 1);
            }
        }
        // we take away half the number of repeats, meaning that
        // unique characters are valued more highly.
        score -= 0.5 * pwdState.repeats;
        return score;
    }
    static getPwdState(str) {
        const duplicate = str
            .split('')
            .sort()
            .join('')
            .match(/(.)\1+/g);
        // number of char repeats
        const repeats = (duplicate?.join('')?.length || 0) - (duplicate?.length || 0);
        return {
            upper: str.match(/[A-Z]/g)?.length || 0,
            lower: str.match(/[a-z]/g)?.length || 0,
            number: str.match(/\d/g)?.length || 0,
            special: str.match(/[^a-zA-Z0-9]/g)?.length || 0,
            repeats
        };
    }
}

var PasswordStrengthLevel;
(function (PasswordStrengthLevel) {
    PasswordStrengthLevel[PasswordStrengthLevel["WEAK"] = 0] = "WEAK";
    PasswordStrengthLevel[PasswordStrengthLevel["MEDIUM"] = 1] = "MEDIUM";
    PasswordStrengthLevel[PasswordStrengthLevel["STRONG"] = 2] = "STRONG";
})(PasswordStrengthLevel || (PasswordStrengthLevel = {}));
class PasswordStrengthIndicatorComponent {
    constructor() {
        this.PasswordStrengthLevel = PasswordStrengthLevel;
        this.emptyPass = true;
    }
    get passwordRules() {
        return this._passwordRules;
    }
    get password() {
        return this._password;
    }
    set password(pwd) {
        this._password = pwd;
        this.updateStrengthIndicator();
    }
    set passwordRules(rules) {
        this._passwordRules = rules;
        this.updateStrengthIndicator();
    }
    updateStrengthIndicator() {
        if (this.password) {
            this.emptyPass = false;
            const passwordStrength = Utils.passwordStrength(this.password, this.passwordRules);
            this.strengthIndicator = this.getStrengthLevel(passwordStrength);
        }
        else {
            this.emptyPass = true;
        }
    }
    getStrengthLevel(score) {
        if (score > 20) {
            return PasswordStrengthLevel.STRONG;
        }
        if (score > 10) {
            return PasswordStrengthLevel.MEDIUM;
        }
        return PasswordStrengthLevel.WEAK;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PasswordStrengthIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: PasswordStrengthIndicatorComponent, isStandalone: true, selector: "ama-ng-password-strength-indicator", inputs: { password: "password", passwordRules: "passwordRules" }, ngImport: i0, template: "<div *ngIf=\"!emptyPass\">\n  <h6 class=\"d-inline-block text-secondary\">\n    <ng-container i18n=\"@@login.pwdStrength.strength\">Strength:</ng-container>\n  </h6>\n  <span\n    class=\"badge df-badge-dot me-2 ps-2\"\n    [ngClass]=\"{\n      'bg-danger': strengthIndicator === PasswordStrengthLevel.WEAK,\n      'bg-warning': strengthIndicator === PasswordStrengthLevel.MEDIUM,\n      'bg-success': strengthIndicator === PasswordStrengthLevel.STRONG\n    }\"\n    [ngSwitch]=\"strengthIndicator\"\n  >\n    <ng-container *ngSwitchCase=\"PasswordStrengthLevel.STRONG\" i18n=\"@@login.pwdStrength.strong\">STRONG</ng-container>\n    <ng-container *ngSwitchCase=\"PasswordStrengthLevel.MEDIUM\" i18n=\"@@login.pwdStrength.medium\">MEDIUM</ng-container>\n    <ng-container *ngSwitchDefault i18n=\"@@login.pwdStrength.weak\">WEAK</ng-container>\n  </span>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i4.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i4.NgSwitchDefault, selector: "[ngSwitchDefault]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PasswordStrengthIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-password-strength-indicator', standalone: true, imports: [CommonModule], template: "<div *ngIf=\"!emptyPass\">\n  <h6 class=\"d-inline-block text-secondary\">\n    <ng-container i18n=\"@@login.pwdStrength.strength\">Strength:</ng-container>\n  </h6>\n  <span\n    class=\"badge df-badge-dot me-2 ps-2\"\n    [ngClass]=\"{\n      'bg-danger': strengthIndicator === PasswordStrengthLevel.WEAK,\n      'bg-warning': strengthIndicator === PasswordStrengthLevel.MEDIUM,\n      'bg-success': strengthIndicator === PasswordStrengthLevel.STRONG\n    }\"\n    [ngSwitch]=\"strengthIndicator\"\n  >\n    <ng-container *ngSwitchCase=\"PasswordStrengthLevel.STRONG\" i18n=\"@@login.pwdStrength.strong\">STRONG</ng-container>\n    <ng-container *ngSwitchCase=\"PasswordStrengthLevel.MEDIUM\" i18n=\"@@login.pwdStrength.medium\">MEDIUM</ng-container>\n    <ng-container *ngSwitchDefault i18n=\"@@login.pwdStrength.weak\">WEAK</ng-container>\n  </span>\n</div>\n" }]
        }], propDecorators: { password: [{
                type: Input
            }], passwordRules: [{
                type: Input
            }] } });

class PasswordTooltipIndicatorComponent {
    constructor() {
        this.emptyPass = true;
    }
    get passwordRules() {
        return this._passwordRules;
    }
    get password() {
        return this._password;
    }
    set password(pwd) {
        this._password = pwd;
        this.updateRulesIndicator();
    }
    set passwordRules(rules) {
        this._passwordRules = rules;
        this.updateRulesIndicator();
    }
    open() {
        this.pwdPopover.open();
    }
    close() {
        this.pwdPopover.close();
    }
    updateRulesIndicator() {
        if (this.passwordRules && this.password) {
            this.passwordIndicator = Utils.passwordIndicator(this.password, this.passwordRules);
        }
        else {
            this.passwordIndicator = { ...DEFAULT_INDICATOR };
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PasswordTooltipIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: PasswordTooltipIndicatorComponent, isStandalone: true, selector: "ama-ng-password-tooltip-indicator", inputs: { password: "password", passwordRules: "passwordRules" }, providers: [Utils], viewQueries: [{ propertyName: "pwdPopover", first: true, predicate: ["pwdPopover"], descendants: true, static: true }], ngImport: i0, template: "<span\n  class=\"ms-2 fa-info-circle text-secondary\"\n  placement=\"top auto\"\n  [autoClose]=\"false\"\n  [ngbPopover]=\"popHintPassword\"\n  #pwdPopover=\"ngbPopover\"\n  triggers=\"mouseenter:mouseleave\"\n  i18n-popoverTitle=\"@@login.resetPwd.passwords.newPwd.popOverTitle\"\n></span>\n<ng-template #popHintPassword>\n  <ul class=\"ps-0 m-0 list-unstyled\">\n    <li *ngIf=\"passwordRules?.min\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.length }\"\n      ></ng-container>\n      <span *ngIf=\"passwordRules.max\" i18n=\"@@login.forgetPwd.explanation.tooltip.nbChar\"\n        >Between {{ passwordRules.min }} and {{ passwordRules.max }} characters</span\n      >\n      <span *ngIf=\"!passwordRules.max\" i18n=\"@@login.forgetPwd.explanation.tooltip.nbCharMin\"\n        >{{ passwordRules.min }} characters minimum</span\n      >\n    </li>\n    <li *ngIf=\"passwordRules?.uplc === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.lowercase }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.lowercase\">Lowercase letters (a-z)</span>\n    </li>\n    <li *ngIf=\"passwordRules?.uplc === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.uppercase }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.uppercase\">Uppercase letters (A-Z)</span>\n    </li>\n    <li *ngIf=\"passwordRules?.uplc === 'N' && passwordRules?.an === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.letter }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.letter\">Letters (a-Z)</span>\n    </li>\n    <li *ngIf=\"passwordRules?.an === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.number }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.numebr\">Numbers</span>\n    </li>\n    <li *ngIf=\"passwordRules?.sc === 1\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.specialchar }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.special\">Special characters (like &#64; or #)</span>\n    </li>\n  </ul>\n</ng-template>\n\n<ng-template #indicatorTemplate let-indicator=\"indicator\">\n  <span class=\"fa-container me-2\">\n    <span\n      [ngClass]=\"{\n        'fa-check text-success': indicator,\n        'fa-times text-secondary': !indicator\n      }\"\n      class=\"fa-solid\"\n      role=\"status\"\n      aria-hidden=\"true\"\n    ></span>\n  </span>\n</ng-template>\n", styles: [".icon-container{width:24px;height:24px;display:inline-block;text-align:center}\n"], dependencies: [{ kind: "directive", type: NgbPopover, selector: "[ngbPopover]", inputs: ["animation", "autoClose", "ngbPopover", "popoverTitle", "placement", "popperOptions", "triggers", "positionTarget", "container", "disablePopover", "popoverClass", "popoverContext", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["ngbPopover"] }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PasswordTooltipIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-password-tooltip-indicator', standalone: true, imports: [NgbPopover, CommonModule], providers: [Utils], template: "<span\n  class=\"ms-2 fa-info-circle text-secondary\"\n  placement=\"top auto\"\n  [autoClose]=\"false\"\n  [ngbPopover]=\"popHintPassword\"\n  #pwdPopover=\"ngbPopover\"\n  triggers=\"mouseenter:mouseleave\"\n  i18n-popoverTitle=\"@@login.resetPwd.passwords.newPwd.popOverTitle\"\n></span>\n<ng-template #popHintPassword>\n  <ul class=\"ps-0 m-0 list-unstyled\">\n    <li *ngIf=\"passwordRules?.min\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.length }\"\n      ></ng-container>\n      <span *ngIf=\"passwordRules.max\" i18n=\"@@login.forgetPwd.explanation.tooltip.nbChar\"\n        >Between {{ passwordRules.min }} and {{ passwordRules.max }} characters</span\n      >\n      <span *ngIf=\"!passwordRules.max\" i18n=\"@@login.forgetPwd.explanation.tooltip.nbCharMin\"\n        >{{ passwordRules.min }} characters minimum</span\n      >\n    </li>\n    <li *ngIf=\"passwordRules?.uplc === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.lowercase }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.lowercase\">Lowercase letters (a-z)</span>\n    </li>\n    <li *ngIf=\"passwordRules?.uplc === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.uppercase }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.uppercase\">Uppercase letters (A-Z)</span>\n    </li>\n    <li *ngIf=\"passwordRules?.uplc === 'N' && passwordRules?.an === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.letter }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.letter\">Letters (a-Z)</span>\n    </li>\n    <li *ngIf=\"passwordRules?.an === 'Y'\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.number }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.numebr\">Numbers</span>\n    </li>\n    <li *ngIf=\"passwordRules?.sc === 1\">\n      <ng-container\n        [ngTemplateOutlet]=\"indicatorTemplate\"\n        [ngTemplateOutletContext]=\"{ indicator: passwordIndicator?.specialchar }\"\n      ></ng-container>\n      <span i18n=\"@@login.forgetPwd.explanation.tooltip.special\">Special characters (like &#64; or #)</span>\n    </li>\n  </ul>\n</ng-template>\n\n<ng-template #indicatorTemplate let-indicator=\"indicator\">\n  <span class=\"fa-container me-2\">\n    <span\n      [ngClass]=\"{\n        'fa-check text-success': indicator,\n        'fa-times text-secondary': !indicator\n      }\"\n      class=\"fa-solid\"\n      role=\"status\"\n      aria-hidden=\"true\"\n    ></span>\n  </span>\n</ng-template>\n", styles: [".icon-container{width:24px;height:24px;display:inline-block;text-align:center}\n"] }]
        }], propDecorators: { pwdPopover: [{
                type: ViewChild,
                args: ['pwdPopover', { static: true }]
            }], password: [{
                type: Input
            }], passwordRules: [{
                type: Input
            }] } });

class CapsLockDirective {
    constructor() {
        this.capsLock = new EventEmitter();
        this.focused = false;
    }
    onKeyEvent(event) {
        if (event.type === 'focusin') {
            this.focused = true;
        }
        if (this.focused) {
            const capsOn = event.getModifierState && event.getModifierState('CapsLock');
            this.capsLock.emit(capsOn);
        }
        if (event.type === 'focusout') {
            this.focused = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CapsLockDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.12", type: CapsLockDirective, isStandalone: true, selector: "[capsLock]", outputs: { capsLock: "capsLock" }, host: { listeners: { "window:keydown": "onKeyEvent($event)", "window:keyup": "onKeyEvent($event)", "window:click": "onKeyEvent($event)", "focusout": "onKeyEvent($event)", "focusin": "onKeyEvent($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: CapsLockDirective, decorators: [{
            type: Directive,
            args: [{ standalone: true, selector: '[capsLock]' }]
        }], propDecorators: { capsLock: [{
                type: Output
            }], onKeyEvent: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }, {
                type: HostListener,
                args: ['window:keyup', ['$event']]
            }, {
                type: HostListener,
                args: ['window:click', ['$event']]
            }, {
                type: HostListener,
                args: ['focusout', ['$event']]
            }, {
                type: HostListener,
                args: ['focusin', ['$event']]
            }] } });

const LOGIN_ACTION = {
    IDENTIFY_REQUEST: '[LoginActions - Login] Send identify request',
    AUTHENTICATE_REQUEST: '[LoginActions - Login] Send authenticate request',
    LOGIN_REQUEST_SSO: '[LoginActions - Login] Send login request via SSO',
    LOGIN_RECEIVED_ACTION: '[LoginActions - Login] Received login from Action',
    ERROR_RECEIVED: '[LoginActions - Login] Received error',
    OTP_NEEDED: '[LoginActions - Login] OTP is needed',
    OTP_REQUEST: '[LoginActions - Login] Send login with OTP request',
    PHONE_NUMBER_NEEDED: '[LoginActions - Login] Phone Number is needed',
    PHONE_NUMBER_REQUEST: '[LoginActions - Login] Send phone number to get code',
    VALIDATION_CODE_NEEDED: '[LoginActions - Login] Validation code is needed',
    VALIDATION_CODE_REQUEST: '[LoginActions - Login] Send Validation code to login',
    DDNA_CHECK_START: '[LoginActions - Login] DDNA check start',
    DDNA_CHECK_END: '[LoginActions - Login] DDNA check end',
    DDNA_REQUEST: '[LoginActions - Login] send login with DDNA request',
    DDNA_NEEDED: '[LoginActions - Login] DDNA is needed',
    UPDATE_LOGIN_STORAGE: '[LoginActions - Login] Update login info stored in local storage',
    SIGN_IN_END: '[LoginActions - Login] Signed in finished',
    CANCEL_LOGIN_ACTION: '[LoginActions - Login] Cancel login',
    CHANGE_ACCOUNT: '[LoginActions - Login] Change account',
    INIT_FORGET_PWD_FLOW: '[LoginActions - Login] Init the forget password flow',
    INIT_VALIDATE_PWD_FLOW: '[LoginActions - Login] Init the validate password flow',
    VALIDATE_PWD_REQUEST: '[LoginActions - Login] Send validate password request',
    VALIDATE_PWD_END: '[LoginActions - Login] Validate password finished',
    RESET_PWD_REQUEST: '[LoginActions - Login] Send reset password request',
    RESET_PWD_END: '[LoginActions - Login] Reset password finished',
    EXPIRED_PASSWORD: '[LoginActions - Login] Password is expired',
    CHANGED_PASSOWRD_AND_LOGIN_REQUEST: '[LoginActions - Login] Change password and login request',
    LOGIN_OFFICE_LIST: '[LoginActions - Login] Login office list',
    CLOSE_FORCE_SIGN_IN: '[LoginActions - Login] Close force sign in modal',
    FORM_ERROR: '[LoginActions - Login] Error found in form',
    INIT_JUMP_LOGIN_FLOW: '[LoginActions - Login] Init the jump login flow',
    JUMP_LOGIN_REQUEST: '[LoginActions - Login] Send jump login request',
    JUMP_LOGIN_OTP_NEEDED: '[LoginActions - Login] OTP is needed for impersonate action',
    JUMP_LOGIN_OTT_NEEDED: '[LoginActions - Login] OTT is needed for impersonate action',
    MFA_SELF_SELECTION: '[LoginActions - Login] MFA self selection',
    SELECTED_MFA: '[LoginActions - Login] Set selected MFA',
    TOTP_NEEDED: '[LoginActions - Login] TOTP is needed',
    TOTP_REQUEST: '[LoginActions - Login] Send login with TOTP request',
    AUTHENTICATOR_APP_REQUEST: '[LoginActions - Login] Choose Authenticator App',
    AUTHENTICATOR_QRCODE_REQUEST: '[LoginActions - Login] Scan QR code from Authenticator App',
    AUTHENTICATOR_VALIDATION_CODE_REQUEST: '[LoginActions - Login] Enter validation code from Authenticator App'
};
class IdentifyRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.IDENTIFY_REQUEST;
    }
}
class AuthenticateRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.AUTHENTICATE_REQUEST;
    }
}
class LoginRequestSSO {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.LOGIN_REQUEST_SSO;
    }
}
class ErrorReceived {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.ERROR_RECEIVED;
    }
}
class OtpNeeded {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.OTP_NEEDED;
    }
}
class TotpNeeded {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.TOTP_NEEDED;
    }
}
class OtpRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.OTP_REQUEST;
    }
}
class TotpRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.TOTP_REQUEST;
    }
}
class AuthenticatorAppRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.AUTHENTICATOR_APP_REQUEST;
    }
}
class AuthenticatorQrCodeRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.AUTHENTICATOR_QRCODE_REQUEST;
    }
}
class AuthenticatorValidationCodeRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.AUTHENTICATOR_VALIDATION_CODE_REQUEST;
    }
}
class PhoneNumberNeeded {
    constructor(
    // mixed type for AD.
    payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.PHONE_NUMBER_NEEDED;
    }
}
class PhoneNumberRequest {
    //mixed type for AD.
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.PHONE_NUMBER_REQUEST;
    }
}
class ValidationCodeNeeded {
    constructor(
    // mixed type for AD.
    payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.VALIDATION_CODE_NEEDED;
    }
}
class ValidationCodeRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.VALIDATION_CODE_REQUEST;
    }
}
class DdnaCheckStart {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.DDNA_CHECK_START;
    }
}
class DdnaCheckEnd {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.DDNA_CHECK_END;
    }
}
class DdnaRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.DDNA_REQUEST;
    }
}
class DdnaNeeded {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.DDNA_NEEDED;
    }
}
class UpdateLoginStorage {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.UPDATE_LOGIN_STORAGE;
    }
}
class SignInEnd {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.SIGN_IN_END;
    }
}
class ChangeAccount {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.CHANGE_ACCOUNT;
    }
}
class CloseForceSignIn {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.CLOSE_FORCE_SIGN_IN;
    }
}
class InitForgetPwdFlow {
    constructor(payload, subtitle) {
        this.payload = payload;
        this.subtitle = subtitle;
        this.type = LOGIN_ACTION.INIT_FORGET_PWD_FLOW;
    }
}
class InitValidatePwdFlow {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.INIT_VALIDATE_PWD_FLOW;
    }
}
class ValidatePasswordRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.VALIDATE_PWD_REQUEST;
    }
}
class ValidatePasswordEnd {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.VALIDATE_PWD_END;
    }
}
class InitJumpLoginFlow {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.INIT_JUMP_LOGIN_FLOW;
    }
}
class JumpLoginRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.JUMP_LOGIN_REQUEST;
    }
}
class OtpNeededImpersonate {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.JUMP_LOGIN_OTP_NEEDED;
    }
}
class OttNeededImpersonate {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.JUMP_LOGIN_OTT_NEEDED;
    }
}
class ResetPasswordRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.RESET_PWD_REQUEST;
    }
}
class ResetPasswordEnd {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.RESET_PWD_END;
    }
}
class ExpiredPassword {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.EXPIRED_PASSWORD;
    }
}
class ChangePasswordAndLoginRequest {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.CHANGED_PASSOWRD_AND_LOGIN_REQUEST;
    }
}
class OfficeList {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.LOGIN_OFFICE_LIST;
    }
}
class FormError {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.FORM_ERROR;
    }
}
class MfaSelfSelection {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.MFA_SELF_SELECTION;
    }
}
class SelectedMFA {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_ACTION.SELECTED_MFA;
    }
}

const TRANSLATIONS = {
    username: $localize `:@@login.username.label:Username`,
    officeId: $localize `:@@login.officeId.label:Office ID`,
    password: $localize `:@@login.password.label:Password`,
    newPassword: $localize `:@@login.resetPwd.passwords.newPwd:New password`,
    confirmPassword: $localize `:@@login.resetPwd.passwords.confirmPwd:Confirm your new password`,
    otp: $localize `:@@login.otp.label:One-time password`,
    ott: $localize `:@@login.ott.label:One-time token`,
    ddnaLabel: $localize `:@@login.ddna.label:Device combination name`,
    ddnaDeviceIds: $localize `:@@login.ddna.devices:Select a device combination`
};
class FormErrorService {
    constructor(store) {
        this.store = store;
    }
    updateError(fields) {
        this.store.dispatch(new FormError({
            message: $localize `:@@login.form.error:Please correct the error or enter the missing information`,
            fields
        }));
    }
    cleanError() {
        this.store.dispatch(new FormError());
    }
    /**
     * getFieldsInError. Used to get all fields in error form a form
     * CAUTION: field name must be referenced in TRANSLATIONS
     * @param group the form group to evaluate
     */
    getFieldsInError(group) {
        let fieldInError = [];
        for (const [name, control] of Object.entries(group.controls)) {
            if (control instanceof UntypedFormControl || control instanceof UntypedFormArray) {
                // Specific test for confirm password, validation is at parent level
                if (control.invalid || (name === 'confirmPassword' && control.parent.errors?.allEqualInGroupValidator)) {
                    const label = TRANSLATIONS[name] || name;
                    fieldInError.push(label);
                }
            }
            else {
                fieldInError = fieldInError.concat(this.getFieldsInError(control));
            }
        }
        return fieldInError;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormErrorService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormErrorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: FormErrorService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.Store }] });

class LoginConfigService {
    constructor() {
        this.loginConfig = new BehaviorSubject(undefined);
    }
    /**
     * Get configuration of the login module.
     */
    getConfig() {
        return this.loginConfig.asObservable();
    }
    /**
     * Set config of the login module.
     */
    setConfig(config) {
        this.loginConfig.next(config);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginConfigService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginConfigService, decorators: [{
            type: Injectable
        }] });

const LOGIN_FEATURE = 'loginReducer';
var HTTP_STATUS;
(function (HTTP_STATUS) {
    HTTP_STATUS[HTTP_STATUS["init"] = 0] = "init";
    HTTP_STATUS[HTTP_STATUS["waiting"] = 1] = "waiting";
    HTTP_STATUS[HTTP_STATUS["success"] = 2] = "success";
    HTTP_STATUS[HTTP_STATUS["error"] = 3] = "error";
})(HTTP_STATUS || (HTTP_STATUS = {}));
var LoginUiState;
(function (LoginUiState) {
    LoginUiState[LoginUiState["form"] = 0] = "form";
    LoginUiState[LoginUiState["formOtp"] = 1] = "formOtp";
    LoginUiState[LoginUiState["forgetPwd"] = 2] = "forgetPwd";
    LoginUiState[LoginUiState["formDdna"] = 3] = "formDdna";
    LoginUiState[LoginUiState["expiredPwd"] = 4] = "expiredPwd";
    LoginUiState[LoginUiState["validatePwd"] = 5] = "validatePwd";
    LoginUiState[LoginUiState["sso"] = 6] = "sso";
    LoginUiState[LoginUiState["formPhone"] = 7] = "formPhone";
    LoginUiState[LoginUiState["formCode"] = 8] = "formCode";
    LoginUiState[LoginUiState["jumpLogin"] = 9] = "jumpLogin";
    LoginUiState[LoginUiState["officeList"] = 10] = "officeList";
    LoginUiState[LoginUiState["mfaSelfSelection"] = 11] = "mfaSelfSelection";
    LoginUiState[LoginUiState["formTotp"] = 12] = "formTotp";
    LoginUiState[LoginUiState["authenticatorApp"] = 13] = "authenticatorApp";
    LoginUiState[LoginUiState["authenticatorQrCode"] = 14] = "authenticatorQrCode";
    LoginUiState[LoginUiState["authenticatorValidationCode"] = 15] = "authenticatorValidationCode";
})(LoginUiState || (LoginUiState = {}));
var JumpLoginState;
(function (JumpLoginState) {
    JumpLoginState[JumpLoginState["otpNeededJump"] = 0] = "otpNeededJump";
    JumpLoginState[JumpLoginState["ottNeededJump"] = 1] = "ottNeededJump";
})(JumpLoginState || (JumpLoginState = {}));
var ForgetPwdState;
(function (ForgetPwdState) {
    ForgetPwdState[ForgetPwdState["initForget"] = 0] = "initForget";
    ForgetPwdState[ForgetPwdState["resetCompleted"] = 1] = "resetCompleted";
    ForgetPwdState[ForgetPwdState["initValid"] = 2] = "initValid";
    ForgetPwdState[ForgetPwdState["validCompleted"] = 3] = "validCompleted";
})(ForgetPwdState || (ForgetPwdState = {}));
const initialState = {
    status: HTTP_STATUS.init,
    errors: undefined,
    uiState: LoginUiState.form,
    ddnaDevices: [],
    mfaAvailable: [],
    userSignedIn: false,
    loginInformation: {},
    ssoStatus: false,
    isClpReady: false,
    registrationLink: ''
};
const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_ACTION.IDENTIFY_REQUEST:
            const loginInfo = action.payload;
            return {
                ...state,
                status: HTTP_STATUS.waiting,
                errors: undefined,
                loginInformation: {
                    username: loginInfo.username,
                    officeId: loginInfo.officeId,
                    dutyCode: loginInfo.dutyCode,
                    rememberMe: loginInfo.rememberMe,
                    useDefaultoffice: loginInfo.useDefaultoffice
                },
                userSignedIn: false
            };
        case LOGIN_ACTION.LOGIN_REQUEST_SSO:
            return {
                ...state,
                status: HTTP_STATUS.waiting,
                errors: undefined,
                userSignedIn: false
            };
        case LOGIN_ACTION.PHONE_NUMBER_REQUEST:
            return {
                ...state,
                status: HTTP_STATUS.waiting,
                errors: undefined,
                ...(action.payload?.countryCodeIndicator && {
                    loginInformation: {
                        ...state.loginInformation,
                        phoneNumber: action.payload.phoneNumber,
                        countryCodeIndicator: action.payload.countryCodeIndicator
                    }
                })
            };
        case LOGIN_ACTION.CHANGED_PASSOWRD_AND_LOGIN_REQUEST:
        case LOGIN_ACTION.RESET_PWD_REQUEST:
        case LOGIN_ACTION.VALIDATE_PWD_REQUEST:
        case LOGIN_ACTION.DDNA_CHECK_START:
        case LOGIN_ACTION.DDNA_CHECK_END:
        case LOGIN_ACTION.DDNA_REQUEST:
        case LOGIN_ACTION.VALIDATION_CODE_REQUEST:
        case LOGIN_ACTION.TOTP_REQUEST:
        case LOGIN_ACTION.OTP_REQUEST:
            return {
                ...state,
                status: HTTP_STATUS.waiting,
                errors: undefined
            };
        case LOGIN_ACTION.AUTHENTICATOR_APP_REQUEST:
            return {
                ...state,
                uiState: LoginUiState.authenticatorApp,
                status: HTTP_STATUS.init,
                registrationLink: action.payload.registrationLink
            };
        case LOGIN_ACTION.AUTHENTICATOR_QRCODE_REQUEST:
            return {
                ...state,
                uiState: LoginUiState.authenticatorQrCode,
                status: HTTP_STATUS.init
            };
        case LOGIN_ACTION.AUTHENTICATOR_VALIDATION_CODE_REQUEST:
            return {
                ...state,
                uiState: LoginUiState.authenticatorValidationCode,
                status: HTTP_STATUS.init
            };
        case LOGIN_ACTION.ERROR_RECEIVED:
        case CLP_ACTION.ERROR_RECEIVED:
            return {
                ...state,
                status: HTTP_STATUS.error,
                errors: action.payload,
                uiState: state.uiState === LoginUiState.sso ? LoginUiState.form : state.uiState
            };
        case CLP_ACTION.OTP_ERROR_RECEIVED:
            return {
                ...state,
                status: HTTP_STATUS.error,
                errors: action.payload,
                uiState: LoginUiState.formOtp
            };
        case CLP_ACTION.OTP_EMULATE_ERROR_RECEIVED:
            return {
                ...state,
                status: HTTP_STATUS.error,
                errors: action.payload,
                uiState: LoginUiState.jumpLogin
            };
        case CLP_ACTION.PASSWORD_RULES_RECEIVED:
            return {
                ...state,
                status: HTTP_STATUS.success
            };
        case CLP_ACTION.PASSWORD_RULES_ERROR_RECEIVED:
            return {
                ...state,
                status: HTTP_STATUS.error,
                errors: action.payload
            };
        case LOGIN_ACTION.SIGN_IN_END:
            return {
                ...state,
                status: HTTP_STATUS.success,
                userSignedIn: true
            };
        case LOGIN_ACTION.DDNA_NEEDED:
            return {
                ...state,
                status: HTTP_STATUS.init,
                uiState: LoginUiState.formDdna,
                ddnaDevices: action.payload
            };
        case LOGIN_ACTION.RESET_PWD_END:
            return {
                ...state,
                status: HTTP_STATUS.success,
                forgetPwdState: ForgetPwdState.resetCompleted
            };
        case LOGIN_ACTION.VALIDATE_PWD_END:
            return {
                ...state,
                status: HTTP_STATUS.success,
                forgetPwdState: ForgetPwdState.validCompleted,
                uiState: LoginUiState.form
            };
        case LOGIN_ACTION.UPDATE_LOGIN_STORAGE:
            const loginStorage = action.payload;
            if (loginStorage && loginStorage.username) {
                return {
                    ...state,
                    loginInformation: {
                        username: loginStorage.username,
                        officeId: loginStorage.officeId,
                        dutyCode: loginStorage.dutyCode,
                        rememberMe: loginStorage.rememberMe !== undefined ? loginStorage.rememberMe : true
                    }
                };
            }
            return state;
        case LOGIN_ACTION.OTP_NEEDED:
            return {
                ...state,
                uiState: LoginUiState.formOtp,
                status: HTTP_STATUS.init
            };
        case LOGIN_ACTION.PHONE_NUMBER_NEEDED:
            return {
                ...state,
                uiState: LoginUiState.formPhone,
                status: HTTP_STATUS.init
            };
        case LOGIN_ACTION.VALIDATION_CODE_NEEDED:
            return {
                ...state,
                uiState: LoginUiState.formCode,
                status: HTTP_STATUS.init
            };
        case LOGIN_ACTION.EXPIRED_PASSWORD:
            return {
                ...state,
                uiState: LoginUiState.expiredPwd,
                status: HTTP_STATUS.init
            };
        case CLP_ACTION.CLP_INIT:
        case CLP_ACTION.PASSWORD_RULES_REQUEST:
            return {
                ...state,
                status: HTTP_STATUS.waiting
            };
        case CLP_ACTION.CLP_INITIALIZED:
            return {
                ...state,
                status: HTTP_STATUS.init,
                ssoStatus: action.payload.isSSO,
                uiState: action.payload.isSSO ? LoginUiState.sso : state.uiState,
                isClpReady: true
            };
        case LOGIN_ACTION.CLOSE_FORCE_SIGN_IN:
            return {
                ...state,
                status: HTTP_STATUS.init,
                ...(action.payload?.reset && { uiState: LoginUiState.form })
            };
        case LOGIN_ACTION.CANCEL_LOGIN_ACTION:
            return {
                ...state,
                status: HTTP_STATUS.init
            };
        case LOGIN_ACTION.CHANGE_ACCOUNT:
            return {
                ...initialState,
                isClpReady: state.isClpReady
            };
        case LOGIN_ACTION.INIT_FORGET_PWD_FLOW:
            return {
                ...state,
                uiState: LoginUiState.forgetPwd,
                forgetPwdState: ForgetPwdState.initForget,
                loginInformation: action.payload
            };
        case LOGIN_ACTION.INIT_VALIDATE_PWD_FLOW:
            return {
                ...state,
                uiState: LoginUiState.validatePwd,
                forgetPwdState: ForgetPwdState.initValid
            };
        case LOGIN_ACTION.INIT_JUMP_LOGIN_FLOW:
            return {
                ...state,
                status: HTTP_STATUS.init,
                uiState: LoginUiState.jumpLogin
            };
        case LOGIN_ACTION.JUMP_LOGIN_OTP_NEEDED:
            return {
                ...state,
                uiState: LoginUiState.jumpLogin,
                status: HTTP_STATUS.init,
                jumpLoginState: JumpLoginState.otpNeededJump
            };
        case LOGIN_ACTION.JUMP_LOGIN_OTT_NEEDED:
            return {
                ...state,
                uiState: LoginUiState.jumpLogin,
                status: HTTP_STATUS.init,
                jumpLoginState: JumpLoginState.ottNeededJump
            };
        case LOGIN_ACTION.LOGIN_OFFICE_LIST:
            return {
                ...state,
                status: HTTP_STATUS.init,
                uiState: LoginUiState.officeList,
                officeList: action.payload
            };
        case LOGIN_ACTION.MFA_SELF_SELECTION:
            return {
                ...state,
                status: HTTP_STATUS.init,
                uiState: LoginUiState.mfaSelfSelection,
                mfaAvailable: action.payload
            };
        case LOGIN_ACTION.SELECTED_MFA:
            return {
                ...state,
                loginInformation: { ...state.loginInformation, selectedMFA: action.payload }
            };
        case LOGIN_ACTION.TOTP_NEEDED:
            return {
                ...state,
                uiState: LoginUiState.formTotp,
                status: HTTP_STATUS.init
            };
        default:
            return state;
    }
};
const getLoginState = createFeatureSelector(LOGIN_FEATURE);
const getLoginInformation = createSelector(getLoginState, (state) => state.loginInformation);
const getLoginUiState = createSelector(getLoginState, (state) => state.uiState);
const getJumpLoginUiState = createSelector(getLoginState, (state) => state.jumpLoginState);
const getForgetPwdState = createSelector(getLoginState, (state) => state.forgetPwdState);
const getUserSignedIn = createSelector(getLoginState, (state) => state.userSignedIn);
const getLoginStateStatus = createSelector(getLoginState, (state) => state.status);
const getErrors = createSelector(getLoginState, (state) => state.errors);
const getSSOStatus = createSelector(getLoginState, (state) => state.ssoStatus);
const getIsClpReady = createSelector(getLoginState, (state) => state.isClpReady);
const getDdnaDevices = createSelector(getLoginState, (state) => state.ddnaDevices);
const getOfficeList = createSelector(getLoginState, (state) => state.officeList);
const getMfaAvailable = createSelector(getLoginState, (state) => state.mfaAvailable);
const getRegistrationLink = createSelector(getLoginState, (state) => state.registrationLink);

class LoginActionsService {
    constructor(store, clpService, localStorageService, analytics, loginConfigService) {
        this.store = store;
        this.clpService = clpService;
        this.localStorageService = localStorageService;
        this.analytics = analytics;
        this.loginConfigService = loginConfigService;
        this.ssoPerformed = false;
        this.LOGIN_INFO_KEY = 'login';
        this.OLD_LOGIN_INFO_KEY = { officeId: 'officeId', username: 'userAlias', rememberMe: 'rememberMe' };
        this.otpOnGoing = false;
        this.totpOnGoing = false;
        this.silentDDNAEnabled = false;
        this.mfaSelfRegistrationActivated = false;
        this.subscription = new Subscription();
        this.subscription.add(this.store.select(getLoginInformation).subscribe((newLoginInformation) => {
            this.username = newLoginInformation.username;
            this.selectedMFA = newLoginInformation.selectedMFA;
        }));
        this.subscription.add(this.loginConfigService
            .getConfig()
            .pipe(filter((config) => !!config), mergeMap((config) => config.clpConfig))
            .subscribe((config) => {
            this.silentDDNAEnabled = config.loginParameters.silentDDNAEnabled ?? false;
            this.mfaSelfRegistrationActivated = config.loginParameters.mfaSelfRegistrationActivated ?? false;
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * Login action.
     * @param loginInformation
     */
    login(loginInformation, onMonosignError) {
        this.store.dispatch(new IdentifyRequest(loginInformation));
        this.clpService.setClpConfig({
            username: loginInformation.username,
            password: loginInformation.password,
            officeId: loginInformation.officeId,
            dutyCode: loginInformation.dutyCode,
            useDefaultoffice: loginInformation.useDefaultoffice,
            otp: '',
            phoneNumber: '',
            phoneValidationCode: '',
            timeBasedOtp: '',
            selectedMFAId: '',
            onClpSuccess: this.onClpLoginSuccess.bind(this),
            onOneTimePasswordRequest: this.onOneTimePasswordRequest.bind(this, loginInformation.username),
            onPhoneRegistrationRequest: this.onPhoneRegistrationRequest.bind(this),
            onPhoneValidationCodeRequest: this.onPhoneValidationCodeRequest.bind(this, loginInformation.phoneNumber),
            onPasswordRequest: this.onPasswordRequest.bind(this),
            onDdnaCheckStart: this.onDdnaCheckStart.bind(this),
            onDdnaCheckEnd: this.onDdnaCheckEnd.bind(this),
            onDdnaRegistrationRequest: this.onDdnaRegistrationRequest.bind(this),
            onMonosignError,
            onPasswordChangeRequest: this.onPasswordChangeRequest.bind(this),
            onOfficeList: this.onOfficeList.bind(this),
            ...(this.mfaSelfRegistrationActivated && {
                onSelectMFARequest: this.onSelectMFARequest.bind(this),
                onTimeBasedOtpRequest: this.onTimeBasedOtpRequest.bind(this),
                onTimeBasedOtpRegistrationRequest: this.onTimeBasedOtpRegistrationRequest.bind(this)
            })
        }, ClpApi.LOGIN);
        this.clpService.identify(false);
    }
    /**
     * Return Tokens (accessToken, idToken)
     */
    getTokens() {
        return this.tokensConfig;
    }
    /**
     * Delete tokens from the service for security reasons
     * Used for impersonate flow
     */
    resetTokens() {
        this.tokensConfig = undefined;
    }
    /**
     * Init Jump Login flow.
     */
    initJumpLoginFlow(accessToken, idToken) {
        this.tokensConfig = { accessToken, idToken };
        const payload = $localize `:@@login.jumpLogin.explanation:Please now enter remote user details to log in`;
        this.store.dispatch(new InitJumpLoginFlow(payload));
    }
    /**
     * Jump Login.
     * @param loginInformation
     * @param tokens
     */
    jumpLoginRequest(username, loginInformation, tokens) {
        this.store.dispatch(new JumpLoginRequest(loginInformation));
        this.clpService.setClpConfig({
            username: loginInformation.username,
            officeId: loginInformation.officeId,
            otp: loginInformation.otp,
            ott: loginInformation.ott,
            onClpSuccess: this.onClpImpersonateSuccess.bind(this),
            onOneTimePasswordRequest: this.onImpersonateOTPRequest.bind(this, username),
            onImpersonateTokenRequest: this.onImpersonateTokenRequest.bind(this, username)
        }, ClpApi.JUMP_LOGIN);
        this.analytics.track({
            action: 'login.jumpLogin',
            action_value: JSON.stringify({ officeId: loginInformation.officeId })
        });
        this.clpService.jumpLogin(loginInformation.username, loginInformation.officeId, tokens.accessToken, tokens.idToken);
    }
    /**
     * Login via SSO action.
     */
    loginViaSSO() {
        // ensure this is only performed once
        if (!this.ssoPerformed) {
            this.store.dispatch(new LoginRequestSSO());
            this.ssoPerformed = true;
            this.clpService.setClpConfig({
                username: '',
                password: '',
                officeId: '',
                otp: '',
                phoneNumber: '',
                phoneValidationCode: '',
                onClpSuccess: this.onClpLoginSuccess.bind(this),
                onOneTimePasswordRequest: this.onOneTimePasswordRequest.bind(this),
                onPhoneRegistrationRequest: this.onPhoneRegistrationRequest.bind(this),
                onPhoneValidationCodeRequest: this.onPhoneValidationCodeRequest.bind(this),
                onPasswordRequest: this.onPasswordRequest.bind(this),
                onDdnaCheckStart: this.onDdnaCheckStart.bind(this),
                onDdnaCheckEnd: this.onDdnaCheckEnd.bind(this),
                onDdnaRegistrationRequest: this.onDdnaRegistrationRequest.bind(this),
                onMonosignError: () => { },
                onPasswordChangeRequest: this.onPasswordChangeRequest.bind(this)
            }, ClpApi.LOGIN);
            this.clpService.identify(true);
        }
    }
    /**
     * Login with Otp.
     * @param loginInformation
     */
    loginWithOtp(loginInformation, isSelectedMFAFlow = false) {
        this.store.dispatch(new OtpRequest());
        this.clpService.loginWithOtp(loginInformation.otp, loginInformation.password, isSelectedMFAFlow);
        this.analytics.track({
            action: 'login.submitOTP',
            action_value: JSON.stringify({ officeId: loginInformation.officeId })
        });
    }
    /**
     * Login with Totp.
     * @param loginInformation
     */
    loginWithTotp(loginInformation) {
        this.store.dispatch(new TotpRequest());
        this.clpService.loginWithTotp(loginInformation.totp, loginInformation.password);
        this.analytics.track({
            action: 'login.submitTOTP',
            action_value: JSON.stringify({ officeId: loginInformation.officeId })
        });
    }
    /**
     * register phone number.
     * @param loginInformation
     */
    registerPhoneNumber(loginInformation) {
        let fullPhoneNumber = loginInformation.phoneNumber ?? '';
        if (this.mfaSelfRegistrationActivated) {
            this.store.dispatch(new PhoneNumberRequest({
                phoneNumber: loginInformation.phoneNumber,
                countryCodeIndicator: loginInformation.countryCodeIndicator
            }));
            fullPhoneNumber = `${loginInformation.countryCodeIndicator}${loginInformation.phoneNumber}`;
        }
        else {
            this.store.dispatch(new PhoneNumberRequest());
        }
        this.clpService.registerPhoneNumber(fullPhoneNumber);
    }
    /**
     * login with phone validation code
     * @param loginInformation
     */
    loginWithPhoneValidationCode(loginInformation) {
        this.store.dispatch(new ValidationCodeRequest());
        this.clpService.loginWithPhoneValidationCode(loginInformation.validationCode, loginInformation.password);
        this.analytics.track({
            action: 'login.phoneCallRegistration',
            action_value: JSON.stringify({ officeId: loginInformation.officeId })
        });
    }
    /**
     * login with authenticator app
     */
    registrationWithTotpAuthenticatorCode(loginInformation) {
        this.clpService.registrationTotpWithAuthenticatorCode(loginInformation.validationCode);
        this.analytics.track({
            action: 'login.totpRegistration',
            action_value: JSON.stringify({ officeId: loginInformation.officeId })
        });
    }
    /**
     * Reset password.
     * @param loginInformation
     */
    resetPassword(loginInformation) {
        this.store.dispatch(new ResetPasswordRequest());
        // We need to reset callbacks and setters in case of user re-enter a new opt or password
        this.clpService.setClpConfig({
            username: loginInformation.username,
            officeId: loginInformation.officeId,
            newPassword: loginInformation.newPassword,
            confirmPassword: loginInformation.confirmPassword,
            onClpSuccess: this.onClpResetPwdSuccess.bind(this)
        }, ClpApi.RESET_PASSWORD);
        this.analytics.track({
            action: 'login.resetPwdButton',
            action_value: JSON.stringify({ officeId: loginInformation.officeId })
        });
        this.clpService.resetPassword();
    }
    /**
     * Login and change the password.
     * @param loginInformation
     */
    loginAndChangePassword(loginInformation) {
        this.store.dispatch(new ChangePasswordAndLoginRequest());
        this.clpService.loginAndChangePassword(loginInformation.newPassword, loginInformation.confirmPassword);
    }
    /**
     * Update login information in Local Storage.
     * @param info
     */
    updateLoginStorage(info) {
        this.store.dispatch(new UpdateLoginStorage(info));
    }
    /**
     * Read login info stored in Local Storage.
     */
    readLoginInfo() {
        let loginInfo = this.localStorageService.getItem(this.LOGIN_INFO_KEY);
        // If no login info stored we try to get stored info from old login page
        if (!loginInfo) {
            const username = localStorage.getItem(this.OLD_LOGIN_INFO_KEY.username);
            const officeId = localStorage.getItem(this.OLD_LOGIN_INFO_KEY.officeId);
            const rememberMe = localStorage.getItem(this.OLD_LOGIN_INFO_KEY.rememberMe);
            if (username && officeId) {
                loginInfo = { username, officeId, rememberMe, dutyCode: '' };
            }
        }
        return loginInfo;
    }
    /**
     * Set login info in Local Storage.
     * @param data
     */
    setLoginInfo(data) {
        this.localStorageService.setItem(this.LOGIN_INFO_KEY, data);
    }
    /**
     * Remove login info from Local Storage.
     */
    removeLoginInfo() {
        this.localStorageService.removeItem(this.LOGIN_INFO_KEY);
    }
    /**
     * Change account.
     */
    changeAccount() {
        this.otpOnGoing = false;
        this.totpOnGoing = false;
        this.store.dispatch(new ChangeAccount());
        this.updateLoginStorage(this.readLoginInfo());
    }
    /**
     * Init forget password flow.
     */
    initForgetPwdFlow(loginInfo) {
        const subtitle = '';
        this.store.dispatch(new InitForgetPwdFlow(loginInfo, subtitle));
    }
    /**
     * Init Validate password flow.
     */
    initValidatePwdFlow() {
        this.store.dispatch(new InitValidatePwdFlow());
    }
    /**
     * Validate password.
     * @param loginInformation
     */
    validatePassword(loginInformation) {
        this.store.dispatch(new ValidatePasswordRequest());
        this.clpService.validatePassword(loginInformation.newPassword, this.onClpValidatePwdSuccess.bind(this));
    }
    /**
     * @param label
     * @param deviceIds
     */
    ddnaRegister(label, deviceIds) {
        this.store.dispatch(new DdnaRequest());
        this.analytics.track({
            action: 'login.ddnaRegistration'
        });
        this.clpService.ddnaRegister(label, deviceIds);
        this.localStorageService.removeItem(DDNA_DOWNLOADED);
    }
    /**
     * Close forceSignIn modal and reset http status
     */
    closeForceSignIn(reset = false) {
        this.store.dispatch(new CloseForceSignIn({ reset }));
    }
    /**
     * onPasswordRequest  (after identify)
     * @private
     */
    loginWithOfficeId(loginInformation) {
        this.clpService.loginWithOfficeId(loginInformation.officeId);
        this.store.dispatch(new IdentifyRequest(loginInformation));
    }
    /**
     * Check the MFA type and dispatch the corresponding action to redirect to the correct page
     * @param mfa
     */
    setSelectedMFA(mfa) {
        const mfaProbeListLabel = {
            [MFA_ID.OTP_SMS]: 'SMS',
            [MFA_ID.OTP_VOICE_CALL]: 'Voice call',
            [MFA_ID.TOTP]: 'TOTP',
            [MFA_ID.DDNA]: 'DDNA'
        };
        this.analytics.track({
            action: 'login.selfselectMFAmethod',
            action_value: JSON.stringify({
                MFAmethod: mfaProbeListLabel[mfa.id]
            })
        });
        this.store.dispatch(new SelectedMFA(mfa));
        this.clpService.setSelectedMFA(mfa);
    }
    /**
     * Start DDNA check (enable loader)
     * @private
     */
    onDdnaCheckStart() {
        this.store.dispatch(new DdnaCheckStart());
    }
    /**
     * End DDNA check
     * @private
     */
    onDdnaCheckEnd() {
        this.store.dispatch(new DdnaCheckEnd());
        this.clpService.authenticate();
    }
    /**
     * Self selection of MFA method
     * @private
     */
    onSelectMFARequest(mfa) {
        this.store.dispatch(new MfaSelfSelection(mfa));
    }
    /**
     * DDNA need to be registered
     * @param devices
     * @private
     */
    onDdnaRegistrationRequest(devices) {
        if (this.silentDDNAEnabled) {
            this.ddnaRegister(this.setNewDdnaLabel(devices), devices.map((device) => device.id));
        }
        else {
            this.store.dispatch(new DdnaNeeded(devices));
        }
    }
    setNewDdnaLabel(devices) {
        let deviceLabel = `${this.username}_`;
        devices.forEach((device) => {
            deviceLabel += `${device.type}_${device.description.slice(0, 10)}_`;
        });
        deviceLabel += new Date().getTime();
        return deviceLabel;
    }
    /**
     * On Clp login success.
     * @param accessToken
     * @param idToken
     */
    onClpLoginSuccess(accessToken, idToken) {
        if (this.imperSonateMode()) {
            this.initJumpLoginFlow(accessToken, idToken);
        }
        else {
            this.store.dispatch(new SignInEnd({
                accessToken,
                idToken,
                nonce: this.clpService.getClpInitConfig().nonce
            }));
        }
    }
    /**
     * On Clp impersonate success.
     * @param accessToken
     * @param idToken
     */
    onClpImpersonateSuccess(accessToken, idToken) {
        this.store.dispatch(new SignInEnd({
            accessToken,
            idToken,
            nonce: this.clpService.getClpInitConfig().nonce
        }));
        this.resetTokens();
    }
    imperSonateMode() {
        return new RegExp('[?&]HELPDESK', 'i').exec(window.location.href.toUpperCase()) !== null;
    }
    /**
     * On Clp reset password success.
     * @param accessToken
     * @param idToken
     */
    onClpResetPwdSuccess() {
        this.store.dispatch(new ResetPasswordEnd());
    }
    /**
     * On Clp validate password success.
     * @param accessToken
     * @param idToken
     */
    onClpValidatePwdSuccess() {
        this.store.dispatch(new ValidatePasswordEnd());
    }
    /**
     * On otp requested.
     */
    onOneTimePasswordRequest(username = null) {
        this.otpOnGoing = true;
        const message = $localize `:@@login.otp.explanation:To verify your credentials, a one-time password will be sent for this user.
    Enter the one-time password to sign in. If you don’t receive it, check your credentials or contact your administrator.`;
        this.store.dispatch(new OtpNeeded(message));
    }
    /**
     * On totp requested.
     */
    onTimeBasedOtpRequest() {
        this.totpOnGoing = true;
        const message = $localize `:@@login.totp.explanation:To verify your credentials, a time based one-time password will be sent for this
    user. Enter the time based one-time password to sign in. If you don’t receive it, check your credentials or contact your
    administrator.`;
        this.store.dispatch(new TotpNeeded(message));
    }
    /**
     * On phone number requested.
     */
    onPhoneRegistrationRequest() {
        const message = $localize `:@@login.mobileNumber.explanation:Enter your mobile number to continue.
    A verification code will be sent to your phone`;
        this.store.dispatch(new PhoneNumberNeeded(this.mfaSelfRegistrationActivated
            ? { message, selectedMFA: this.selectedMFA, mfaSelfRegistrationActivated: this.mfaSelfRegistrationActivated }
            : message));
    }
    /**
     * On phone validation code requested.
     */
    onPhoneValidationCodeRequest(phoneNumber) {
        const message = $localize `:@@login.validationCode.explanation:Enter the verification code sent to <strong>"${phoneNumber}"</strong>.
    For your security, our sign-in process requires additional verification.`;
        this.store.dispatch(new ValidationCodeNeeded(this.mfaSelfRegistrationActivated
            ? {
                message,
                selectedMFA: this.selectedMFA,
                mfaSelfRegistrationActivated: this.mfaSelfRegistrationActivated
            }
            : message));
    }
    /**
     * On TOTP registration request
     */
    onTimeBasedOtpRegistrationRequest(registrationLink) {
        this.store.dispatch(new AuthenticatorAppRequest({
            registrationLink
        }));
    }
    /* On impersonate otp requested.
     */
    onImpersonateOTPRequest(username) {
        const message = $localize `:@@login.otp.explanation:To verify your credentials, a one-time password will be sent for this user.
    Enter the one-time password to sign in. If you don’t receive it, check your credentials or contact your administrator.`;
        this.store.dispatch(new OtpNeededImpersonate(message));
    }
    /* On impersonate ott requested.
     */
    onImpersonateTokenRequest(username) {
        const message = $localize `:@@login.ott.explanation:To verify your credentials, a one-time token will be sent for this user.
    Enter the one-time token to sign in. If you don’t receive it, check your credentials or contact your administrator.`;
        this.store.dispatch(new OttNeededImpersonate(message));
    }
    /**
     * onPasswordRequest  (after identify)
     * @private
     */
    onPasswordRequest() {
        if (this.otpOnGoing) {
            this.otpOnGoing = false;
            return;
        }
        else if (this.totpOnGoing) {
            this.totpOnGoing = false;
            return;
        }
        this.store.dispatch(new AuthenticateRequest());
        this.clpService.authenticate();
    }
    /**
     * On Password change requested.
     */
    onPasswordChangeRequest() {
        const subtitle = '';
        this.store.dispatch(new ExpiredPassword(subtitle));
    }
    onOfficeList(list) {
        this.store.dispatch(new OfficeList(list));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginActionsService, deps: [{ token: i1.Store }, { token: ClpService }, { token: i3.LocalStorageService }, { token: i3.AnalyticsService }, { token: LoginConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginActionsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginActionsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.Store }, { type: ClpService }, { type: i3.LocalStorageService }, { type: i3.AnalyticsService }, { type: LoginConfigService }] });

const OFFICE_ID_REGEXP = '^[A-Za-z]{3}[A-Za-z\\d]{2}\\d[A-Za-z\\d]{3}$';
const DUTY_CODE_REGEXP = '^[A-Za-z]{2}$';
const USERNAME_REGEXP = "^[A-Za-z0-9. !#$&\\+\\-/=\\?\\^_'\\(\\)@[\\]]{0,99}$";

class RequestStatusService {
    constructor() {
        this.store = inject(Store);
        this.loginConfigService = inject(LoginConfigService);
        this.isRequestOnGoing$ = combineLatest([
            this.store.select(getLoginStateStatus),
            this.loginConfigService
                .getConfig()
                .pipe(switchMap((config) => (config?.signInStatus ? config.signInStatus : of(undefined))))
        ]).pipe(map(([httpStatus, signInStatus]) => httpStatus === HTTP_STATUS.waiting || (signInStatus ? signInStatus === HTTP_STATUS.waiting : false)));
        this.isClpReady$ = this.store.select(getIsClpReady);
        this.hasLoginErrors$ = this.store.select(getErrors).pipe(map((error) => !!error));
    }
}

class ActionButtonsComponent {
    constructor() {
        this.leftButton = input({ label: 'Cancel', fn: () => { } });
        this.rightButton = input({ label: 'Sign in', fn: () => { } });
        this.subscription = new Subscription();
        this.requestStatusService = inject(RequestStatusService);
        this.cdr = inject(ChangeDetectorRef);
        this.isClpReady = false;
        this.isRequestOnGoing = false;
        this.subscription.add(this.requestStatusService.isClpReady$.subscribe((isClpReady) => {
            this.isClpReady = isClpReady;
            this.cdr.markForCheck();
        }));
        this.subscription.add(this.requestStatusService.isRequestOnGoing$.subscribe((isRequestOnGoing) => {
            this.isRequestOnGoing = isRequestOnGoing;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    rightButtonClick() {
        if (!this.isRequestOnGoing) {
            this.rightButton().fn();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ActionButtonsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: ActionButtonsComponent, isStandalone: true, selector: "ama-ng-action-buttons", inputs: { leftButton: { classPropertyName: "leftButton", publicName: "leftButton", isSignal: true, isRequired: false, transformFunction: null }, rightButton: { classPropertyName: "rightButton", publicName: "rightButton", isSignal: true, isRequired: false, transformFunction: null } }, providers: [RequestStatusService], ngImport: i0, template: "<div class=\"mt-3 mb-5 btn-group w-100\">\n  <button\n    type=\"button\"\n    class=\"btn btn-outline-primary rounded me-5 col-6\"\n    (click)=\"leftButton().fn()\"\n    [attr.data-testid]=\"leftButton()['data-testid']\"\n    >{{ leftButton().label }}</button\n  >\n  <button\n    type=\"submit\"\n    [disabled]=\"!isClpReady\"\n    class=\"btn btn-primary rounded col-6\"\n    (click)=\"rightButtonClick()\"\n    [attr.data-testid]=\"rightButton()['data-testid']\"\n  >\n    @if (!isClpReady || isRequestOnGoing) {\n      <ng-container>\n        <span class=\"df-spinner-border-dark spinner-border-sm text-light ms-3\" role=\"status\" aria-hidden=\"true\"></span>\n        <span class=\"visually-hidden\" i18n=\"@@login.request.ongoing\">Loading...</span>\n      </ng-container>\n    } @else {\n      {{ rightButton().label }}\n    }\n  </button>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ActionButtonsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-action-buttons', standalone: true, imports: [CommonModule], providers: [RequestStatusService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mt-3 mb-5 btn-group w-100\">\n  <button\n    type=\"button\"\n    class=\"btn btn-outline-primary rounded me-5 col-6\"\n    (click)=\"leftButton().fn()\"\n    [attr.data-testid]=\"leftButton()['data-testid']\"\n    >{{ leftButton().label }}</button\n  >\n  <button\n    type=\"submit\"\n    [disabled]=\"!isClpReady\"\n    class=\"btn btn-primary rounded col-6\"\n    (click)=\"rightButtonClick()\"\n    [attr.data-testid]=\"rightButton()['data-testid']\"\n  >\n    @if (!isClpReady || isRequestOnGoing) {\n      <ng-container>\n        <span class=\"df-spinner-border-dark spinner-border-sm text-light ms-3\" role=\"status\" aria-hidden=\"true\"></span>\n        <span class=\"visually-hidden\" i18n=\"@@login.request.ongoing\">Loading...</span>\n      </ng-container>\n    } @else {\n      {{ rightButton().label }}\n    }\n  </button>\n</div>\n" }]
        }], ctorParameters: () => [] });

class AuthenticatorViewComponent {
    constructor(store, loginActions) {
        this.store = store;
        this.loginActions = loginActions;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onCancel.bind(this),
            'data-testid': 'cancel-button'
        };
        this.rightButton = {
            label: $localize `:@@login.next:Next`,
            fn: this.onNext.bind(this),
            'data-testid': 'next-button'
        };
    }
    onNext() {
        this.store.dispatch(new AuthenticatorQrCodeRequest());
    }
    onCancel() {
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AuthenticatorViewComponent, deps: [{ token: i1.Store }, { token: LoginActionsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AuthenticatorViewComponent, isStandalone: true, selector: "ama-ng-authenticator-view", ngImport: i0, template: "<div class=\"mb-5\" i18n=\"@@login.authenticator.description.initialSetup\">\n  Already have one installed? Use your existing authenticator.\n</div>\n\n<div class=\"mb-5\" i18n=\"@@login.authenticator.key\">\n  Don't have an authenticator? Use Google Authenticator, Microsoft Authenticator or 2FAS.\n</div>\n\n<div class=\"mb-5\">\n  <ul>\n    <li i18n=\"@@login.authenticator.mobile\"><b>For mobile:</b> Download app from Google Play Store or App Store</li>\n    <li i18n=\"@@login.authenticator.desktop\"><b>For desktop:</b> Download browser extension</li>\n  </ul>\n</div>\n\n<ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AuthenticatorViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-authenticator-view', imports: [CommonModule, ActionButtonsComponent], standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-5\" i18n=\"@@login.authenticator.description.initialSetup\">\n  Already have one installed? Use your existing authenticator.\n</div>\n\n<div class=\"mb-5\" i18n=\"@@login.authenticator.key\">\n  Don't have an authenticator? Use Google Authenticator, Microsoft Authenticator or 2FAS.\n</div>\n\n<div class=\"mb-5\">\n  <ul>\n    <li i18n=\"@@login.authenticator.mobile\"><b>For mobile:</b> Download app from Google Play Store or App Store</li>\n    <li i18n=\"@@login.authenticator.desktop\"><b>For desktop:</b> Download browser extension</li>\n  </ul>\n</div>\n\n<ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n" }]
        }], ctorParameters: () => [{ type: i1.Store }, { type: LoginActionsService }] });

class AuthenticatorQrCodeComponent {
    constructor(store, loginActions) {
        this.store = store;
        this.loginActions = loginActions;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onCancel.bind(this),
            'data-testid': 'cancel-button'
        };
        this.rightButton = {
            label: $localize `:@@login.next:Next`,
            fn: this.onNext.bind(this),
            'data-testid': 'next-button'
        };
        this.qrCodeAltLabel = $localize `:@@login.authenticator.qrCodeAlt:QR code that links to authenticator app`;
        this.qrCodeSubject = new BehaviorSubject(null);
        this.qrCodeDataUrl$ = this.qrCodeSubject.asObservable();
        this.registrationLink$ = this.store.pipe(select(getRegistrationLink));
    }
    ngOnInit() {
        this.registrationLink$
            .pipe(filter$1((link) => !!link), first())
            .subscribe(async (registrationLink) => {
            await this.generateQRCode(registrationLink);
            this.secretParam = this.retrieveSecretParam(registrationLink);
        });
    }
    onCancel() {
        this.loginActions.changeAccount();
    }
    onNext() {
        this.store.dispatch(new AuthenticatorValidationCodeRequest());
    }
    async generateQRCode(text) {
        await toDataURL(text)
            .then((url) => {
            this.qrCodeSubject.next(url);
        })
            .catch((_err) => {
            this.qrCodeSubject.next(null);
        });
    }
    retrieveSecretParam(registrationLink) {
        const params = new URLSearchParams(registrationLink.split('?')[1]);
        // URL param name on LSS side
        return params.get('secret');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AuthenticatorQrCodeComponent, deps: [{ token: i1.Store }, { token: LoginActionsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: AuthenticatorQrCodeComponent, isStandalone: true, selector: "ama-ng-authenticator-qrcode-view", ngImport: i0, template: "<div class=\"mb-5\" i18n=\"@@login.authenticator.description.qrCodeSetup\">\n  Scan the QR code using the authenticator app, and click on <b>Next</b> button.\n</div>\n\n@if (qrCodeDataUrl$ | async; as qrCodeDataUrl) {\n  <div class=\"mb-5 text-center\">\n    <img [src]=\"qrCodeDataUrl\" [alt]=\"qrCodeAltLabel\" height=\"200\" />\n  </div>\n\n  <div class=\"mb-5\">\n    <div i18n=\"@@login.authenticator.manualCode\">If you can't scan the QR code, enter the following code:</div>\n    <div id=\"manualCode\"\n      ><b>{{ secretParam }}</b></div\n    >\n  </div>\n}\n<ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AuthenticatorQrCodeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-authenticator-qrcode-view', standalone: true, imports: [CommonModule, ActionButtonsComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-5\" i18n=\"@@login.authenticator.description.qrCodeSetup\">\n  Scan the QR code using the authenticator app, and click on <b>Next</b> button.\n</div>\n\n@if (qrCodeDataUrl$ | async; as qrCodeDataUrl) {\n  <div class=\"mb-5 text-center\">\n    <img [src]=\"qrCodeDataUrl\" [alt]=\"qrCodeAltLabel\" height=\"200\" />\n  </div>\n\n  <div class=\"mb-5\">\n    <div i18n=\"@@login.authenticator.manualCode\">If you can't scan the QR code, enter the following code:</div>\n    <div id=\"manualCode\"\n      ><b>{{ secretParam }}</b></div\n    >\n  </div>\n}\n<ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n" }]
        }], ctorParameters: () => [{ type: i1.Store }, { type: LoginActionsService }] });

//TODO: remove with DEZFACT-1691
class OtpCodeViewComponent {
    constructor() {
        this.parentForm = input();
        this.otpForm = input();
        this.errorMessages = {
            required: $localize `:@@login.otp.view.error.required:This field is required`,
            default: $localize `:@@login.otp.view.error.default:Code is invalid`
        };
    }
    ngAfterViewInit() {
        this.pasteEventHandler = (event) => this.handlePaste(event);
        document.getElementById('otpCode')?.addEventListener('paste', this.pasteEventHandler);
    }
    ngOnDestroy() {
        this.pasteEventHandler && document.getElementById('otpCode')?.removeEventListener('paste', this.pasteEventHandler);
    }
    onInput($event, inputNumber) {
        if ($event.inputType === 'deleteContentBackward') {
            return;
        }
        inputNumber++;
        this.focusInput(document.getElementById(`otp-box-${inputNumber}`), $event);
    }
    onKeyDown($event, inputNumber) {
        switch ($event.key) {
            case 'Backspace':
                const currentInput = document.getElementById(`otp-box-${inputNumber}`);
                if (!currentInput?.value) {
                    inputNumber--;
                    // we don't pass event as we don't want to stop the propagation as it permit to delete the previous input value
                    // from the default action of the backspace key
                    this.focusInput(document.getElementById(`otp-box-${inputNumber}`));
                }
                break;
            case 'ArrowLeft':
                inputNumber--;
                this.focusInput(document.getElementById(`otp-box-${inputNumber}`), $event);
                break;
            case 'ArrowRight':
                inputNumber++;
                this.focusInput(document.getElementById(`otp-box-${inputNumber}`), $event);
                break;
        }
    }
    focusInput(input, $event) {
        if (input) {
            input.focus();
            input.setSelectionRange(0, 1);
            $event?.preventDefault();
            $event?.stopPropagation();
        }
    }
    handlePaste(event) {
        event.stopPropagation();
        event.preventDefault();
        const pastedData = event.clipboardData?.getData('Text');
        if (pastedData) {
            const otpBoxNumber = Number(event.target?.id?.split('otp-box-')[1] ?? 0);
            for (let i = 0; i < pastedData.length && otpBoxNumber + i < 6; i++) {
                this.otpForm()?.controls[otpBoxNumber + i].setValue(pastedData[i]);
                this.otpForm()?.controls[otpBoxNumber + i].markAsTouched();
            }
        }
    }
    getOtpBoxAriaLabel(index) {
        return $localize `:@@login.otp.view.input:One-time password input ${index + 1}`;
    }
    shouldDisplayError() {
        const control = this.otpForm()?.controls?.find?.((control) => control.touched && control.errors);
        if (control) {
            this.errorMessage = this.getErrorMessage(control);
            return true;
        }
        return false;
    }
    getErrorMessage(control) {
        const errorKey = control.errors ? Object.keys(control.errors)[0] : 'default';
        return this.isErrorKey(errorKey) ? this.errorMessages[errorKey] : this.errorMessages.default;
    }
    isErrorKey(key) {
        return key in this.errorMessages;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OtpCodeViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: OtpCodeViewComponent, isStandalone: true, selector: "ama-ng-otp-code-view", inputs: { parentForm: { classPropertyName: "parentForm", publicName: "parentForm", isSignal: true, isRequired: false, transformFunction: null }, otpForm: { classPropertyName: "otpForm", publicName: "otpForm", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<div class=\"d-grid justify-content-left\">\n  <div [formGroup]=\"parentForm()\" id=\"otpCode\" class=\"d-flex\">\n    @for (control of otpForm().controls; track control; let index = $index) {\n      <input\n        id=\"otp-box-{{ index }}\"\n        type=\"text\"\n        class=\"form-control me-3 text-center text-uppercase fw-bold otp-box-input\"\n        [formControl]=\"control\"\n        maxlength=\"1\"\n        [attr.aria-label]=\"getOtpBoxAriaLabel(index)\"\n        autocomplete=\"off\"\n        (input)=\"onInput($event, index)\"\n        (keydown)=\"onKeyDown($event, index)\"\n        [ngClass]=\"{ 'is-invalid': control.touched && control.errors }\"\n      />\n    }\n  </div>\n  @if (shouldDisplayError()) {\n    <div class=\"invalid-feedback d-block\">{{ errorMessage }}</div>\n  }\n</div>\n", styles: [".otp-box-input{width:36px;height:36px}\n"], dependencies: [{ kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FormsModule }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OtpCodeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-otp-code-view', changeDetection: ChangeDetectionStrategy.OnPush, imports: [ReactiveFormsModule, FormsModule, CommonModule], standalone: true, template: "<div class=\"d-grid justify-content-left\">\n  <div [formGroup]=\"parentForm()\" id=\"otpCode\" class=\"d-flex\">\n    @for (control of otpForm().controls; track control; let index = $index) {\n      <input\n        id=\"otp-box-{{ index }}\"\n        type=\"text\"\n        class=\"form-control me-3 text-center text-uppercase fw-bold otp-box-input\"\n        [formControl]=\"control\"\n        maxlength=\"1\"\n        [attr.aria-label]=\"getOtpBoxAriaLabel(index)\"\n        autocomplete=\"off\"\n        (input)=\"onInput($event, index)\"\n        (keydown)=\"onKeyDown($event, index)\"\n        [ngClass]=\"{ 'is-invalid': control.touched && control.errors }\"\n      />\n    }\n  </div>\n  @if (shouldDisplayError()) {\n    <div class=\"invalid-feedback d-block\">{{ errorMessage }}</div>\n  }\n</div>\n", styles: [".otp-box-input{width:36px;height:36px}\n"] }]
        }], ctorParameters: () => [] });

class AuthenticatorCodeViewComponent {
    constructor() {
        this.loginInformation = input();
        this.hasLoginError = false;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onCancel.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.verifySignin:Verify and sign in`,
            fn: this.onSubmit.bind(this),
            'data-testid': 'verify-signin'
        };
        this.fb = inject(UntypedFormBuilder);
        this.loginActions = inject(LoginActionsService);
        this.formErrorService = inject(FormErrorService);
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.loginForm && hasLoginError) {
                this.loginForm.patchValue({ password: '' });
                this.loginForm.markAsPristine();
                this.loginForm.get('otp')?.reset();
            }
        }));
        const controls = [];
        for (let i = 0; i < 6; i++) {
            controls.push(this.fb.control('', [Validators.required, Validators.maxLength(1)]));
        }
        this.loginForm = this.fb.group({ otp: this.fb.array(controls) });
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm?.valid) {
            const formValue = this.loginForm.value;
            this.loginActions.registrationWithTotpAuthenticatorCode({
                ...this.loginInformation(),
                validationCode: formValue.otp.join('').toUpperCase()
            });
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm?.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
        }
    }
    onCancel() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AuthenticatorCodeViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.12", type: AuthenticatorCodeViewComponent, isStandalone: true, selector: "ama-ng-authenticator-code-view", inputs: { loginInformation: { classPropertyName: "loginInformation", publicName: "loginInformation", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<form [formGroup]=\"loginForm\">\n  <div class=\"mb-5\" i18n=\"@@login.authenticator.validationCode\">Enter the code received in the authenticator app</div>\n\n  <div class=\"mb-5\">\n    <ama-ng-otp-code-view [parentForm]=\"loginForm\" [otpForm]=\"loginForm.get('otp')\"></ama-ng-otp-code-view>\n  </div>\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: OtpCodeViewComponent, selector: "ama-ng-otp-code-view", inputs: ["parentForm", "otpForm"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AuthenticatorCodeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-authenticator-code-view', standalone: true, imports: [FormsModule, ReactiveFormsModule, OtpCodeViewComponent, ActionButtonsComponent], changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"loginForm\">\n  <div class=\"mb-5\" i18n=\"@@login.authenticator.validationCode\">Enter the code received in the authenticator app</div>\n\n  <div class=\"mb-5\">\n    <ama-ng-otp-code-view [parentForm]=\"loginForm\" [otpForm]=\"loginForm.get('otp')\"></ama-ng-otp-code-view>\n  </div>\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [] });

class ForceSignInPopupComponent {
    constructor() {
        this.loginActionService = inject(LoginActionsService);
        this.resetSignInValue = input(true);
    }
    ngOnDestroy() {
        this.loginActionService.closeForceSignIn(this.resetSignInValue());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ForceSignInPopupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.12", type: ForceSignInPopupComponent, isStandalone: true, selector: "ama-ng-force-sign-in-popup", inputs: { resetSignInValue: { classPropertyName: "resetSignInValue", publicName: "resetSignInValue", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: ` <p i18n="@@login.monosign.explanation"
    ><strong>The username entered is being used in another session:</strong><br />To go back to the 'Sign In' page and
    log in with another username, click on 'Close'.<br />To disconnect the opened session and continue with the log in,
    click on 'Force Sign-In'.</p
  >`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ForceSignInPopupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ama-ng-force-sign-in-popup',
                    standalone: true,
                    imports: [CommonModule],
                    template: ` <p i18n="@@login.monosign.explanation"
    ><strong>The username entered is being used in another session:</strong><br />To go back to the 'Sign In' page and
    log in with another username, click on 'Close'.<br />To disconnect the opened session and continue with the log in,
    click on 'Force Sign-In'.</p
  >`,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }] });

class AdvancedPasswordComponent {
    constructor() {
        this.passwordHidden = true;
        this.capsOn = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AdvancedPasswordComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: AdvancedPasswordComponent, selector: "ama-ng-login-advanced-password", inputs: { parentForm: "parentForm", passwordForm: "passwordForm" }, ngImport: i0, template: "<div [formGroup]=\"parentForm\" class=\"mb-5\">\n  <label for=\"passwordInput\">\n    <ng-container i18n=\"@@login.password.label\">Password</ng-container>\n    <span class=\"mandatory-indicator\">*</span>\n  </label>\n  <div\n    class=\"input-group df-input-append\"\n    [ngClass]=\"{ 'is-invalid': passwordForm.touched && passwordForm.errors, 'is-warning': capsOn }\"\n  >\n    <input\n      [dfInputIcon]=\"['append']\"\n      type=\"{{ passwordHidden ? 'password' : 'text' }}\"\n      class=\"form-control\"\n      id=\"passwordInput\"\n      formControlName=\"password\"\n      autocomplete=\"off\"\n      [ngClass]=\"{ 'is-invalid': passwordForm.touched && passwordForm.errors }\"\n      (capsLock)=\"capsOn = $event\"\n    />\n    <div class=\"input-group-append\">\n      <button\n        type=\"button\"\n        class=\"input-group-text\"\n        [ngClass]=\"{ 'fa-eye-slash': passwordHidden, 'fa-eye': !passwordHidden }\"\n        (click)=\"passwordHidden = !passwordHidden\"\n      >\n        <span class=\"visually-hidden\" *ngIf=\"passwordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n          >Show password</span\n        >\n        <ng-template #hidePassword>\n          <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n        </ng-template>\n      </button>\n    </div>\n  </div>\n  <div class=\"warning-feedback\" *ngIf=\"capsOn\">\n    <span class=\"icon-df-caps-lock\"></span>\n    <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n  </div>\n\n  <div\n    i18n=\"@@login.password.required\"\n    *ngIf=\"passwordForm.touched && passwordForm.errors?.required\"\n    class=\"invalid-feedback\"\n    >Enter a password</div\n  >\n</div>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i5.DfInputIconDirective, selector: "[dfInputIcon]", inputs: ["dfInputIcon"], exportAs: ["dfInputIcon"] }, { kind: "directive", type: CapsLockDirective, selector: "[capsLock]", outputs: ["capsLock"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: AdvancedPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-advanced-password', template: "<div [formGroup]=\"parentForm\" class=\"mb-5\">\n  <label for=\"passwordInput\">\n    <ng-container i18n=\"@@login.password.label\">Password</ng-container>\n    <span class=\"mandatory-indicator\">*</span>\n  </label>\n  <div\n    class=\"input-group df-input-append\"\n    [ngClass]=\"{ 'is-invalid': passwordForm.touched && passwordForm.errors, 'is-warning': capsOn }\"\n  >\n    <input\n      [dfInputIcon]=\"['append']\"\n      type=\"{{ passwordHidden ? 'password' : 'text' }}\"\n      class=\"form-control\"\n      id=\"passwordInput\"\n      formControlName=\"password\"\n      autocomplete=\"off\"\n      [ngClass]=\"{ 'is-invalid': passwordForm.touched && passwordForm.errors }\"\n      (capsLock)=\"capsOn = $event\"\n    />\n    <div class=\"input-group-append\">\n      <button\n        type=\"button\"\n        class=\"input-group-text\"\n        [ngClass]=\"{ 'fa-eye-slash': passwordHidden, 'fa-eye': !passwordHidden }\"\n        (click)=\"passwordHidden = !passwordHidden\"\n      >\n        <span class=\"visually-hidden\" *ngIf=\"passwordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n          >Show password</span\n        >\n        <ng-template #hidePassword>\n          <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n        </ng-template>\n      </button>\n    </div>\n  </div>\n  <div class=\"warning-feedback\" *ngIf=\"capsOn\">\n    <span class=\"icon-df-caps-lock\"></span>\n    <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n  </div>\n\n  <div\n    i18n=\"@@login.password.required\"\n    *ngIf=\"passwordForm.touched && passwordForm.errors?.required\"\n    class=\"invalid-feedback\"\n    >Enter a password</div\n  >\n</div>\n" }]
        }], propDecorators: { parentForm: [{
                type: Input
            }], passwordForm: [{
                type: Input
            }] } });

class LoginViewComponent {
    constructor(fb, loginActions, clpService, loginConfigService, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.clpService = clpService;
        this.loginConfigService = loginConfigService;
        this.formErrorService = formErrorService;
        this.clpErrors = false;
        this.dutyCodes = ['AS', 'CE', 'GS', 'PD', 'PR', 'RC', 'SU', 'TR'];
        this.resetSignInValue = signal(true);
        this.subscription = new Subscription();
        this.requestStatusService = inject(RequestStatusService);
        this.cdr = inject(ChangeDetectorRef);
        this.modalManagerService = inject(ModalManagerService);
        this.isRequestOnGoing = false;
        this.isClpReady = false;
        this.config$ = this.loginConfigService.getConfig().pipe(mergeMap((config) => config.clpConfig));
        this.subscription.add(this.requestStatusService.isRequestOnGoing$.subscribe((isRequestOnGoing) => {
            this.isRequestOnGoing = isRequestOnGoing;
            this.cdr.markForCheck();
        }));
        this.subscription.add(this.requestStatusService.isClpReady$.subscribe((isClpReady) => {
            this.isClpReady = isClpReady;
            this.cdr.markForCheck();
        }));
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.clpErrors = hasLoginError;
            if (hasLoginError) {
                this.loginForm.patchValue({ password: '' });
                this.cdr.markForCheck();
            }
        }));
    }
    set loginInformation(loginInformation) {
        if (loginInformation) {
            this.loginForm = this.fb.group({
                username: ['', [Validators.required, Validators.pattern(USERNAME_REGEXP)]],
                password: [this.loginForm ? this.loginForm.value.password : '', Validators.required],
                rememberMe: [loginInformation.rememberMe?.toString().toLowerCase() !== 'false']
            });
            this.updateFormValue('username', loginInformation.username);
            this.subscription.add(this.config$.subscribe((config) => {
                if (config.loginParameters.displayDutyCode) {
                    this.loginForm.addControl('dutyCode', this.fb.control(loginInformation.dutyCode || null, Validators.pattern(DUTY_CODE_REGEXP)));
                }
                if (config.loginParameters.officeNeeded) {
                    this.loginForm.addControl('officeId', this.fb.control(null, [Validators.required, Validators.pattern(OFFICE_ID_REGEXP)]));
                    this.updateFormValue('officeId', loginInformation.officeId);
                }
                if (!config.loginParameters.officeNeeded) {
                    this.loginForm.addControl('defaultOffice', this.fb.control(loginInformation.useDefaultoffice !== false));
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * On Submit.
     * @param form
     */
    onSubmit(form) {
        if (!this.isRequestOnGoing) {
            if (form.valid) {
                const formValue = form.value;
                this.loginActions.login({
                    username: formValue.username,
                    officeId: formValue.officeId || '',
                    dutyCode: formValue.dutyCode || '',
                    password: formValue.password,
                    rememberMe: formValue.rememberMe,
                    useDefaultoffice: this.loginForm.get('defaultOffice') ? this.loginForm.get('defaultOffice')?.value : true
                }, this.onMonosignError.bind(this));
                this.formErrorService.cleanError();
            }
            else {
                form.markAllAsTouched();
                this.formErrorService.updateError(this.formErrorService.getFieldsInError(form));
            }
        }
    }
    /**
     * On Forget password click.
     * @param form
     */
    onForgetPwd() {
        if (!this.loginForm.get('officeId') || this.loginForm.get('officeId')?.valid) {
            this.loginActions.initForgetPwdFlow({
                username: this.loginForm.get('username')?.valid ? this.loginForm.get('username')?.value : '',
                officeId: this.loginForm.get('officeId')?.value?.toUpperCase() || ''
            });
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm.get('officeId')?.markAsTouched();
            this.officeIdInput.nativeElement.focus();
            this.formErrorService.updateError([$localize `:@@login.officeId.label:Office ID`]);
        }
    }
    onForceSignIn() {
        this.clpService.loginAfterForcedSignOut();
    }
    onMonosignError() {
        this.modalManagerService.createModalInSeco($localize `:@@login.monosign.title:Force sign-in`, ForceSignInPopupComponent, [
            {
                label: $localize `:@@login.close:Close`,
                callbackFunction: () => this.resetSignInValue.set(false),
                btnClass: 'btn btn-outline-primary'
            },
            {
                label: $localize `:@@login.monosign.confirm:Force sign-in`,
                callbackFunction: () => {
                    this.resetSignInValue.set(false);
                    this.onForceSignIn();
                },
                btnClass: 'btn btn-primary'
            }
        ], { topCross: true, alertType: 'warning' }, { resetSignInValue: this.resetSignInValue });
    }
    updateFormValue(fieldName, value) {
        if (value !== undefined) {
            setTimeout(() => {
                this.loginForm.get(fieldName)?.setValue(value);
            }, 500);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginViewComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: ClpService }, { token: LoginConfigService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: LoginViewComponent, selector: "ama-ng-login-login-view", inputs: { loginInformation: "loginInformation" }, viewQueries: [{ propertyName: "officeIdInput", first: true, predicate: ["officeIdInput"], descendants: true }], ngImport: i0, template: "<form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit(loginForm)\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"d-flex flex-row align-items-baseline flex-nowrap\">\n    <div class=\"mb-5 w-100\" *ngIf=\"loginForm.get('username') as usernameForm\">\n      <label for=\"usernameInput\">\n        <ng-container i18n=\"@@login.username.label\">Username</ng-container>\n        <span class=\"mandatory-indicator\">*</span>\n      </label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"usernameInput\"\n        formControlName=\"username\"\n        autocomplete=\"off\"\n        [ngClass]=\"usernameForm.touched && usernameForm.errors ? 'is-invalid' : ''\"\n      />\n      <div\n        i18n=\"@@login.username.required\"\n        *ngIf=\"usernameForm.touched && usernameForm.errors?.required\"\n        class=\"invalid-feedback\"\n        >Enter a username</div\n      >\n      <div\n        i18n=\"@@login.username.pattern\"\n        *ngIf=\"usernameForm.touched && usernameForm.errors?.pattern\"\n        class=\"invalid-feedback\"\n        >Username has an invalid format\n      </div>\n    </div>\n\n    <div class=\"mb-5 ms-3\" *ngIf=\"loginForm.get('dutyCode') as dutyCode\" style=\"width: 9rem\">\n      <label i18n=\"@@login.dutycode.label\" for=\"dutyCodeSelect\">Duty code</label>\n      <ng-select\n        formControlName=\"dutyCode\"\n        id=\"dutyCode\"\n        placeholder=\"Select\"\n        bindLabel=\"dutyCode\"\n        labelForId=\"dutyCodeSelect\"\n        i18n-placeholder=\"@@login.dutycode.select.placeholder\"\n        [selectOnTab]=\"true\"\n        [items]=\"dutyCodes\"\n        [searchable]=\"false\"\n        [clearable]=\"true\"\n        [ngClass]=\"dutyCode.errors && dutyCode.dirty ? 'is-invalid' : ''\"\n      >\n      </ng-select>\n    </div>\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginForm.get('officeId') as officeIdForm\">\n    <label for=\"officeIdInput\">\n      <ng-container i18n=\"@@login.officeId.label\">Office ID</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      #officeIdInput\n      id=\"officeIdInput\"\n      formControlName=\"officeId\"\n      autocomplete=\"off\"\n      [ngClass]=\"officeIdForm.touched && officeIdForm.errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n    <div\n      i18n=\"@@login.officeId.pattern\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Enter an office ID (9 alphanumeric characters)</div\n    >\n  </div>\n  <ama-ng-login-advanced-password [parentForm]=\"loginForm\" [passwordForm]=\"loginForm.get('password')\">\n  </ama-ng-login-advanced-password>\n  <div class=\"form-check form-check mb-5\" *ngIf=\"loginForm.get('defaultOffice')\">\n    <input type=\"checkbox\" class=\"form-check-input\" formControlName=\"defaultOffice\" id=\"signInToDefaultOffice\" />\n    <label i18n=\"@@login.SignInToDefaultOffice\" class=\"form-check-label\" for=\"signInToDefaultOffice\"\n      >Sign in to default office</label\n    >\n  </div>\n  <div class=\"form-check form-check mb-5\">\n    <input type=\"checkbox\" class=\"form-check-input\" formControlName=\"rememberMe\" id=\"login-view-rememberMe\" />\n    <label i18n=\"@@login.rememberMe\" class=\"form-check-label\" for=\"login-view-rememberMe\">Remember me</label>\n  </div>\n  <div class=\"mt-6 mb-5 d-grid\">\n    <button [disabled]=\"!isClpReady\" type=\"submit\" class=\"btn btn-primary btn-lg\">\n      <ng-container i18n=\"@@login.send\">Sign in</ng-container>\n      <ng-container *ngIf=\"(!isClpReady || isRequestOnGoing) && !clpErrors\">\n        <span class=\"df-spinner-border-dark spinner-border-sm text-light ms-3\" role=\"status\" aria-hidden=\"true\"></span>\n        <span class=\"visually-hidden\" i18n=\"@@login.request.ongoing\">Loading...</span>\n      </ng-container>\n    </button>\n  </div>\n  <div class=\"mb-5 text-center\">\n    <button\n      id=\"forgotPasswordBtn\"\n      i18n=\"@@login.forgetPwd.label\"\n      type=\"button\"\n      class=\"btn btn-link p-0\"\n      (click)=\"onForgetPwd()\"\n      >I forgot my password</button\n    >\n  </div>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "component", type: AdvancedPasswordComponent, selector: "ama-ng-login-advanced-password", inputs: ["parentForm", "passwordForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-login-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit(loginForm)\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"d-flex flex-row align-items-baseline flex-nowrap\">\n    <div class=\"mb-5 w-100\" *ngIf=\"loginForm.get('username') as usernameForm\">\n      <label for=\"usernameInput\">\n        <ng-container i18n=\"@@login.username.label\">Username</ng-container>\n        <span class=\"mandatory-indicator\">*</span>\n      </label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"usernameInput\"\n        formControlName=\"username\"\n        autocomplete=\"off\"\n        [ngClass]=\"usernameForm.touched && usernameForm.errors ? 'is-invalid' : ''\"\n      />\n      <div\n        i18n=\"@@login.username.required\"\n        *ngIf=\"usernameForm.touched && usernameForm.errors?.required\"\n        class=\"invalid-feedback\"\n        >Enter a username</div\n      >\n      <div\n        i18n=\"@@login.username.pattern\"\n        *ngIf=\"usernameForm.touched && usernameForm.errors?.pattern\"\n        class=\"invalid-feedback\"\n        >Username has an invalid format\n      </div>\n    </div>\n\n    <div class=\"mb-5 ms-3\" *ngIf=\"loginForm.get('dutyCode') as dutyCode\" style=\"width: 9rem\">\n      <label i18n=\"@@login.dutycode.label\" for=\"dutyCodeSelect\">Duty code</label>\n      <ng-select\n        formControlName=\"dutyCode\"\n        id=\"dutyCode\"\n        placeholder=\"Select\"\n        bindLabel=\"dutyCode\"\n        labelForId=\"dutyCodeSelect\"\n        i18n-placeholder=\"@@login.dutycode.select.placeholder\"\n        [selectOnTab]=\"true\"\n        [items]=\"dutyCodes\"\n        [searchable]=\"false\"\n        [clearable]=\"true\"\n        [ngClass]=\"dutyCode.errors && dutyCode.dirty ? 'is-invalid' : ''\"\n      >\n      </ng-select>\n    </div>\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginForm.get('officeId') as officeIdForm\">\n    <label for=\"officeIdInput\">\n      <ng-container i18n=\"@@login.officeId.label\">Office ID</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      #officeIdInput\n      id=\"officeIdInput\"\n      formControlName=\"officeId\"\n      autocomplete=\"off\"\n      [ngClass]=\"officeIdForm.touched && officeIdForm.errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n    <div\n      i18n=\"@@login.officeId.pattern\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Enter an office ID (9 alphanumeric characters)</div\n    >\n  </div>\n  <ama-ng-login-advanced-password [parentForm]=\"loginForm\" [passwordForm]=\"loginForm.get('password')\">\n  </ama-ng-login-advanced-password>\n  <div class=\"form-check form-check mb-5\" *ngIf=\"loginForm.get('defaultOffice')\">\n    <input type=\"checkbox\" class=\"form-check-input\" formControlName=\"defaultOffice\" id=\"signInToDefaultOffice\" />\n    <label i18n=\"@@login.SignInToDefaultOffice\" class=\"form-check-label\" for=\"signInToDefaultOffice\"\n      >Sign in to default office</label\n    >\n  </div>\n  <div class=\"form-check form-check mb-5\">\n    <input type=\"checkbox\" class=\"form-check-input\" formControlName=\"rememberMe\" id=\"login-view-rememberMe\" />\n    <label i18n=\"@@login.rememberMe\" class=\"form-check-label\" for=\"login-view-rememberMe\">Remember me</label>\n  </div>\n  <div class=\"mt-6 mb-5 d-grid\">\n    <button [disabled]=\"!isClpReady\" type=\"submit\" class=\"btn btn-primary btn-lg\">\n      <ng-container i18n=\"@@login.send\">Sign in</ng-container>\n      <ng-container *ngIf=\"(!isClpReady || isRequestOnGoing) && !clpErrors\">\n        <span class=\"df-spinner-border-dark spinner-border-sm text-light ms-3\" role=\"status\" aria-hidden=\"true\"></span>\n        <span class=\"visually-hidden\" i18n=\"@@login.request.ongoing\">Loading...</span>\n      </ng-container>\n    </button>\n  </div>\n  <div class=\"mb-5 text-center\">\n    <button\n      id=\"forgotPasswordBtn\"\n      i18n=\"@@login.forgetPwd.label\"\n      type=\"button\"\n      class=\"btn btn-link p-0\"\n      (click)=\"onForgetPwd()\"\n      >I forgot my password</button\n    >\n  </div>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: ClpService }, { type: LoginConfigService }, { type: FormErrorService }], propDecorators: { officeIdInput: [{
                type: ViewChild,
                args: ['officeIdInput']
            }], loginInformation: [{
                type: Input
            }] } });

class OtpViewComponent {
    constructor(fb, loginActions, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.mfaSelfRegistrationActivated = input(false);
        this.hasLoginError = false;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this),
            'data-testid': 'cancelOTPButton'
        };
        this.rightButton = {
            label: $localize `:@@login.send:Sign in`,
            fn: this.onSubmit.bind(this),
            'data-testid': 'submitOTPButton'
        };
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.loginForm && hasLoginError) {
                this.loginForm.patchValue({ password: '' });
                this.loginForm.markAsPristine();
            }
        }));
    }
    ngOnInit() {
        if (this.isSelectedMFA()) {
            this.rightButton.label = $localize `:@@login.next:Next`;
        }
        this.loginForm = this.fb.group({
            otp: ['', Validators.required],
            ...(this.isSelectedMFA() ? {} : { password: ['', Validators.required] })
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    isSelectedMFA() {
        return this.mfaSelfRegistrationActivated() && !!this.loginInformation?.selectedMFA;
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm.valid) {
            const formValue = this.loginForm.value;
            this.loginActions.loginWithOtp({
                ...this.loginInformation,
                otp: formValue.otp.toUpperCase(),
                ...(this.isSelectedMFA() ? {} : { password: formValue.password })
            }, this.isSelectedMFA());
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OtpViewComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: OtpViewComponent, selector: "ama-ng-login-otp-view", inputs: { loginInformation: { classPropertyName: "loginInformation", publicName: "loginInformation", isSignal: false, isRequired: false, transformFunction: null }, mfaSelfRegistrationActivated: { classPropertyName: "mfaSelfRegistrationActivated", publicName: "mfaSelfRegistrationActivated", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<form [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      [value]=\"loginInformation.username\"\n      readonly\n    />\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n    <label i18n=\"@@login.officeId.label\" for=\"officeIdInput\">Office ID</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"officeIdInput\"\n      [value]=\"loginInformation.officeId\"\n      readonly\n    />\n  </div>\n  <div class=\"mb-5\">\n    <label for=\"otpInput\">\n      <ng-container i18n=\"@@login.otp.label\">One-time password</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"otpInput\"\n      formControlName=\"otp\"\n      autocomplete=\"off\"\n      [ngClass]=\"loginForm.get('otp').touched && loginForm.get('otp').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.otp.required\"\n      *ngIf=\"loginForm.get('otp').touched && loginForm.get('otp').errors?.required\"\n      class=\"invalid-feedback\"\n      >One-time Password is required</div\n    >\n  </div>\n  @if (!isSelectedMFA()) {\n    <ama-ng-login-advanced-password\n      [parentForm]=\"loginForm\"\n      [passwordForm]=\"loginForm.get('password')\"\n    ></ama-ng-login-advanced-password>\n  }\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }, { kind: "component", type: AdvancedPasswordComponent, selector: "ama-ng-login-advanced-password", inputs: ["parentForm", "passwordForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OtpViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-otp-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      [value]=\"loginInformation.username\"\n      readonly\n    />\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n    <label i18n=\"@@login.officeId.label\" for=\"officeIdInput\">Office ID</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"officeIdInput\"\n      [value]=\"loginInformation.officeId\"\n      readonly\n    />\n  </div>\n  <div class=\"mb-5\">\n    <label for=\"otpInput\">\n      <ng-container i18n=\"@@login.otp.label\">One-time password</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"otpInput\"\n      formControlName=\"otp\"\n      autocomplete=\"off\"\n      [ngClass]=\"loginForm.get('otp').touched && loginForm.get('otp').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.otp.required\"\n      *ngIf=\"loginForm.get('otp').touched && loginForm.get('otp').errors?.required\"\n      class=\"invalid-feedback\"\n      >One-time Password is required</div\n    >\n  </div>\n  @if (!isSelectedMFA()) {\n    <ama-ng-login-advanced-password\n      [parentForm]=\"loginForm\"\n      [passwordForm]=\"loginForm.get('password')\"\n    ></ama-ng-login-advanced-password>\n  }\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }], propDecorators: { loginInformation: [{
                type: Input
            }] } });

class DdnaViewComponent {
    constructor(fb, loginActions, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.ddnaDevices = [];
        this.hasLoginError = false;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this),
            'data-testid': 'cancelDdnaButton'
        };
        this.rightButton = {
            label: $localize `:@@login.send:Sign in`,
            fn: this.onSubmit.bind(this),
            'data-testid': 'submitDdnaButton'
        };
        this.subscription = new Subscription();
        this.requestStatusService = inject(RequestStatusService);
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.ddnaForm && hasLoginError) {
                this.ddnaForm.patchValue({ ddnaLabel: '', ddnaDeviceIds: '' });
                this.ddnaForm.markAsPristine();
            }
        }));
        this.ddnaForm = this.fb.group({
            ddnaLabel: ['', Validators.required],
            ddnaDeviceIds: ['', Validators.required]
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.ddnaForm.valid) {
            const formValue = this.ddnaForm.value;
            this.loginActions.ddnaRegister(formValue.ddnaLabel, formValue.ddnaDeviceIds);
            this.formErrorService.cleanError();
        }
        else {
            this.ddnaForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.ddnaForm));
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: DdnaViewComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: DdnaViewComponent, selector: "ama-ng-login-ddna-view", inputs: { ddnaDevices: "ddnaDevices" }, ngImport: i0, template: "<form [formGroup]=\"ddnaForm\">\n  <div class=\"mb-5\">\n    <label for=\"devices-selection\" i18n=\"@@login.ddna.devices\">Select a device combination</label>\n    <ng-select\n      labelForId=\"devices-selection\"\n      data-testid=\"devices-selection\"\n      dfManageNavSelect\n      [items]=\"ddnaDevices\"\n      [multiple]=\"true\"\n      i18n-placeholder=\"@@login.ddna.devices.placeholder\"\n      placeholder=\"Select devices\"\n      bindLabel=\"description\"\n      bindValue=\"id\"\n      [clearable]=\"true\"\n      formControlName=\"ddnaDeviceIds\"\n      name=\"devices-selection\"\n      [ngClass]=\"ddnaForm.get('ddnaDeviceIds').touched && ddnaForm.get('ddnaDeviceIds').errors ? 'is-invalid' : ''\"\n      [selectOnTab]=\"true\"\n      [closeOnSelect]=\"false\"\n      [clearSearchOnAdd]=\"true\"\n    >\n      <ng-template ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n        <div class=\"badge rounded-pill df-closable bg-light\"\n          >{{ item.description }}\n          <button\n            type=\"button\"\n            i18n-attr.aria-label=\"@@login.ddna.devices.ariaLabel\"\n            attr.aria-label=\"Remove {{ item.description }}\"\n            [dfManageBadgeEventsSelect]=\"[clear, item]\"\n          >\n            <span aria-hidden=\"true\" class=\"fa-xmark\"></span>\n          </button>\n        </div>\n      </ng-template>\n      <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\" let-index=\"index\" let-search=\"searchTerm\">\n        <div class=\"form-check\">\n          <input\n            id=\"devices-selection-item-{{ index }}\"\n            name=\"devices-selection-{{ index }}\"\n            type=\"checkbox\"\n            [ngModel]=\"item$.selected\"\n            [ngModelOptions]=\"{ standalone: true }\"\n          />\n          <label\n            class=\"form-check-label\"\n            for=\"devices-selection-item-{{ index }}\"\n            (click)=\"$event.preventDefault()\"\n            [dfOptionHighlight]=\"search\"\n            ><span class=\"me-2\" [ngClass]=\"{ 'fa-usb-drive': item.type === '1', 'fa-laptop': item.type === '0' }\"></span\n            >{{ item.description }}</label\n          >\n        </div>\n      </ng-template>\n    </ng-select>\n    <div\n      *ngIf=\"ddnaForm.get('ddnaDeviceIds').touched && ddnaForm.get('ddnaDeviceIds').errors\"\n      class=\"invalid-feedback d-block\"\n      i18n=\"@@login.ddna.devices.error\"\n    >\n      Please select at least one device\n    </div>\n  </div>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.ddna.label\" for=\"deviceCombinationName\">Device combination name</label>\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      id=\"deviceCombinationName\"\n      placeholder=\"Enter a name\"\n      i18n-placeholder=\"@@login.ddna.label.placeholder\"\n      formControlName=\"ddnaLabel\"\n      [ngClass]=\"ddnaForm.get('ddnaLabel').touched && ddnaForm.get('ddnaLabel').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      *ngIf=\"ddnaForm.get('ddnaLabel').touched && ddnaForm.get('ddnaLabel').errors\"\n      class=\"invalid-feedback\"\n      i18n=\"@@login.ddna.label.error\"\n    >\n      Please provide a label name\n    </div>\n  </div>\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i5.DfManageNavSelectDirective, selector: "[dfManageNavSelect]" }, { kind: "directive", type: i5.DfManageBadgeEventsDirective, selector: "[dfManageBadgeEventsSelect]", inputs: ["dfManageBadgeEventsSelect"] }, { kind: "directive", type: i5.DfOptionHighlightDirective, selector: "[dfOptionHighlight]", inputs: ["dfOptionHighlight"] }, { kind: "component", type: i6.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i6.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "directive", type: i6.NgLabelTemplateDirective, selector: "[ng-label-tmp]" }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: DdnaViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-ddna-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"ddnaForm\">\n  <div class=\"mb-5\">\n    <label for=\"devices-selection\" i18n=\"@@login.ddna.devices\">Select a device combination</label>\n    <ng-select\n      labelForId=\"devices-selection\"\n      data-testid=\"devices-selection\"\n      dfManageNavSelect\n      [items]=\"ddnaDevices\"\n      [multiple]=\"true\"\n      i18n-placeholder=\"@@login.ddna.devices.placeholder\"\n      placeholder=\"Select devices\"\n      bindLabel=\"description\"\n      bindValue=\"id\"\n      [clearable]=\"true\"\n      formControlName=\"ddnaDeviceIds\"\n      name=\"devices-selection\"\n      [ngClass]=\"ddnaForm.get('ddnaDeviceIds').touched && ddnaForm.get('ddnaDeviceIds').errors ? 'is-invalid' : ''\"\n      [selectOnTab]=\"true\"\n      [closeOnSelect]=\"false\"\n      [clearSearchOnAdd]=\"true\"\n    >\n      <ng-template ng-label-tmp let-item=\"item\" let-clear=\"clear\">\n        <div class=\"badge rounded-pill df-closable bg-light\"\n          >{{ item.description }}\n          <button\n            type=\"button\"\n            i18n-attr.aria-label=\"@@login.ddna.devices.ariaLabel\"\n            attr.aria-label=\"Remove {{ item.description }}\"\n            [dfManageBadgeEventsSelect]=\"[clear, item]\"\n          >\n            <span aria-hidden=\"true\" class=\"fa-xmark\"></span>\n          </button>\n        </div>\n      </ng-template>\n      <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\" let-index=\"index\" let-search=\"searchTerm\">\n        <div class=\"form-check\">\n          <input\n            id=\"devices-selection-item-{{ index }}\"\n            name=\"devices-selection-{{ index }}\"\n            type=\"checkbox\"\n            [ngModel]=\"item$.selected\"\n            [ngModelOptions]=\"{ standalone: true }\"\n          />\n          <label\n            class=\"form-check-label\"\n            for=\"devices-selection-item-{{ index }}\"\n            (click)=\"$event.preventDefault()\"\n            [dfOptionHighlight]=\"search\"\n            ><span class=\"me-2\" [ngClass]=\"{ 'fa-usb-drive': item.type === '1', 'fa-laptop': item.type === '0' }\"></span\n            >{{ item.description }}</label\n          >\n        </div>\n      </ng-template>\n    </ng-select>\n    <div\n      *ngIf=\"ddnaForm.get('ddnaDeviceIds').touched && ddnaForm.get('ddnaDeviceIds').errors\"\n      class=\"invalid-feedback d-block\"\n      i18n=\"@@login.ddna.devices.error\"\n    >\n      Please select at least one device\n    </div>\n  </div>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.ddna.label\" for=\"deviceCombinationName\">Device combination name</label>\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      id=\"deviceCombinationName\"\n      placeholder=\"Enter a name\"\n      i18n-placeholder=\"@@login.ddna.label.placeholder\"\n      formControlName=\"ddnaLabel\"\n      [ngClass]=\"ddnaForm.get('ddnaLabel').touched && ddnaForm.get('ddnaLabel').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      *ngIf=\"ddnaForm.get('ddnaLabel').touched && ddnaForm.get('ddnaLabel').errors\"\n      class=\"invalid-feedback\"\n      i18n=\"@@login.ddna.label.error\"\n    >\n      Please provide a label name\n    </div>\n  </div>\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }], propDecorators: { ddnaDevices: [{
                type: Input
            }] } });

class UserManagementService {
    constructor(httpService, store, clpService) {
        this.httpService = httpService;
        this.store = store;
        this.clpService = clpService;
        this.UM_GET_PASSWORD_RULES = 'getPasswordRules';
    }
    /**
     * Retrieve password policy from the backend if activated
     */
    getPasswordPolicy(input) {
        const passwordPolicyModule = this.getPasswordPolicyModule();
        if (!passwordPolicyModule) {
            return of(null);
        }
        this.store.dispatch(new PasswordRulesRequest());
        return this.httpService.postApfPlus(passwordPolicyModule, this.UM_GET_PASSWORD_RULES, input).pipe(map$1((res) => {
            const response = res.response.model;
            if (response.errors?.length > 0) {
                const errors = response.errors;
                throw new Error(errors[0].message);
            }
            this.store.dispatch(new PasswordRulesReceived());
            return {
                min: response.min,
                max: response.max,
                an: response.an,
                sc: response.sc,
                uplc: response.uplc
            };
        }));
    }
    getPasswordPolicyModule() {
        return this.clpService.getLoginConfig()?.passwordPolicyModule;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UserManagementService, deps: [{ token: i3.HttpService, optional: true }, { token: i1.Store }, { token: ClpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UserManagementService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: UserManagementService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i3.HttpService, decorators: [{
                    type: Optional
                }] }, { type: i1.Store }, { type: ClpService }] });

class NewPasswordComponent {
    constructor(store, userManagementService) {
        this.store = store;
        this.userManagementService = userManagementService;
        this.passwordHidden = true;
        this.confirmPasswordHidden = true;
        this.capsOn = false;
        this.capsOnConfirm = false;
        this.hasLoginError = false;
        this.passwordRules$ = new BehaviorSubject(undefined);
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (hasLoginError && this.passwordsForm) {
                this.passwordsForm.patchValue({ newPassword: '', confirmPassword: '' });
            }
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    get passwordsForm() {
        return this._passwordsForm;
    }
    set passwordsForm(passwordsForm) {
        passwordsForm.get('newPassword').addValidators([(ctrl) => this.passwordValidator(ctrl)]);
        this._passwordsForm = passwordsForm;
        this.updatePasswordPolicy();
    }
    set loginInformation(loginInformation) {
        this.officeId = loginInformation.officeId;
    }
    /**
     * updateOfficeId. Used by parent component to update rules when officeId changes
     * @param officeId to switch
     */
    updateOfficeId(officeId) {
        if (this.officeId !== officeId && officeId.match(OFFICE_ID_REGEXP)) {
            this.officeId = officeId;
            this.updatePasswordPolicy();
        }
    }
    updatePasswordPolicy() {
        const supportMode = new URLSearchParams(window.location.search.toUpperCase()).has('HELPDESK');
        this.userManagementService
            .getPasswordPolicy({
            officeId: this.officeId,
            organization: '',
            supportMode
        })
            .subscribe({
            next: (passwordRules) => {
                this.passwordRules$.next(passwordRules);
                this.passwordsForm.get('newPassword').updateValueAndValidity();
            },
            error: (error) => {
                const alert = new LoginAlertModel(error.message);
                this.store.dispatch(new PasswordRulesErrorReceived([alert]));
            }
        });
    }
    passwordValidator(ctrl) {
        if (!this.passwordRules$.value) {
            return null;
        }
        return Utils.checkPasswordRules(this.passwordRules$.value, ctrl.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NewPasswordComponent, deps: [{ token: i1.Store }, { token: UserManagementService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: NewPasswordComponent, selector: "ama-new-password", inputs: { passwordsForm: "passwordsForm", loginInformation: "loginInformation" }, viewQueries: [{ propertyName: "passwordHintTooltip", first: true, predicate: PasswordTooltipIndicatorComponent, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"passwordsForm\">\n  <div [formGroup]=\"passwordsForm\">\n    <div\n      class=\"mb-5\"\n      *ngIf=\"{\n        pwdValue: passwordsForm.get('newPassword').valueChanges | async,\n        pwdRule: passwordRules$ | async\n      } as pwdObs\"\n    >\n      <label for=\"newPasswordInput\">\n        <ng-container i18n=\"@@login.resetPwd.passwords.newPwd\">New password</ng-container>\n        <span class=\"mandatory-indicator\">*</span>\n      </label>\n      <ama-ng-password-tooltip-indicator\n        *ngIf=\"pwdObs.pwdRule\"\n        [password]=\"pwdObs.pwdValue\"\n        [passwordRules]=\"pwdObs.pwdRule\"\n      >\n      </ama-ng-password-tooltip-indicator>\n      <div\n        class=\"input-group df-input-append\"\n        [class]=\"\n          passwordsForm.get('newPassword').touched && passwordsForm.get('newPassword').errors ? 'is-invalid' : ''\n        \"\n        [ngClass]=\"{ 'is-warning': capsOn }\"\n      >\n        <input\n          [dfInputIcon]=\"['append']\"\n          type=\"{{ passwordHidden ? 'password' : 'text' }}\"\n          class=\"form-control\"\n          [class]=\"\n            passwordsForm.get('newPassword').touched && passwordsForm.get('newPassword').errors ? 'is-invalid' : ''\n          \"\n          id=\"newPasswordInput\"\n          formControlName=\"newPassword\"\n          autocomplete=\"off\"\n          (capsLock)=\"capsOn = $event\"\n          (focus)=\"passwordHintTooltip?.open()\"\n          (blur)=\"passwordHintTooltip?.close()\"\n        />\n        <div class=\"input-group-append\">\n          <button\n            type=\"button\"\n            class=\"input-group-text\"\n            [ngClass]=\"{ 'fa-eye-slash': passwordHidden, 'fa-eye': !passwordHidden }\"\n            (click)=\"passwordHidden = !passwordHidden; confirmPasswordHidden = true\"\n          >\n            <span class=\"visually-hidden\" *ngIf=\"passwordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n              >Show password</span\n            >\n            <ng-template #hidePassword>\n              <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n            </ng-template>\n          </button>\n        </div>\n      </div>\n      <div class=\"warning-feedback\" *ngIf=\"capsOn\">\n        <span class=\"icon-df-caps-lock\"></span>\n        <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n      </div>\n      <div\n        i18n=\"@@login.password.invalid\"\n        *ngIf=\"\n          passwordsForm.get('newPassword').touched &&\n          passwordsForm.get('newPassword').invalid &&\n          !passwordsForm.get('newPassword').errors.required\n        \"\n        class=\"invalid-feedback\"\n        >Password has an invalid format</div\n      >\n      <div\n        i18n=\"@@login.password.required\"\n        *ngIf=\"passwordsForm.get('newPassword').touched && passwordsForm.get('newPassword').errors?.required\"\n        class=\"invalid-feedback\"\n        >Enter a password</div\n      >\n      <ama-ng-password-strength-indicator\n        *ngIf=\"!passwordsForm.get('newPassword').touched || passwordsForm.get('newPassword').valid\"\n        [password]=\"pwdObs.pwdValue\"\n        [passwordRules]=\"pwdObs.pwdRule\"\n      >\n      </ama-ng-password-strength-indicator>\n    </div>\n    <div class=\"mb-5\">\n      <label for=\"confirmPasswordInput\">\n        <ng-container i18n=\"@@login.resetPwd.passwords.confirmPwd\">Confirm your new password</ng-container>\n        <span class=\"mandatory-indicator\">*</span>\n      </label>\n      <div\n        class=\"input-group df-input-append\"\n        [class]=\"\n          passwordsForm.get('confirmPassword').touched && passwordsForm.errors?.allEqualInGroupValidator\n            ? 'is-invalid'\n            : ''\n        \"\n        [ngClass]=\"{ 'is-warning': capsOnConfirm }\"\n      >\n        <input\n          [dfInputIcon]=\"['append']\"\n          type=\"{{ confirmPasswordHidden ? 'password' : 'text' }}\"\n          class=\"form-control\"\n          [class]=\"\n            passwordsForm.get('confirmPassword').touched && passwordsForm.errors?.allEqualInGroupValidator\n              ? 'is-invalid'\n              : ''\n          \"\n          id=\"confirmPasswordInput\"\n          formControlName=\"confirmPassword\"\n          autocomplete=\"off\"\n          (capsLock)=\"capsOnConfirm = $event\"\n        />\n        <div class=\"input-group-append\">\n          <button\n            type=\"button\"\n            class=\"input-group-text\"\n            [ngClass]=\"{ 'fa-eye-slash': confirmPasswordHidden, 'fa-eye': !confirmPasswordHidden }\"\n            (click)=\"confirmPasswordHidden = !confirmPasswordHidden; passwordHidden = true\"\n          >\n            <span class=\"visually-hidden\" *ngIf=\"confirmPasswordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n              >Show password</span\n            >\n            <ng-template #hidePassword>\n              <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n            </ng-template>\n          </button>\n        </div>\n      </div>\n      <div class=\"warning-feedback\" *ngIf=\"capsOnConfirm\">\n        <span class=\"icon-df-caps-lock\"></span>\n        <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n      </div>\n      <div\n        i18n=\"@@login.resetPwd.passwords.wrongMatch\"\n        *ngIf=\"passwordsForm.get('confirmPassword').touched && passwordsForm.errors?.allEqualInGroupValidator\"\n        class=\"invalid-feedback\"\n        >The passwords you entered don't match</div\n      >\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i5.DfInputIconDirective, selector: "[dfInputIcon]", inputs: ["dfInputIcon"], exportAs: ["dfInputIcon"] }, { kind: "component", type: PasswordTooltipIndicatorComponent, selector: "ama-ng-password-tooltip-indicator", inputs: ["password", "passwordRules"] }, { kind: "component", type: PasswordStrengthIndicatorComponent, selector: "ama-ng-password-strength-indicator", inputs: ["password", "passwordRules"] }, { kind: "directive", type: CapsLockDirective, selector: "[capsLock]", outputs: ["capsLock"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: NewPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-new-password', template: "<ng-container *ngIf=\"passwordsForm\">\n  <div [formGroup]=\"passwordsForm\">\n    <div\n      class=\"mb-5\"\n      *ngIf=\"{\n        pwdValue: passwordsForm.get('newPassword').valueChanges | async,\n        pwdRule: passwordRules$ | async\n      } as pwdObs\"\n    >\n      <label for=\"newPasswordInput\">\n        <ng-container i18n=\"@@login.resetPwd.passwords.newPwd\">New password</ng-container>\n        <span class=\"mandatory-indicator\">*</span>\n      </label>\n      <ama-ng-password-tooltip-indicator\n        *ngIf=\"pwdObs.pwdRule\"\n        [password]=\"pwdObs.pwdValue\"\n        [passwordRules]=\"pwdObs.pwdRule\"\n      >\n      </ama-ng-password-tooltip-indicator>\n      <div\n        class=\"input-group df-input-append\"\n        [class]=\"\n          passwordsForm.get('newPassword').touched && passwordsForm.get('newPassword').errors ? 'is-invalid' : ''\n        \"\n        [ngClass]=\"{ 'is-warning': capsOn }\"\n      >\n        <input\n          [dfInputIcon]=\"['append']\"\n          type=\"{{ passwordHidden ? 'password' : 'text' }}\"\n          class=\"form-control\"\n          [class]=\"\n            passwordsForm.get('newPassword').touched && passwordsForm.get('newPassword').errors ? 'is-invalid' : ''\n          \"\n          id=\"newPasswordInput\"\n          formControlName=\"newPassword\"\n          autocomplete=\"off\"\n          (capsLock)=\"capsOn = $event\"\n          (focus)=\"passwordHintTooltip?.open()\"\n          (blur)=\"passwordHintTooltip?.close()\"\n        />\n        <div class=\"input-group-append\">\n          <button\n            type=\"button\"\n            class=\"input-group-text\"\n            [ngClass]=\"{ 'fa-eye-slash': passwordHidden, 'fa-eye': !passwordHidden }\"\n            (click)=\"passwordHidden = !passwordHidden; confirmPasswordHidden = true\"\n          >\n            <span class=\"visually-hidden\" *ngIf=\"passwordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n              >Show password</span\n            >\n            <ng-template #hidePassword>\n              <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n            </ng-template>\n          </button>\n        </div>\n      </div>\n      <div class=\"warning-feedback\" *ngIf=\"capsOn\">\n        <span class=\"icon-df-caps-lock\"></span>\n        <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n      </div>\n      <div\n        i18n=\"@@login.password.invalid\"\n        *ngIf=\"\n          passwordsForm.get('newPassword').touched &&\n          passwordsForm.get('newPassword').invalid &&\n          !passwordsForm.get('newPassword').errors.required\n        \"\n        class=\"invalid-feedback\"\n        >Password has an invalid format</div\n      >\n      <div\n        i18n=\"@@login.password.required\"\n        *ngIf=\"passwordsForm.get('newPassword').touched && passwordsForm.get('newPassword').errors?.required\"\n        class=\"invalid-feedback\"\n        >Enter a password</div\n      >\n      <ama-ng-password-strength-indicator\n        *ngIf=\"!passwordsForm.get('newPassword').touched || passwordsForm.get('newPassword').valid\"\n        [password]=\"pwdObs.pwdValue\"\n        [passwordRules]=\"pwdObs.pwdRule\"\n      >\n      </ama-ng-password-strength-indicator>\n    </div>\n    <div class=\"mb-5\">\n      <label for=\"confirmPasswordInput\">\n        <ng-container i18n=\"@@login.resetPwd.passwords.confirmPwd\">Confirm your new password</ng-container>\n        <span class=\"mandatory-indicator\">*</span>\n      </label>\n      <div\n        class=\"input-group df-input-append\"\n        [class]=\"\n          passwordsForm.get('confirmPassword').touched && passwordsForm.errors?.allEqualInGroupValidator\n            ? 'is-invalid'\n            : ''\n        \"\n        [ngClass]=\"{ 'is-warning': capsOnConfirm }\"\n      >\n        <input\n          [dfInputIcon]=\"['append']\"\n          type=\"{{ confirmPasswordHidden ? 'password' : 'text' }}\"\n          class=\"form-control\"\n          [class]=\"\n            passwordsForm.get('confirmPassword').touched && passwordsForm.errors?.allEqualInGroupValidator\n              ? 'is-invalid'\n              : ''\n          \"\n          id=\"confirmPasswordInput\"\n          formControlName=\"confirmPassword\"\n          autocomplete=\"off\"\n          (capsLock)=\"capsOnConfirm = $event\"\n        />\n        <div class=\"input-group-append\">\n          <button\n            type=\"button\"\n            class=\"input-group-text\"\n            [ngClass]=\"{ 'fa-eye-slash': confirmPasswordHidden, 'fa-eye': !confirmPasswordHidden }\"\n            (click)=\"confirmPasswordHidden = !confirmPasswordHidden; passwordHidden = true\"\n          >\n            <span class=\"visually-hidden\" *ngIf=\"confirmPasswordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n              >Show password</span\n            >\n            <ng-template #hidePassword>\n              <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n            </ng-template>\n          </button>\n        </div>\n      </div>\n      <div class=\"warning-feedback\" *ngIf=\"capsOnConfirm\">\n        <span class=\"icon-df-caps-lock\"></span>\n        <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n      </div>\n      <div\n        i18n=\"@@login.resetPwd.passwords.wrongMatch\"\n        *ngIf=\"passwordsForm.get('confirmPassword').touched && passwordsForm.errors?.allEqualInGroupValidator\"\n        class=\"invalid-feedback\"\n        >The passwords you entered don't match</div\n      >\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1.Store }, { type: UserManagementService }], propDecorators: { passwordHintTooltip: [{
                type: ViewChild,
                args: [PasswordTooltipIndicatorComponent]
            }], passwordsForm: [{
                type: Input
            }], loginInformation: [{
                type: Input
            }] } });

class ForgetPwdComponent {
    constructor(fb, reactiveFormUtils, loginActions, store, formErrorService) {
        this.fb = fb;
        this.reactiveFormUtils = reactiveFormUtils;
        this.loginActions = loginActions;
        this.store = store;
        this.formErrorService = formErrorService;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this),
            'data-testid': 'cancelButton'
        };
        this.rightButton = {
            label: $localize `:@@login.forgetPwd.reset:Reset password`,
            fn: this.onSubmit.bind(this),
            'data-testid': 'resetButton'
        };
        this.passwordHidden = true;
        this.confirmPasswordHidden = true;
        this.capsOn = false;
        this.capsOnConfirm = false;
        this.FORGET_PWD_STATE = ForgetPwdState;
        this.hasLoginError = false;
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((errors) => {
            this.hasLoginError = errors;
            if (errors && this.loginForm?.get('passwords')) {
                this.loginForm.markAsPristine();
            }
        }));
        this.forgetPwdState$ = this.store.pipe(select(getForgetPwdState));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    get loginInformation() {
        return this._loginInformation;
    }
    set loginInformation(loginInformation) {
        this._loginInformation = loginInformation;
        this.loginForm = this.fb.group({
            username: [loginInformation.username, Validators.required],
            passwords: this.fb.group({
                newPassword: ['', [Validators.required]],
                confirmPassword: ['']
            }, { validator: this.reactiveFormUtils.allEqualInGroupValidator })
        });
        if (loginInformation.officeId) {
            this.loginForm.addControl('officeId', this.fb.control(loginInformation.officeId, [Validators.required, Validators.pattern(OFFICE_ID_REGEXP)]));
        }
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm.valid) {
            const formValue = this.loginForm.value;
            this.loginActions.resetPassword({
                username: formValue.username.toUpperCase(),
                officeId: formValue.officeId?.toUpperCase() || '',
                newPassword: formValue.passwords.newPassword,
                confirmPassword: formValue.passwords.confirmPassword
            });
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ForgetPwdComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: i3.ReactiveFormUtilsService }, { token: LoginActionsService }, { token: i1.Store }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ForgetPwdComponent, selector: "ama-ng-login-forget-pwd", inputs: { loginInformation: "loginInformation" }, viewQueries: [{ propertyName: "newPasswordComponent", first: true, predicate: NewPasswordComponent, descendants: true }], ngImport: i0, template: "<form *ngIf=\"(forgetPwdState$ | async) === FORGET_PWD_STATE.initForget\" [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label for=\"usernameInput\">\n      <ng-container i18n=\"@@login.username.label\">Username</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      formControlName=\"username\"\n      autocomplete=\"off\"\n      [ngClass]=\"loginForm.get('username').touched && loginForm.get('username').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.username.required\"\n      *ngIf=\"loginForm.get('username').touched && loginForm.get('username').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter a username</div\n    >\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n    <label for=\"officeIdInput\">\n      <ng-container i18n=\"@@login.officeId.label\">Office ID</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"officeIdInput\"\n      formControlName=\"officeId\"\n      autocomplete=\"off\"\n      (blur)=\"newPasswordComponent.updateOfficeId(loginForm.get('officeId').value)\"\n      [ngClass]=\"loginForm.get('officeId').touched && loginForm.get('officeId').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"loginForm.get('officeId').touched && loginForm.get('officeId').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n    <div\n      i18n=\"@@login.officeId.pattern\"\n      *ngIf=\"loginForm.get('officeId').touched && loginForm.get('officeId').errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Enter an office ID (9 alphanumeric characters)</div\n    >\n  </div>\n  <ama-new-password [loginInformation]=\"loginInformation\" [passwordsForm]=\"loginForm.get('passwords')\">\n  </ama-new-password>\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n<ng-container *ngIf=\"(forgetPwdState$ | async) === FORGET_PWD_STATE.resetCompleted\">\n  <ngb-alert\n    id=\"forgotPwdConfirmation\"\n    dfInsertAlertIcon\n    class=\"df-card-alert border border-success\"\n    type=\"success\"\n    [dismissible]=\"false\"\n  >\n    <ng-container i18n=\"@@login.forgetPwd.end.confirmation\"\n      >An email with a confirmation link will be sent to the user's address.</ng-container\n    >\n    <hr class=\"border border-success\" />\n    <strong i18n=\"@@login.forgetPwd.end.explanation\"\n      >If you don't receive it, check your credentials or contact your administrator.</strong\n    >\n  </ngb-alert>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i7.NgbAlert, selector: "ngb-alert", inputs: ["animation", "dismissible", "type"], outputs: ["closed"], exportAs: ["ngbAlert"] }, { kind: "directive", type: i5.DfInsertIconDirective, selector: "ngb-alert[dfInsertAlertIcon],ngb-toast[dfInsertToastIcon]" }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }, { kind: "component", type: NewPasswordComponent, selector: "ama-new-password", inputs: ["passwordsForm", "loginInformation"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ForgetPwdComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-forget-pwd', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form *ngIf=\"(forgetPwdState$ | async) === FORGET_PWD_STATE.initForget\" [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label for=\"usernameInput\">\n      <ng-container i18n=\"@@login.username.label\">Username</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      formControlName=\"username\"\n      autocomplete=\"off\"\n      [ngClass]=\"loginForm.get('username').touched && loginForm.get('username').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.username.required\"\n      *ngIf=\"loginForm.get('username').touched && loginForm.get('username').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter a username</div\n    >\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n    <label for=\"officeIdInput\">\n      <ng-container i18n=\"@@login.officeId.label\">Office ID</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"officeIdInput\"\n      formControlName=\"officeId\"\n      autocomplete=\"off\"\n      (blur)=\"newPasswordComponent.updateOfficeId(loginForm.get('officeId').value)\"\n      [ngClass]=\"loginForm.get('officeId').touched && loginForm.get('officeId').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"loginForm.get('officeId').touched && loginForm.get('officeId').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n    <div\n      i18n=\"@@login.officeId.pattern\"\n      *ngIf=\"loginForm.get('officeId').touched && loginForm.get('officeId').errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Enter an office ID (9 alphanumeric characters)</div\n    >\n  </div>\n  <ama-new-password [loginInformation]=\"loginInformation\" [passwordsForm]=\"loginForm.get('passwords')\">\n  </ama-new-password>\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n<ng-container *ngIf=\"(forgetPwdState$ | async) === FORGET_PWD_STATE.resetCompleted\">\n  <ngb-alert\n    id=\"forgotPwdConfirmation\"\n    dfInsertAlertIcon\n    class=\"df-card-alert border border-success\"\n    type=\"success\"\n    [dismissible]=\"false\"\n  >\n    <ng-container i18n=\"@@login.forgetPwd.end.confirmation\"\n      >An email with a confirmation link will be sent to the user's address.</ng-container\n    >\n    <hr class=\"border border-success\" />\n    <strong i18n=\"@@login.forgetPwd.end.explanation\"\n      >If you don't receive it, check your credentials or contact your administrator.</strong\n    >\n  </ngb-alert>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: i3.ReactiveFormUtilsService }, { type: LoginActionsService }, { type: i1.Store }, { type: FormErrorService }], propDecorators: { newPasswordComponent: [{
                type: ViewChild,
                args: [NewPasswordComponent]
            }], loginInformation: [{
                type: Input
            }] } });

class ExpiredPasswordComponent {
    constructor(fb, loginActions, reactiveFormUtils, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.reactiveFormUtils = reactiveFormUtils;
        this.formErrorService = formErrorService;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.send:Sign in`,
            fn: this.onSubmit.bind(this)
        };
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.hasLoginError = false;
        this.passwordsForm = this.fb.group({
            newPassword: ['', [Validators.required]],
            confirmPassword: ['', Validators.required]
        }, { validator: this.reactiveFormUtils.allEqualInGroupValidator });
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((errors) => {
            this.hasLoginError = errors;
            if (errors && this.passwordsForm) {
                this.passwordsForm.markAsPristine();
            }
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.passwordsForm.valid) {
            const formValue = this.passwordsForm.value;
            this.loginActions.loginAndChangePassword({
                ...this.loginInformation,
                newPassword: formValue.newPassword,
                confirmPassword: formValue.confirmPassword
            });
            this.formErrorService.cleanError();
        }
        else {
            this.passwordsForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.passwordsForm));
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ExpiredPasswordComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: i3.ReactiveFormUtilsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ExpiredPasswordComponent, selector: "ama-ng-login-expired-pwd", inputs: { loginInformation: "loginInformation" }, ngImport: i0, template: "<form [formGroup]=\"passwordsForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      [value]=\"loginInformation.username\"\n      readonly\n    />\n  </div>\n  <ama-new-password [loginInformation]=\"loginInformation\" [passwordsForm]=\"passwordsForm\"> </ama-new-password>\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }, { kind: "component", type: NewPasswordComponent, selector: "ama-new-password", inputs: ["passwordsForm", "loginInformation"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ExpiredPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-expired-pwd', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"passwordsForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      [value]=\"loginInformation.username\"\n      readonly\n    />\n  </div>\n  <ama-new-password [loginInformation]=\"loginInformation\" [passwordsForm]=\"passwordsForm\"> </ama-new-password>\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: i3.ReactiveFormUtilsService }, { type: FormErrorService }], propDecorators: { loginInformation: [{
                type: Input
            }] } });

class ValidatePwdComponent {
    constructor(fb, store, loginActions, formErrorService) {
        this.fb = fb;
        this.store = store;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.leftButton = {
            label: $localize `:@@login.validatePwd.close:Close`,
            fn: this.onBack.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.validatePwd.confirm:Confirm`,
            fn: this.onSubmit.bind(this)
        };
        this.forgetPwdState$ = this.store.pipe(select(getForgetPwdState));
        this.FORGET_PWD_STATE = ForgetPwdState;
        this.newPasswordHidden = true;
        this.capsOn = false;
        this.hasLoginError = false;
        this.USER_NAME_PARAM = 'USER_ALIAS';
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        const regUser = new RegExp(`[?&]${this.USER_NAME_PARAM}=([^&#]*)`, 'i').exec(window.location.href.toUpperCase());
        this.userName = regUser ? regUser[1] : '';
        this.loginForm = this.fb.group({
            newPassword: ['', Validators.required]
        });
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.loginForm && hasLoginError) {
                this.loginForm.patchValue({ newPassword: '' });
                this.loginForm.markAsPristine();
            }
        }));
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm.valid) {
            const formValue = this.loginForm.value;
            this.loginActions.validatePassword({
                newPassword: formValue.newPassword
            });
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ValidatePwdComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: i1.Store }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ValidatePwdComponent, selector: "ama-ng-login-validate-pwd", ngImport: i0, template: "<form *ngIf=\"(forgetPwdState$ | async) === FORGET_PWD_STATE.initValid\" [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input type=\"text\" class=\"form-control text-uppercase\" id=\"usernameInput\" [value]=\"userName\" readonly />\n  </div>\n  <div class=\"mb-5\">\n    <label for=\"newPasswordInput\">\n      <ng-container i18n=\"@@login.validatePwd.newPwd\">Password</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <div\n      class=\"input-group df-input-append\"\n      [ngClass]=\"{\n        'is-invalid': loginForm.get('newPassword').errors && loginForm.get('newPassword').touched,\n        'is-warning': capsOn\n      }\"\n    >\n      <input\n        [dfInputIcon]=\"['append']\"\n        type=\"{{ newPasswordHidden ? 'password' : 'text' }}\"\n        class=\"form-control\"\n        id=\"newPasswordInput\"\n        formControlName=\"newPassword\"\n        [ngClass]=\"{ 'is-invalid': loginForm.get('newPassword').errors && loginForm.get('newPassword').touched }\"\n        autocomplete=\"off\"\n        (capsLock)=\"capsOn = $event\"\n      />\n      <div class=\"input-group-append\">\n        <button\n          type=\"button\"\n          class=\"input-group-text\"\n          [ngClass]=\"{ 'fa-eye-slash': newPasswordHidden, 'fa-eye': !newPasswordHidden }\"\n          (click)=\"newPasswordHidden = !newPasswordHidden\"\n        >\n          <span class=\"visually-hidden\" *ngIf=\"newPasswordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n            >Show password</span\n          >\n          <ng-template #hidePassword>\n            <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n          </ng-template>\n        </button>\n      </div>\n    </div>\n    <div class=\"warning-feedback\" *ngIf=\"capsOn\">\n      <span class=\"icon-df-caps-lock\"></span>\n      <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n    </div>\n    <div\n      i18n=\"@@login.password.required\"\n      *ngIf=\"loginForm.get('newPassword').touched && loginForm.get('newPassword').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter a password</div\n    >\n  </div>\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i5.DfInputIconDirective, selector: "[dfInputIcon]", inputs: ["dfInputIcon"], exportAs: ["dfInputIcon"] }, { kind: "directive", type: CapsLockDirective, selector: "[capsLock]", outputs: ["capsLock"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ValidatePwdComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-validate-pwd', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form *ngIf=\"(forgetPwdState$ | async) === FORGET_PWD_STATE.initValid\" [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input type=\"text\" class=\"form-control text-uppercase\" id=\"usernameInput\" [value]=\"userName\" readonly />\n  </div>\n  <div class=\"mb-5\">\n    <label for=\"newPasswordInput\">\n      <ng-container i18n=\"@@login.validatePwd.newPwd\">Password</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <div\n      class=\"input-group df-input-append\"\n      [ngClass]=\"{\n        'is-invalid': loginForm.get('newPassword').errors && loginForm.get('newPassword').touched,\n        'is-warning': capsOn\n      }\"\n    >\n      <input\n        [dfInputIcon]=\"['append']\"\n        type=\"{{ newPasswordHidden ? 'password' : 'text' }}\"\n        class=\"form-control\"\n        id=\"newPasswordInput\"\n        formControlName=\"newPassword\"\n        [ngClass]=\"{ 'is-invalid': loginForm.get('newPassword').errors && loginForm.get('newPassword').touched }\"\n        autocomplete=\"off\"\n        (capsLock)=\"capsOn = $event\"\n      />\n      <div class=\"input-group-append\">\n        <button\n          type=\"button\"\n          class=\"input-group-text\"\n          [ngClass]=\"{ 'fa-eye-slash': newPasswordHidden, 'fa-eye': !newPasswordHidden }\"\n          (click)=\"newPasswordHidden = !newPasswordHidden\"\n        >\n          <span class=\"visually-hidden\" *ngIf=\"newPasswordHidden; else hidePassword\" i18n=\"@@login.password.show\"\n            >Show password</span\n          >\n          <ng-template #hidePassword>\n            <span class=\"visually-hidden\" i18n=\"@@login.password.hide\">Hide password</span>\n          </ng-template>\n        </button>\n      </div>\n    </div>\n    <div class=\"warning-feedback\" *ngIf=\"capsOn\">\n      <span class=\"icon-df-caps-lock\"></span>\n      <ng-container i18n=\"@@login.password.capsLockWarning\"> Caps Lock is on</ng-container>\n    </div>\n    <div\n      i18n=\"@@login.password.required\"\n      *ngIf=\"loginForm.get('newPassword').touched && loginForm.get('newPassword').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter a password</div\n    >\n  </div>\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: i1.Store }, { type: LoginActionsService }, { type: FormErrorService }] });

class SSOViewComponent {
    constructor(loginActions) {
        this.loginActions = loginActions;
    }
    ngOnChanges(changes) {
        if (this.loginConfig && this.loginConfig.useSSO) {
            if (this.ssoStatus && !this.userSignedIn) {
                this.loginActions.loginViaSSO();
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SSOViewComponent, deps: [{ token: LoginActionsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: SSOViewComponent, selector: "ama-ng-login-sso-view", inputs: { loginConfig: "loginConfig", ssoStatus: "ssoStatus", userSignedIn: "userSignedIn" }, usesOnChanges: true, ngImport: i0, template: "<div i18n=\"@@login.sso.message\">Performing login via SSO.</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: SSOViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-sso-view', template: "<div i18n=\"@@login.sso.message\">Performing login via SSO.</div>\n" }]
        }], ctorParameters: () => [{ type: LoginActionsService }], propDecorators: { loginConfig: [{
                type: Input
            }], ssoStatus: [{
                type: Input
            }], userSignedIn: [{
                type: Input
            }] } });

const PHONE_CODES = [
    { label: '+93', country: 'Afghanistan' },
    { label: '+355', country: 'Albania' },
    { label: '+213', country: 'Algeria' },
    { label: '+684', country: 'American Samoa' },
    { label: '+376', country: 'Andorra' },
    { label: '+244', country: 'Angola' },
    { label: '+809', country: 'Anguilla' },
    { label: '+268', country: 'Antigua' },
    { label: '+54', country: 'Argentina' },
    { label: '+374', country: 'Armenia' },
    { label: '+297', country: 'Aruba' },
    { label: '+247', country: 'Ascension Island' },
    { label: '+61', country: 'Australia' },
    { label: '+672', country: 'Australian External Territories' },
    { label: '+43', country: 'Austria' },
    { label: '+994', country: 'Azerbaijan' },
    { label: '+242', country: 'Bahamas' },
    { label: '+246', country: 'Barbados' },
    { label: '+973', country: 'Bahrain' },
    { label: '+880', country: 'Bangladesh' },
    { label: '+375', country: 'Belarus' },
    { label: '+32', country: 'Belgium' },
    { label: '+501', country: 'Belize' },
    { label: '+229', country: 'Benin' },
    { label: '+809', country: 'Bermuda' },
    { label: '+975', country: 'Bhutan' },
    { label: '+284', country: 'British Virgin Islands' },
    { label: '+591', country: 'Bolivia' },
    { label: '+387', country: 'Bosnia and Hercegovina' },
    { label: '+267', country: 'Botswana' },
    { label: '+55', country: 'Brazil' },
    { label: '+284', country: 'British V.I.' },
    { label: '+673', country: 'Brunei Darussalm' },
    { label: '+359', country: 'Bulgaria' },
    { label: '+226', country: 'Burkina Faso' },
    { label: '+257', country: 'Burundi' },
    { label: '+855', country: 'Cambodia' },
    { label: '+237', country: 'Cameroon' },
    { label: '+1', country: 'Canada' },
    { label: '+238', country: 'CapeVerde Islands' },
    { label: '+1', country: 'Caribbean Nations' },
    { label: '+345', country: 'Cayman Islands' },
    { label: '+238', country: 'Cape Verdi' },
    { label: '+236', country: 'Central African Republic' },
    { label: '+235', country: 'Chad' },
    { label: '+56', country: 'Chile' },
    { label: '+86', country: "China (People's Republic)" },
    { label: '+886', country: 'China-Taiwan' },
    { label: '+57', country: 'Colombia' },
    { label: '+269', country: 'Comoros and Mayotte' },
    { label: '+242', country: 'Congo' },
    { label: '+682', country: 'Cook Islands' },
    { label: '+506', country: 'Costa Rica' },
    { label: '+385', country: 'Croatia' },
    { label: '+53', country: 'Cuba' },
    { label: '+357', country: 'Cyprus' },
    { label: '+420', country: 'Czech Republic' },
    { label: '+45', country: 'Denmark' },
    { label: '+246', country: 'Diego Garcia' },
    { label: '+767', country: 'Dominca' },
    { label: '+809', country: 'Dominican Republic' },
    { label: '+253', country: 'Djibouti' },
    { label: '+593', country: 'Ecuador' },
    { label: '+20', country: 'Egypt' },
    { label: '+503', country: 'El Salvador' },
    { label: '+240', country: 'Equatorial Guinea' },
    { label: '+291', country: 'Eritrea' },
    { label: '+372', country: 'Estonia' },
    { label: '+251', country: 'Ethiopia' },
    { label: '+500', country: 'Falkland Islands' },
    { label: '+298', country: 'Faroe (Faeroe) Islands (Denmark)' },
    { label: '+679', country: 'Fiji' },
    { label: '+358', country: 'Finland' },
    { label: '+33', country: 'France' },
    { label: '+596', country: 'French Antilles' },
    { label: '+594', country: 'French Guiana' },
    { label: '+241', country: 'Gabon (Gabonese Republic)' },
    { label: '+220', country: 'Gambia' },
    { label: '+995', country: 'Georgia' },
    { label: '+49', country: 'Germany' },
    { label: '+233', country: 'Ghana' },
    { label: '+350', country: 'Gibraltar' },
    { label: '+30', country: 'Greece' },
    { label: '+299', country: 'Greenland' },
    { label: '+473', country: 'Grenada/Carricou' },
    { label: '+671', country: 'Guam' },
    { label: '+502', country: 'Guatemala' },
    { label: '+224', country: 'Guinea' },
    { label: '+245', country: 'Guinea-Bissau' },
    { label: '+592', country: 'Guyana' },
    { label: '+509', country: 'Haiti' },
    { label: '+504', country: 'Honduras' },
    { label: '+852', country: 'Hong Kong' },
    { label: '+36', country: 'Hungary' },
    { label: '+354', country: 'Iceland' },
    { label: '+91', country: 'India' },
    { label: '+62', country: 'Indonesia' },
    { label: '+98', country: 'Iran' },
    { label: '+964', country: 'Iraq' },
    { label: '+353', country: 'Ireland (Irish Republic; Eire)' },
    { label: '+972', country: 'Israel' },
    { label: '+39', country: 'Italy' },
    { label: '+225', country: "Ivory Coast (La Cote d'Ivoire)" },
    { label: '+876', country: 'Jamaica' },
    { label: '+81', country: 'Japan' },
    { label: '+962', country: 'Jordan' },
    { label: '+7', country: 'Kazakhstan' },
    { label: '+254', country: 'Kenya' },
    { label: '+855', country: 'Khmer Republic (Cambodia/Kampuchea)' },
    { label: '+686', country: 'Kiribati Republic (Gilbert Islands)' },
    { label: '+82', country: 'Korea, Republic of (South Korea)' },
    { label: '+850', country: "Korea, People's Republic of (North Korea)" },
    { label: '+965', country: 'Kuwait' },
    { label: '+996', country: 'Kyrgyz Republic' },
    { label: '+371', country: 'Latvia' },
    { label: '+856', country: 'Laos' },
    { label: '+961', country: 'Lebanon' },
    { label: '+266', country: 'Lesotho' },
    { label: '+231', country: 'Liberia' },
    { label: '+370', country: 'Lithuania' },
    { label: '+218', country: 'Libya' },
    { label: '+423', country: 'Liechtenstein' },
    { label: '+352', country: 'Luxembourg' },
    { label: '+853', country: 'Macao' },
    { label: '+389', country: 'Macedonia' },
    { label: '+261', country: 'Madagascar' },
    { label: '+265', country: 'Malawi' },
    { label: '+60', country: 'Malaysia' },
    { label: '+960', country: 'Maldives' },
    { label: '+223', country: 'Mali' },
    { label: '+356', country: 'Malta' },
    { label: '+692', country: 'Marshall Islands' },
    { label: '+596', country: 'Martinique (French Antilles)' },
    { label: '+222', country: 'Mauritania' },
    { label: '+230', country: 'Mauritius' },
    { label: '+269', country: 'Mayolte' },
    { label: '+52', country: 'Mexico' },
    { label: '+691', country: 'Micronesia (F.S. of Polynesia)' },
    { label: '+373', country: 'Moldova' },
    { label: '+33', country: 'Monaco' },
    { label: '+976', country: 'Mongolia' },
    { label: '+473', country: 'Montserrat' },
    { label: '+212', country: 'Morocco' },
    { label: '+258', country: 'Mozambique' },
    { label: '+95', country: 'Myanmar (former Burma)' },
    { label: '+264', country: 'Namibia (former South-West Africa)' },
    { label: '+674', country: 'Nauru' },
    { label: '+977', country: 'Nepal' },
    { label: '+31', country: 'Netherlands' },
    { label: '+599', country: 'Netherlands Antilles' },
    { label: '+869', country: 'Nevis' },
    { label: '+687', country: 'New Caledonia' },
    { label: '+64', country: 'New Zealand' },
    { label: '+505', country: 'Nicaragua' },
    { label: '+227', country: 'Niger' },
    { label: '+234', country: 'Nigeria' },
    { label: '+683', country: 'Niue' },
    { label: '+850', country: 'North Korea' },
    { label: '+1 670 ', country: 'North Mariana Islands (Saipan)' },
    { label: '+47', country: 'Norway' },
    { label: '+968', country: 'Oman' },
    { label: '+92', country: 'Pakistan' },
    { label: '+680', country: 'Palau' },
    { label: '+507', country: 'Panama' },
    { label: '+675', country: 'Papua New Guinea' },
    { label: '+595', country: 'Paraguay' },
    { label: '+51', country: 'Peru' },
    { label: '+63', country: 'Philippines' },
    { label: '+48', country: 'Poland' },
    { label: '+351', country: 'Portugal (includes Azores)' },
    { label: '+1 787 ', country: 'Puerto Rico' },
    { label: '+974', country: 'Qatar' },
    { label: '+262', country: 'Reunion (France)' },
    { label: '+40', country: 'Romania' },
    { label: '+7', country: 'Russia' },
    { label: '+250', country: 'Rwanda (Rwandese Republic)' },
    { label: '+670', country: 'Saipan' },
    { label: '+378', country: 'San Marino' },
    { label: '+239', country: 'Sao Tome and Principe' },
    { label: '+966', country: 'Saudi Arabia' },
    { label: '+221', country: 'Senegal' },
    { label: '+381', country: 'Serbia and Montenegro' },
    { label: '+248', country: 'Seychelles' },
    { label: '+232', country: 'Sierra Leone' },
    { label: '+65', country: 'Singapore' },
    { label: '+421', country: 'Slovakia' },
    { label: '+386', country: 'Slovenia' },
    { label: '+677', country: 'Solomon Islands' },
    { label: '+252', country: 'Somalia' },
    { label: '+27', country: 'South Africa' },
    { label: '+34', country: 'Spain' },
    { label: '+94', country: 'Sri Lanka' },
    { label: '+290', country: 'St. Helena' },
    { label: '+869', country: 'St. Kitts/Nevis' },
    { label: '+508', country: 'St. Pierre &(et) Miquelon (France)' },
    { label: '+249', country: 'Sudan' },
    { label: '+597', country: 'Suriname' },
    { label: '+268', country: 'Swaziland' },
    { label: '+46', country: 'Sweden' },
    { label: '+41', country: 'Switzerland' },
    { label: '+963', country: 'Syrian Arab Republic (Syria)' },
    { label: '+689', country: 'Tahiti (French Polynesia)' },
    { label: '+886', country: 'Taiwan' },
    { label: '+7', country: 'Tajikistan' },
    { label: '+255', country: 'Tanzania (includes Zanzibar)' },
    { label: '+66', country: 'Thailand' },
    { label: '+228', country: 'Togo (Togolese Republic)' },
    { label: '+690', country: 'Tokelau' },
    { label: '+676', country: 'Tonga' },
    { label: '+1 868', country: 'Trinidad and Tobago' },
    { label: '+216', country: 'Tunisia' },
    { label: '+90', country: 'Turkey' },
    { label: '+993', country: 'Turkmenistan' },
    { label: '+688', country: 'Tuvalu (Ellice Islands)' },
    { label: '+256', country: 'Uganda' },
    { label: '+380', country: 'Ukraine' },
    { label: '+971', country: 'United Arab Emirates' },
    { label: '+44', country: 'United Kingdom' },
    { label: '+598', country: 'Uruguay' },
    { label: '+1', country: 'USA' },
    { label: '+7', country: 'Uzbekistan' },
    { label: '+678', country: 'Vanuatu (New Hebrides)' },
    { label: '+39', country: 'Vatican City' },
    { label: '+58', country: 'Venezuela' },
    { label: '+84', country: 'Viet Nam' },
    { label: '+1 340', country: 'Virgin Islands' },
    { label: '+681', country: 'Wallis and Futuna' },
    { label: '+685', country: 'Western Samoa' },
    { label: '+381', country: "Yemen (People's Democratic Republic of)" },
    { label: '+967', country: 'Yemen Arab Republic (North Yemen)' },
    { label: '+381', country: 'Yugoslavia (discontinued)' },
    { label: '+243', country: 'Zaire' },
    { label: '+260', country: 'Zambia' },
    { label: '+263', country: 'Zimbabwe' }
];

class PhoneViewComponent {
    constructor(fb, loginActions, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.mfaSelfRegistrationActivated = input(false);
        this.hasLoginError = false;
        this.phoneCodes = PHONE_CODES;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.next:Next`,
            fn: this.onSubmit.bind(this)
        };
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.loginForm && hasLoginError) {
                this.loginForm.patchValue({ mobileNumber: '' });
                this.loginForm.markAsPristine();
            }
        }));
    }
    ngOnInit() {
        this.loginForm = this.fb.group({
            mobileNumber: ['', Validators.required],
            ...(this.mfaSelfRegistrationActivated() && { countryCodeIndicator: [this.phoneCodes[0], Validators.required] })
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    customSearchFn(term, item) {
        term = term.toLowerCase();
        return item.country.toLowerCase().includes(term) || item.label.toLowerCase().includes(term);
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm) {
            if (this.loginForm.valid) {
                const formValue = this.loginForm.value;
                this.loginActions.registerPhoneNumber({
                    ...this.loginInformation,
                    phoneNumber: formValue.mobileNumber,
                    ...(this.mfaSelfRegistrationActivated() && { countryCodeIndicator: formValue.countryCodeIndicator.label })
                });
                this.formErrorService.cleanError();
            }
            else {
                this.loginForm.markAllAsTouched();
                this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
            }
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    /**
     * returns whether it's Voice or SMS view
     */
    isSMSView() {
        return this.loginInformation?.selectedMFA?.id === MFA_ID.OTP_SMS;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PhoneViewComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: PhoneViewComponent, selector: "ama-ng-login-phone-view", inputs: { loginInformation: { classPropertyName: "loginInformation", publicName: "loginInformation", isSignal: false, isRequired: false, transformFunction: null }, mfaSelfRegistrationActivated: { classPropertyName: "mfaSelfRegistrationActivated", publicName: "mfaSelfRegistrationActivated", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<form [formGroup]=\"loginForm\">\n  @if (mfaSelfRegistrationActivated()) {\n    @if (isSMSView()) {\n      <div class=\"mb-5\" i18n=\"@@login.mobilenumber.description.sms\"\n        >Enter your phone number. You will receive a message with an authentication code.</div\n      >\n    } @else {\n      <div class=\"mb-5\" i18n=\"@@login.mobilenumber.description.voice\"\n        >Enter your phone number. You will receive a call with an authentication code.</div\n      >\n    }\n    <div class=\"mb-5\">\n      <label i18n=\"@@login.phoneNumber\" for=\"mobileNumberInput\" class=\"mb-3\">Phone number</label>\n      <label i18n=\"@@login.country.code.number\" id=\"country-code-number-label\" class=\"d-none\"\n        >Country code number</label\n      >\n      <div class=\"input-group mb-5\">\n        <ng-select\n          dfManageNavSelect\n          formControlName=\"countryCodeIndicator\"\n          [selectOnTab]=\"true\"\n          name=\"country-code-selection\"\n          [items]=\"phoneCodes\"\n          [searchable]=\"true\"\n          [clearable]=\"false\"\n          [searchFn]=\"customSearchFn\"\n          [inputAttrs]=\"{ 'aria-labelledby': 'country-code-number-label', autocomplete: 'off' }\"\n        >\n          <ng-template ng-option-tmp let-item=\"item\">\n            <span>{{ item.country }} {{ item.label }}</span>\n          </ng-template>\n        </ng-select>\n\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          id=\"mobileNumberInput\"\n          labelForId=\"mobileNumberInput\"\n          formControlName=\"mobileNumber\"\n          autocomplete=\"on\"\n          pattern=\"^[0-9]{4,18}$\"\n          [ngClass]=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors ? 'is-invalid' : ''\"\n        />\n        <div\n          i18n=\"@@login.mobileNumber.required\"\n          *ngIf=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors?.required\"\n          class=\"invalid-feedback\"\n          >Cell Phone is required</div\n        >\n        <div\n          i18n=\"@@login.mobileNumber.notvalid\"\n          *ngIf=\"\n            loginForm.get('mobileNumber').touched &&\n            !loginForm.get('mobileNumber').errors?.required &&\n            loginForm.get('mobileNumber').errors?.pattern\n          \"\n          class=\"invalid-feedback\"\n          >Enter a valid phone number</div\n        >\n      </div>\n    </div>\n  } @else {\n    <div class=\"mb-5\">\n      <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"usernameInput\"\n        [value]=\"loginInformation.username\"\n        readonly\n      />\n    </div>\n    <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n      <label i18n=\"@@login.officeId.label\" for=\"officeIdInput\">Office ID</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"officeIdInput\"\n        [value]=\"loginInformation.officeId\"\n        readonly\n      />\n    </div>\n\n    <div class=\"mb-5\">\n      <label for=\"mobileNumberInput\">\n        <ng-container i18n=\"@@login.mobileNumber.label\">Cell phone</ng-container>\n        <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n      </label>\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        id=\"mobileNumberInput\"\n        formControlName=\"mobileNumber\"\n        autocomplete=\"on\"\n        pattern=\"^\\+[1-9][0-9]{4,18}$\"\n        [ngClass]=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors ? 'is-invalid' : ''\"\n      />\n      <span class=\"text-secondary\" i18n=\"@@login.mobileNumber.coderequired\">Country and area codes are required</span>\n      <div\n        i18n=\"@@login.mobileNumber.required\"\n        *ngIf=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors?.required\"\n        class=\"invalid-feedback\"\n        >Cell Phone is required</div\n      >\n      <div\n        i18n=\"@@login.mobileNumber.notvalid\"\n        *ngIf=\"\n          loginForm.get('mobileNumber').touched &&\n          !loginForm.get('mobileNumber').errors?.required &&\n          loginForm.get('mobileNumber').errors?.pattern\n        \"\n        class=\"invalid-feedback\"\n        >Enter a valid phone number</div\n      >\n    </div>\n  }\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.PatternValidator, selector: "[pattern][formControlName],[pattern][formControl],[pattern][ngModel]", inputs: ["pattern"] }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i5.DfManageNavSelectDirective, selector: "[dfManageNavSelect]" }, { kind: "component", type: i6.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i6.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PhoneViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-phone-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"loginForm\">\n  @if (mfaSelfRegistrationActivated()) {\n    @if (isSMSView()) {\n      <div class=\"mb-5\" i18n=\"@@login.mobilenumber.description.sms\"\n        >Enter your phone number. You will receive a message with an authentication code.</div\n      >\n    } @else {\n      <div class=\"mb-5\" i18n=\"@@login.mobilenumber.description.voice\"\n        >Enter your phone number. You will receive a call with an authentication code.</div\n      >\n    }\n    <div class=\"mb-5\">\n      <label i18n=\"@@login.phoneNumber\" for=\"mobileNumberInput\" class=\"mb-3\">Phone number</label>\n      <label i18n=\"@@login.country.code.number\" id=\"country-code-number-label\" class=\"d-none\"\n        >Country code number</label\n      >\n      <div class=\"input-group mb-5\">\n        <ng-select\n          dfManageNavSelect\n          formControlName=\"countryCodeIndicator\"\n          [selectOnTab]=\"true\"\n          name=\"country-code-selection\"\n          [items]=\"phoneCodes\"\n          [searchable]=\"true\"\n          [clearable]=\"false\"\n          [searchFn]=\"customSearchFn\"\n          [inputAttrs]=\"{ 'aria-labelledby': 'country-code-number-label', autocomplete: 'off' }\"\n        >\n          <ng-template ng-option-tmp let-item=\"item\">\n            <span>{{ item.country }} {{ item.label }}</span>\n          </ng-template>\n        </ng-select>\n\n        <input\n          type=\"text\"\n          class=\"form-control\"\n          id=\"mobileNumberInput\"\n          labelForId=\"mobileNumberInput\"\n          formControlName=\"mobileNumber\"\n          autocomplete=\"on\"\n          pattern=\"^[0-9]{4,18}$\"\n          [ngClass]=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors ? 'is-invalid' : ''\"\n        />\n        <div\n          i18n=\"@@login.mobileNumber.required\"\n          *ngIf=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors?.required\"\n          class=\"invalid-feedback\"\n          >Cell Phone is required</div\n        >\n        <div\n          i18n=\"@@login.mobileNumber.notvalid\"\n          *ngIf=\"\n            loginForm.get('mobileNumber').touched &&\n            !loginForm.get('mobileNumber').errors?.required &&\n            loginForm.get('mobileNumber').errors?.pattern\n          \"\n          class=\"invalid-feedback\"\n          >Enter a valid phone number</div\n        >\n      </div>\n    </div>\n  } @else {\n    <div class=\"mb-5\">\n      <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"usernameInput\"\n        [value]=\"loginInformation.username\"\n        readonly\n      />\n    </div>\n    <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n      <label i18n=\"@@login.officeId.label\" for=\"officeIdInput\">Office ID</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"officeIdInput\"\n        [value]=\"loginInformation.officeId\"\n        readonly\n      />\n    </div>\n\n    <div class=\"mb-5\">\n      <label for=\"mobileNumberInput\">\n        <ng-container i18n=\"@@login.mobileNumber.label\">Cell phone</ng-container>\n        <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n      </label>\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        id=\"mobileNumberInput\"\n        formControlName=\"mobileNumber\"\n        autocomplete=\"on\"\n        pattern=\"^\\+[1-9][0-9]{4,18}$\"\n        [ngClass]=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors ? 'is-invalid' : ''\"\n      />\n      <span class=\"text-secondary\" i18n=\"@@login.mobileNumber.coderequired\">Country and area codes are required</span>\n      <div\n        i18n=\"@@login.mobileNumber.required\"\n        *ngIf=\"loginForm.get('mobileNumber').touched && loginForm.get('mobileNumber').errors?.required\"\n        class=\"invalid-feedback\"\n        >Cell Phone is required</div\n      >\n      <div\n        i18n=\"@@login.mobileNumber.notvalid\"\n        *ngIf=\"\n          loginForm.get('mobileNumber').touched &&\n          !loginForm.get('mobileNumber').errors?.required &&\n          loginForm.get('mobileNumber').errors?.pattern\n        \"\n        class=\"invalid-feedback\"\n        >Enter a valid phone number</div\n      >\n    </div>\n  }\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }], propDecorators: { loginInformation: [{
                type: Input
            }] } });

class PhoneCodeViewComponent {
    constructor(fb, loginActions, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.mfaSelfRegistrationActivated = input(false);
        this.hasLoginError = false;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.verify:Verify and sign-in`,
            fn: this.onSubmit.bind(this)
        };
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.loginForm && hasLoginError) {
                this.loginForm.patchValue({ password: '' });
                this.loginForm.markAsPristine();
                if (this.mfaSelfRegistrationActivated()) {
                    this.loginForm.get('otp')?.reset();
                }
            }
        }));
    }
    ngOnInit() {
        if (this.mfaSelfRegistrationActivated()) {
            const controls = [];
            for (let i = 0; i < 6; i++) {
                controls.push(this.fb.control('', [Validators.required, Validators.maxLength(1)]));
            }
            this.loginForm = this.fb.group({
                ...(this.mfaSelfRegistrationActivated() && { otp: this.fb.array(controls) })
            });
        }
        else {
            this.rightButton.label = $localize `:@@login.signin:Sign in`;
            this.loginForm = this.fb.group({
                validationCode: ['', Validators.required],
                password: ['', Validators.required]
            });
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    obfuscatePhoneNumber() {
        const obfuscatedCountryCode = this.loginInformation.countryCodeIndicator?.replace(/\d/g, 'X');
        const obfuscatedPhoneNumber = this.loginInformation.phoneNumber?.replace(/\d(?=\d{2})/g, 'X');
        return `${obfuscatedCountryCode} ${obfuscatedPhoneNumber}`;
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm.valid) {
            const formValue = this.loginForm.value;
            this.loginActions.loginWithPhoneValidationCode({
                ...this.loginInformation,
                ...(this.mfaSelfRegistrationActivated()
                    ? { validationCode: formValue.otp.join('').toUpperCase() }
                    : { password: formValue.password, validationCode: formValue.validationCode })
            });
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
        }
    }
    /**
     * On back from phone code.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PhoneCodeViewComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: PhoneCodeViewComponent, selector: "ama-ng-login-phone-code-view", inputs: { loginInformation: { classPropertyName: "loginInformation", publicName: "loginInformation", isSignal: false, isRequired: false, transformFunction: null }, mfaSelfRegistrationActivated: { classPropertyName: "mfaSelfRegistrationActivated", publicName: "mfaSelfRegistrationActivated", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<form [formGroup]=\"loginForm\">\n  @if (mfaSelfRegistrationActivated()) {\n    <div class=\"form-label\" i18n=\"@@login.phone.code.description\"\n      >Enter the authentication code you received on {{ obfuscatePhoneNumber() }}</div\n    >\n    <div class=\"mb-5\">\n      <ama-ng-otp-code-view [parentForm]=\"loginForm\" [otpForm]=\"loginForm.get('otp')\"></ama-ng-otp-code-view>\n    </div>\n  } @else {\n    <div class=\"mb-5\">\n      <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"usernameInput\"\n        [value]=\"loginInformation.username\"\n        readonly\n      />\n    </div>\n    <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n      <label i18n=\"@@login.officeId.label\" for=\"officeIdInput\">Office ID</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"officeIdInput\"\n        [value]=\"loginInformation.officeId\"\n        readonly\n      />\n    </div>\n    <div class=\"mb-5\">\n      <label for=\"codeInput\">\n        <ng-container i18n=\"@@login.validationCode.label\">Verification code</ng-container>\n        <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n      </label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"codeInput\"\n        formControlName=\"validationCode\"\n        autocomplete=\"off\"\n        [ngClass]=\"\n          loginForm.get('validationCode').touched && loginForm.get('validationCode').errors ? 'is-invalid' : ''\n        \"\n      />\n      <div\n        i18n=\"@@login.validationCode.required\"\n        *ngIf=\"loginForm.get('validationCode').touched && loginForm.get('validationCode').errors?.required\"\n        class=\"invalid-feedback\"\n        >Verification code is required</div\n      >\n    </div>\n    <ama-ng-login-advanced-password\n      [parentForm]=\"loginForm\"\n      [passwordForm]=\"loginForm.get('password')\"\n    ></ama-ng-login-advanced-password>\n  }\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: OtpCodeViewComponent, selector: "ama-ng-otp-code-view", inputs: ["parentForm", "otpForm"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }, { kind: "component", type: AdvancedPasswordComponent, selector: "ama-ng-login-advanced-password", inputs: ["parentForm", "passwordForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: PhoneCodeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-phone-code-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"loginForm\">\n  @if (mfaSelfRegistrationActivated()) {\n    <div class=\"form-label\" i18n=\"@@login.phone.code.description\"\n      >Enter the authentication code you received on {{ obfuscatePhoneNumber() }}</div\n    >\n    <div class=\"mb-5\">\n      <ama-ng-otp-code-view [parentForm]=\"loginForm\" [otpForm]=\"loginForm.get('otp')\"></ama-ng-otp-code-view>\n    </div>\n  } @else {\n    <div class=\"mb-5\">\n      <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"usernameInput\"\n        [value]=\"loginInformation.username\"\n        readonly\n      />\n    </div>\n    <div class=\"mb-5\" *ngIf=\"loginInformation.officeId\">\n      <label i18n=\"@@login.officeId.label\" for=\"officeIdInput\">Office ID</label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"officeIdInput\"\n        [value]=\"loginInformation.officeId\"\n        readonly\n      />\n    </div>\n    <div class=\"mb-5\">\n      <label for=\"codeInput\">\n        <ng-container i18n=\"@@login.validationCode.label\">Verification code</ng-container>\n        <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n      </label>\n      <input\n        type=\"text\"\n        class=\"form-control text-uppercase\"\n        id=\"codeInput\"\n        formControlName=\"validationCode\"\n        autocomplete=\"off\"\n        [ngClass]=\"\n          loginForm.get('validationCode').touched && loginForm.get('validationCode').errors ? 'is-invalid' : ''\n        \"\n      />\n      <div\n        i18n=\"@@login.validationCode.required\"\n        *ngIf=\"loginForm.get('validationCode').touched && loginForm.get('validationCode').errors?.required\"\n        class=\"invalid-feedback\"\n        >Verification code is required</div\n      >\n    </div>\n    <ama-ng-login-advanced-password\n      [parentForm]=\"loginForm\"\n      [passwordForm]=\"loginForm.get('password')\"\n    ></ama-ng-login-advanced-password>\n  }\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }], propDecorators: { loginInformation: [{
                type: Input
            }] } });

class JumpLoginComponent {
    constructor(store, fb, loginActions, formErrorService) {
        this.store = store;
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.clpErrors = false;
        this.jumpLoginState = JumpLoginState;
        this.subscription = new Subscription();
        this.requestStatusService = inject(RequestStatusService);
        this.isClpReady = false;
        this.isRequestOnGoing = false;
        this.loginForm = this.fb.group({
            username: ['', [Validators.required, Validators.pattern(USERNAME_REGEXP)]],
            officeId: ['', [Validators.required, Validators.pattern(OFFICE_ID_REGEXP)]]
        });
        this.jumpLoginState$ = this.store.pipe(select(getJumpLoginUiState));
        this.subscription.add(this.jumpLoginState$.subscribe((uiState) => {
            if (uiState === JumpLoginState.otpNeededJump) {
                this.loginForm.addControl('otp', this.fb.control('', Validators.required));
            }
        }));
        this.subscription.add(this.jumpLoginState$.subscribe((uiState) => {
            if (uiState === JumpLoginState.ottNeededJump) {
                this.loginForm.addControl('ott', this.fb.control('', Validators.required));
            }
        }));
        this.subscription.add(this.requestStatusService.isRequestOnGoing$.subscribe((isRequestOnGoing) => (this.isRequestOnGoing = isRequestOnGoing)));
        this.subscription.add(this.requestStatusService.isClpReady$.subscribe((isClpReady) => (this.isClpReady = isClpReady)));
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.clpErrors = hasLoginError;
            if (hasLoginError) {
                this.loginForm.patchValue({ password: '' });
            }
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.loginActions.resetTokens();
    }
    /*  /**
     * On Submit.
     * @param form
     */
    onSubmit(form) {
        const tokens = this.loginActions.getTokens();
        if (!this.isRequestOnGoing) {
            if (form.valid && tokens) {
                const formValue = form.value;
                this.loginActions.jumpLoginRequest(this.loginInfo.username, {
                    username: formValue.username.toUpperCase(),
                    officeId: formValue.officeId.toUpperCase(),
                    otp: formValue.otp || '',
                    ott: formValue.ott || ''
                }, tokens);
                this.formErrorService.cleanError();
            }
            else {
                form.markAllAsTouched();
                this.formErrorService.updateError(this.formErrorService.getFieldsInError(form));
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: JumpLoginComponent, deps: [{ token: i1.Store }, { token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: JumpLoginComponent, selector: "ama-ng-jump-login", inputs: { loginInfo: "loginInfo" }, ngImport: i0, template: "<form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit(loginForm)\">\n  <p>\n    <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\" *ngIf=\"(jumpLoginState$ | async) === jumpLoginState.otpNeededJump\">\n    <label for=\"otpInput\">\n      <ng-container i18n=\"@@login.otp.label\">One-time password</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      id=\"otpInput\"\n      autocomplete=\"off\"\n      formControlName=\"otp\"\n      [ngClass]=\"loginForm.get('otp').touched && loginForm.get('otp').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.otp.required\"\n      *ngIf=\"loginForm.get('otp').touched && loginForm.get('otp').errors?.required\"\n      class=\"invalid-feedback\"\n      >One-time Password is required</div\n    >\n  </div>\n  <div class=\"mb-5\" *ngIf=\"(jumpLoginState$ | async) === jumpLoginState.ottNeededJump\">\n    <label for=\"ottInput\">\n      <ng-container i18n=\"@@login.ott.label\">One-time token</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      id=\"ottInput\"\n      autocomplete=\"off\"\n      formControlName=\"ott\"\n      [ngClass]=\"loginForm.get('ott').touched && loginForm.get('ott').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.ott.required\"\n      *ngIf=\"loginForm.get('ott').touched && loginForm.get('ott').errors?.required\"\n      class=\"invalid-feedback\"\n      >One-time Token is required</div\n    >\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginForm.get('username') as usernameForm\">\n    <label for=\"usernameInput\">\n      <ng-container i18n=\"@@login.username.label\">Username</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      formControlName=\"username\"\n      autocomplete=\"off\"\n      [ngClass]=\"usernameForm.touched && usernameForm.errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.username.required\"\n      *ngIf=\"usernameForm.touched && usernameForm.errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter a username</div\n    >\n    <div\n      i18n=\"@@login.username.pattern\"\n      *ngIf=\"usernameForm.touched && usernameForm.errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Username has an invalid format\n    </div>\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginForm.get('officeId') as officeIdForm\">\n    <label for=\"officeIdInput\">\n      <ng-container i18n=\"@@login.officeId.label\">Office ID</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"officeIdInput\"\n      formControlName=\"officeId\"\n      autocomplete=\"off\"\n      [ngClass]=\"officeIdForm.touched && officeIdForm.errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n    <div\n      i18n=\"@@login.officeId.pattern\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Enter an office ID (9 alphanumeric characters)</div\n    >\n  </div>\n  <div class=\"mt-6 mb-5 text-end d-grid\">\n    <button [disabled]=\"!isClpReady\" type=\"submit\" class=\"btn btn-primary btn-lg\">\n      <ng-container i18n=\"@@login.jumpLogin.send\">Log in</ng-container>\n      <ng-container *ngIf=\"(!isClpReady || isRequestOnGoing) && !clpErrors\">\n        <span class=\"df-spinner-border-dark spinner-border-sm text-light ms-3\" role=\"status\" aria-hidden=\"true\"></span>\n        <span class=\"visually-hidden\" i18n=\"@@login.request.ongoing\">Loading...</span>\n      </ng-container>\n    </button>\n  </div>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: JumpLoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-jump-login', template: "<form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit(loginForm)\">\n  <p>\n    <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\" *ngIf=\"(jumpLoginState$ | async) === jumpLoginState.otpNeededJump\">\n    <label for=\"otpInput\">\n      <ng-container i18n=\"@@login.otp.label\">One-time password</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      id=\"otpInput\"\n      autocomplete=\"off\"\n      formControlName=\"otp\"\n      [ngClass]=\"loginForm.get('otp').touched && loginForm.get('otp').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.otp.required\"\n      *ngIf=\"loginForm.get('otp').touched && loginForm.get('otp').errors?.required\"\n      class=\"invalid-feedback\"\n      >One-time Password is required</div\n    >\n  </div>\n  <div class=\"mb-5\" *ngIf=\"(jumpLoginState$ | async) === jumpLoginState.ottNeededJump\">\n    <label for=\"ottInput\">\n      <ng-container i18n=\"@@login.ott.label\">One-time token</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control\"\n      id=\"ottInput\"\n      autocomplete=\"off\"\n      formControlName=\"ott\"\n      [ngClass]=\"loginForm.get('ott').touched && loginForm.get('ott').errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.ott.required\"\n      *ngIf=\"loginForm.get('ott').touched && loginForm.get('ott').errors?.required\"\n      class=\"invalid-feedback\"\n      >One-time Token is required</div\n    >\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginForm.get('username') as usernameForm\">\n    <label for=\"usernameInput\">\n      <ng-container i18n=\"@@login.username.label\">Username</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      formControlName=\"username\"\n      autocomplete=\"off\"\n      [ngClass]=\"usernameForm.touched && usernameForm.errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.username.required\"\n      *ngIf=\"usernameForm.touched && usernameForm.errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter a username</div\n    >\n    <div\n      i18n=\"@@login.username.pattern\"\n      *ngIf=\"usernameForm.touched && usernameForm.errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Username has an invalid format\n    </div>\n  </div>\n  <div class=\"mb-5\" *ngIf=\"loginForm.get('officeId') as officeIdForm\">\n    <label for=\"officeIdInput\">\n      <ng-container i18n=\"@@login.officeId.label\">Office ID</ng-container>\n      <span class=\"mandatory-indicator\" aria-hidden=\"true\">*</span>\n    </label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"officeIdInput\"\n      formControlName=\"officeId\"\n      autocomplete=\"off\"\n      [ngClass]=\"officeIdForm.touched && officeIdForm.errors ? 'is-invalid' : ''\"\n    />\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n    <div\n      i18n=\"@@login.officeId.pattern\"\n      *ngIf=\"officeIdForm.touched && officeIdForm.errors?.pattern\"\n      class=\"invalid-feedback\"\n      >Enter an office ID (9 alphanumeric characters)</div\n    >\n  </div>\n  <div class=\"mt-6 mb-5 text-end d-grid\">\n    <button [disabled]=\"!isClpReady\" type=\"submit\" class=\"btn btn-primary btn-lg\">\n      <ng-container i18n=\"@@login.jumpLogin.send\">Log in</ng-container>\n      <ng-container *ngIf=\"(!isClpReady || isRequestOnGoing) && !clpErrors\">\n        <span class=\"df-spinner-border-dark spinner-border-sm text-light ms-3\" role=\"status\" aria-hidden=\"true\"></span>\n        <span class=\"visually-hidden\" i18n=\"@@login.request.ongoing\">Loading...</span>\n      </ng-container>\n    </button>\n  </div>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1.Store }, { type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }], propDecorators: { loginInfo: [{
                type: Input
            }] } });

class OfficeListComponent {
    constructor(fb, loginActions, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.send:Sign in`,
            fn: this.onSubmit.bind(this)
        };
        this.officeForm = this.fb.group({
            officeId: ['', [Validators.required]]
        });
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.officeForm.valid) {
            const loginInformation = { ...this.loginInformation, officeId: this.officeForm.value.officeId };
            this.loginActions.loginWithOfficeId(loginInformation);
            this.formErrorService.cleanError();
        }
        else {
            this.officeForm.markAllAsTouched();
            this.officeListSelect.nativeElement.focus();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.officeForm));
        }
    }
    /**
     * On back.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OfficeListComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: OfficeListComponent, selector: "ama-ng-login-office-list", inputs: { loginInformation: "loginInformation", officeList: "officeList" }, viewQueries: [{ propertyName: "officeListSelect", first: true, predicate: ["officeListSelect"], descendants: true }], ngImport: i0, template: "<form [formGroup]=\"officeForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      [value]=\"loginInformation.username\"\n      readonly\n    />\n  </div>\n  <div class=\"mb-5\">\n    <label for=\"officeId\" class=\"form-label\">\n      <ng-container i18n=\"@@login.officeId.select\">Please select an office ID</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <select\n      class=\"form-select\"\n      id=\"officeId\"\n      #officeListSelect\n      formControlName=\"officeId\"\n      [ngClass]=\"officeForm.get('officeId').touched && officeForm.get('officeId').errors ? 'is-invalid' : ''\"\n    >\n      <option *ngFor=\"let office of officeList\" value=\"{{ office }}\">{{ office }}</option>\n    </select>\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"officeForm.get('officeId').touched && officeForm.get('officeId').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n  </div>\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: OfficeListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login-office-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"officeForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <div class=\"mb-5\">\n    <label i18n=\"@@login.username.label\" for=\"usernameInput\">Username</label>\n    <input\n      type=\"text\"\n      class=\"form-control text-uppercase\"\n      id=\"usernameInput\"\n      [value]=\"loginInformation.username\"\n      readonly\n    />\n  </div>\n  <div class=\"mb-5\">\n    <label for=\"officeId\" class=\"form-label\">\n      <ng-container i18n=\"@@login.officeId.select\">Please select an office ID</ng-container>\n      <span class=\"mandatory-indicator\">*</span>\n    </label>\n    <select\n      class=\"form-select\"\n      id=\"officeId\"\n      #officeListSelect\n      formControlName=\"officeId\"\n      [ngClass]=\"officeForm.get('officeId').touched && officeForm.get('officeId').errors ? 'is-invalid' : ''\"\n    >\n      <option *ngFor=\"let office of officeList\" value=\"{{ office }}\">{{ office }}</option>\n    </select>\n    <div\n      i18n=\"@@login.officeId.required\"\n      *ngIf=\"officeForm.get('officeId').touched && officeForm.get('officeId').errors?.required\"\n      class=\"invalid-feedback\"\n      >Enter an office ID</div\n    >\n  </div>\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }], propDecorators: { officeListSelect: [{
                type: ViewChild,
                args: ['officeListSelect']
            }], loginInformation: [{
                type: Input
            }], officeList: [{
                type: Input
            }] } });

class ConfirmDDNAMfaPopupComponent {
    constructor() {
        this.localStorageService = inject(LocalStorageService);
    }
    digitalDNADownloaded() {
        this.localStorageService.setItem(DDNA_DOWNLOADED, true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfirmDDNAMfaPopupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.12", type: ConfirmDDNAMfaPopupComponent, isStandalone: true, selector: "app-confirm-ddna-mfa-popup", ngImport: i0, template: `
    <div class="mb-5"
      ><strong i18n="@@login.mfa-self-selection.confirmation-popup.ddna.sub-title"
        >You’re about to set Digital DNA as your authentication method:</strong
      ></div
    >
    <div>
      <ul>
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description1"
          >Digital DNA extension is required:
          <a
            href="https://www.accounts.sellingplatformconnect.amadeus.com/LoginService/ddna/plugins/win32/DigitalDNA.msi"
            (click)="digitalDNADownloaded()"
            >Install Digital DNA</a
          ></li
        >
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description2"
          >Once selected, only the registered device will have sign-in access with your credentials</li
        >
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description3"
          >Admin access to the system is required</li
        >
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description4"
          >Only Windows is supported (with Chrome, Edge or Firefox)</li
        >
      </ul>
    </div>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfirmDDNAMfaPopupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-confirm-ddna-mfa-popup',
                    template: `
    <div class="mb-5"
      ><strong i18n="@@login.mfa-self-selection.confirmation-popup.ddna.sub-title"
        >You’re about to set Digital DNA as your authentication method:</strong
      ></div
    >
    <div>
      <ul>
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description1"
          >Digital DNA extension is required:
          <a
            href="https://www.accounts.sellingplatformconnect.amadeus.com/LoginService/ddna/plugins/win32/DigitalDNA.msi"
            (click)="digitalDNADownloaded()"
            >Install Digital DNA</a
          ></li
        >
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description2"
          >Once selected, only the registered device will have sign-in access with your credentials</li
        >
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description3"
          >Admin access to the system is required</li
        >
        <li i18n="@@login.mfa-self-selection.confirmation-popup.ddna.description4"
          >Only Windows is supported (with Chrome, Edge or Firefox)</li
        >
      </ul>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }] });

class ConfirmPhoneMfaPopupComponent {
    constructor() {
        this.isSMS = input(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfirmPhoneMfaPopupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.12", type: ConfirmPhoneMfaPopupComponent, isStandalone: true, selector: "app-confirm-phone-mfa-popup", inputs: { isSMS: { classPropertyName: "isSMS", publicName: "isSMS", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: ` <div class="mb-5">
      <strong i18n="@@login.mfa-self-selection.confirmation-popup.phone.sub-title"
        >You're about to set {{ isSMS ? 'SMS' : 'voice call' }} as your authentication method:</strong
      >
    </div>
    <div>
      <ul>
        <li i18n="@@login.mfa-self-selection.confirmation-popup.phone.description1">
          Once selected, only support teams can modify this option
        </li>
        <li i18n="@@login.mfa-self-selection.confirmation-popup.phone.description2">
          {{ isSMS ? 'SMS text messages' : 'Voice calls' }} are less secure and reliable than other authentication
          methods
        </li>
      </ul>
    </div>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: ConfirmPhoneMfaPopupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-confirm-phone-mfa-popup',
                    template: ` <div class="mb-5">
      <strong i18n="@@login.mfa-self-selection.confirmation-popup.phone.sub-title"
        >You're about to set {{ isSMS ? 'SMS' : 'voice call' }} as your authentication method:</strong
      >
    </div>
    <div>
      <ul>
        <li i18n="@@login.mfa-self-selection.confirmation-popup.phone.description1">
          Once selected, only support teams can modify this option
        </li>
        <li i18n="@@login.mfa-self-selection.confirmation-popup.phone.description2">
          {{ isSMS ? 'SMS text messages' : 'Voice calls' }} are less secure and reliable than other authentication
          methods
        </li>
      </ul>
    </div>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true
                }]
        }] });

class MfaSelfSelectionViewComponent {
    set mfaAvailable(value) {
        this._mfaAvailable = this.isSafari() || !this.isWindows() ? value.filter((mfa) => mfa.id !== MFA_ID.DDNA) : value;
        this._mfaAvailable = [...this.mfaAvailable].sort((a, b) => this.mfaIndexSort.indexOf(a.id) < this.mfaIndexSort.indexOf(b.id) ? -1 : 1);
        this.selectedMfa = this._mfaAvailable[0];
    }
    get mfaAvailable() {
        return this._mfaAvailable;
    }
    constructor() {
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this),
            'data-testid': 'cancelMfaSelfSelectionButton'
        };
        this.rightButton = {
            label: $localize `:@@login.next:Next`,
            fn: this.onSubmitMfa.bind(this),
            'data-testid': 'submitMfaSelfSelectionButton'
        };
        this.loginInformation = {};
        this._mfaAvailable = [];
        this.MFA_ID = MFA_ID;
        this.mfaDescriptions = {
            [MFA_ID.TOTP]: {
                title: $localize `:@@login.mfa-self-selection.select.totp.title:Authenticator app`,
                description: $localize `:@@login.mfa-self-selection.select.totp.description:Receive a code in your app`
            },
            [MFA_ID.DDNA]: {
                title: $localize `:@@login.mfa-self-selection.select.ddna.title:Digital DNA`,
                description: $localize `:@@login.mfa-self-selection.select.ddna.description:Install a browser extension `,
                modal: {
                    title: $localize `:@@login.mfa-self-selection.confirmation-popup.ddna.title:Select Digital DNA method?`,
                    class: ConfirmDDNAMfaPopupComponent
                }
            },
            [MFA_ID.OTP_SMS]: {
                title: $localize `:@@login.mfa-self-selection.select.sms.title:SMS`,
                description: $localize `:@@login.mfa-self-selection.select.sms.description:Receive a code in your cell phone`,
                modal: {
                    title: $localize `:@@login.mfa-self-selection.confirmation-popup.sms.title:Select SMS Method?`,
                    class: ConfirmPhoneMfaPopupComponent,
                    bodyComponentData: {
                        isSMS: true
                    }
                }
            },
            [MFA_ID.OTP_VOICE_CALL]: {
                title: $localize `:@@login.mfa-self-selection.select.voice.title:Voice call`,
                description: $localize `:@@login.mfa-self-selection.select.voice.description:Receive a call providing a code`,
                modal: {
                    title: $localize `:@@login.mfa-self-selection.confirmation-popup.voice.title:Select voice call method?`,
                    class: ConfirmPhoneMfaPopupComponent,
                    bodyComponentData: {
                        isSMS: false
                    }
                }
            }
        };
        this.loginActions = inject(LoginActionsService);
        this.modal = inject(ModalManagerService);
        this.localStorageService = inject(LocalStorageService);
        const isDDNAJustDownloaded = this.localStorageService.getItem(DDNA_DOWNLOADED);
        this.mfaIndexSort = isDDNAJustDownloaded
            ? [MFA_ID.DDNA, MFA_ID.TOTP, MFA_ID.OTP_VOICE_CALL, MFA_ID.OTP_SMS]
            : [MFA_ID.TOTP, MFA_ID.DDNA, MFA_ID.OTP_VOICE_CALL, MFA_ID.OTP_SMS];
    }
    onSubmitMfa() {
        if (this.selectedMfa) {
            if (this.mfaDescriptions[this.selectedMfa.id]?.modal) {
                const modalInfos = this.mfaDescriptions[this.selectedMfa.id]?.modal;
                modalInfos &&
                    this.modal.createModalInSeco(modalInfos.title, modalInfos.class, [
                        {
                            label: $localize `:@@login.mfa-self-selection.confirmation-popup.cancel:Select another method`,
                            btnClass: 'outline-primary'
                        },
                        {
                            label: $localize `:@@login.mfa-self-selection.confirmation-popup.confirm:Select anyway`,
                            btnClass: 'primary',
                            callbackFunction: () => this.selectedMfa && this.loginActions.setSelectedMFA(this.selectedMfa)
                        }
                    ], {
                        topCross: true,
                        alertType: 'warning'
                    }, modalInfos.bodyComponentData);
            }
            else {
                this.loginActions.setSelectedMFA(this.selectedMfa);
            }
        }
    }
    onBack() {
        this.loginActions.changeAccount();
    }
    isSafari() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('safari') && !ua.includes('chrome');
    }
    isWindows() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('win');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MfaSelfSelectionViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: MfaSelfSelectionViewComponent, selector: "ama-ng-mfa-self-selection-view", inputs: { loginInformation: "loginInformation", mfaAvailable: "mfaAvailable" }, ngImport: i0, template: "<div class=\"d-flex flex-column\">\n  <label for=\"lbl-mfa-selection\" class=\"mb-3 h-4\" i18n=\"@@newlogin.selectedMFA.subtitle\"\n    >Select an authentification method</label\n  >\n  <ng-select\n    labelForId=\"lbl-mfa-selection\"\n    id=\"mfa-selection\"\n    [selectOnTab]=\"true\"\n    name=\"mfa-selection\"\n    [items]=\"mfaAvailable\"\n    [searchable]=\"false\"\n    [clearable]=\"false\"\n    [(ngModel)]=\"selectedMfa\"\n    class=\"mb-5 mfa-dropdown\"\n  >\n    <ng-template ng-label-tmp let-item=\"item\">\n      <div id=\"mfa-selected-item\" class=\"text-truncate\">\n        <span>{{ mfaDescriptions[item.id]?.title }}</span>\n        @if (item.id === MFA_ID.TOTP) {\n          <span class=\"badge rounded-pill bg-info mx-2\" i18n=\"@@login.recommended\">Recommended</span>\n        }\n        <span class=\"text-muted\" [ngClass]=\"item.id !== MFA_ID.TOTP ? 'ms-2' : ''\">{{\n          mfaDescriptions[item.id]?.description\n        }}</span></div\n      >\n    </ng-template>\n    <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\">\n      <div id=\"mfa-selection-item-{{ index }}\" class=\"text-truncate\"\n        ><span> {{ mfaDescriptions[item.id]?.title }}</span>\n        @if (item.id === MFA_ID.TOTP) {\n          <span class=\"badge rounded-pill bg-info mx-2\" i18n=\"@@login.recommended\">Recommended</span>\n        }\n        <span [ngClass]=\"item.id !== MFA_ID.TOTP ? 'ms-2' : ''\">{{ mfaDescriptions[item.id]?.description }}</span></div\n      >\n    </ng-template>\n  </ng-select>\n\n  <a\n    class=\"df-link-external mb-5\"\n    i18n=\"@@login.learnMore\"\n    href=\"https://servicehub.amadeus.com/c/portal/view-solution/1208191064\"\n    target=\"_blank\"\n    rel=\"noopener noreferrer\"\n    >Learn more</a\n  >\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</div>\n", styles: [".ng-select.mfa-dropdown ::ng-deep .ng-dropdown-panel{max-width:100%}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i6.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "ariaLabel", "markFirst", "placeholder", "fixedPlaceholder", "notFoundText", "typeToSearchText", "preventToggleOnRightClick", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "ngClass", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick", "keyDownFn"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i6.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "directive", type: i6.NgLabelTemplateDirective, selector: "[ng-label-tmp]" }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: MfaSelfSelectionViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-mfa-self-selection-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex flex-column\">\n  <label for=\"lbl-mfa-selection\" class=\"mb-3 h-4\" i18n=\"@@newlogin.selectedMFA.subtitle\"\n    >Select an authentification method</label\n  >\n  <ng-select\n    labelForId=\"lbl-mfa-selection\"\n    id=\"mfa-selection\"\n    [selectOnTab]=\"true\"\n    name=\"mfa-selection\"\n    [items]=\"mfaAvailable\"\n    [searchable]=\"false\"\n    [clearable]=\"false\"\n    [(ngModel)]=\"selectedMfa\"\n    class=\"mb-5 mfa-dropdown\"\n  >\n    <ng-template ng-label-tmp let-item=\"item\">\n      <div id=\"mfa-selected-item\" class=\"text-truncate\">\n        <span>{{ mfaDescriptions[item.id]?.title }}</span>\n        @if (item.id === MFA_ID.TOTP) {\n          <span class=\"badge rounded-pill bg-info mx-2\" i18n=\"@@login.recommended\">Recommended</span>\n        }\n        <span class=\"text-muted\" [ngClass]=\"item.id !== MFA_ID.TOTP ? 'ms-2' : ''\">{{\n          mfaDescriptions[item.id]?.description\n        }}</span></div\n      >\n    </ng-template>\n    <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\">\n      <div id=\"mfa-selection-item-{{ index }}\" class=\"text-truncate\"\n        ><span> {{ mfaDescriptions[item.id]?.title }}</span>\n        @if (item.id === MFA_ID.TOTP) {\n          <span class=\"badge rounded-pill bg-info mx-2\" i18n=\"@@login.recommended\">Recommended</span>\n        }\n        <span [ngClass]=\"item.id !== MFA_ID.TOTP ? 'ms-2' : ''\">{{ mfaDescriptions[item.id]?.description }}</span></div\n      >\n    </ng-template>\n  </ng-select>\n\n  <a\n    class=\"df-link-external mb-5\"\n    i18n=\"@@login.learnMore\"\n    href=\"https://servicehub.amadeus.com/c/portal/view-solution/1208191064\"\n    target=\"_blank\"\n    rel=\"noopener noreferrer\"\n    >Learn more</a\n  >\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</div>\n", styles: [".ng-select.mfa-dropdown ::ng-deep .ng-dropdown-panel{max-width:100%}\n"] }]
        }], ctorParameters: () => [], propDecorators: { loginInformation: [{
                type: Input
            }], mfaAvailable: [{
                type: Input
            }] } });

class TotpViewComponent {
    constructor(fb, loginActions, formErrorService) {
        this.fb = fb;
        this.loginActions = loginActions;
        this.formErrorService = formErrorService;
        this.loginInformation = input();
        this.hasLoginError = false;
        this.leftButton = {
            label: $localize `:@@login.back:Cancel`,
            fn: this.onBack.bind(this)
        };
        this.rightButton = {
            label: $localize `:@@login.verify:Verify and sign-in`,
            fn: this.onSubmit.bind(this),
            'data-testid': 'verify-signin'
        };
        this.requestStatusService = inject(RequestStatusService);
        this.subscription = new Subscription();
        this.subscription.add(this.requestStatusService.hasLoginErrors$.subscribe((hasLoginError) => {
            this.hasLoginError = hasLoginError;
            if (this.loginForm && hasLoginError) {
                this.loginForm.patchValue({ password: '' });
                this.loginForm.markAsPristine();
                this.loginForm.get('totp')?.reset();
            }
        }));
    }
    ngOnInit() {
        const controls = [];
        for (let i = 0; i < 6; i++) {
            controls.push(this.fb.control('', [Validators.required, Validators.maxLength(1)]));
        }
        this.loginForm = this.fb.group({
            totp: this.fb.array(controls),
            password: ['', Validators.required]
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * On Submit.
     */
    onSubmit() {
        if (this.loginForm.valid) {
            const formValue = this.loginForm.value;
            this.loginActions.loginWithTotp({
                ...this.loginInformation(),
                password: formValue.password,
                totp: formValue.totp.join('')
            });
            this.formErrorService.cleanError();
        }
        else {
            this.loginForm.markAllAsTouched();
            this.formErrorService.updateError(this.formErrorService.getFieldsInError(this.loginForm));
        }
    }
    /**
     * On back from phone code.
     */
    onBack() {
        this.formErrorService.cleanError();
        this.loginActions.changeAccount();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TotpViewComponent, deps: [{ token: i1$1.UntypedFormBuilder }, { token: LoginActionsService }, { token: FormErrorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.12", type: TotpViewComponent, selector: "ama-ng-totp-view", inputs: { loginInformation: { classPropertyName: "loginInformation", publicName: "loginInformation", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<form [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <label class=\"form-label\" i18n=\"@@login.totp.description\"\n    >Enter the code received in the authenticator app\n    <span class=\"mandatory-indicator\">*</span>\n  </label>\n  <!-- Hidden input field to permit autofill -->\n  <input id=\"usernameInput\" />\n  <div class=\"mb-5\">\n    <ama-ng-otp-code-view [parentForm]=\"loginForm\" [otpForm]=\"loginForm.get('totp')\"></ama-ng-otp-code-view>\n  </div>\n  <ama-ng-login-advanced-password\n    [parentForm]=\"loginForm\"\n    [passwordForm]=\"loginForm.get('password')\"\n  ></ama-ng-login-advanced-password>\n  <div class=\"form-text text-muted password-help-text\" i18n=\"@@login.totp.password.help\"\n    >Enter your sign-in password</div\n  >\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", styles: [":root{--df-navbar-height: 3.5rem}.password-help-text{margin-top:-1rem}#usernameInput{visibility:hidden;width:0px;height:0px}\n"], dependencies: [{ kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: OtpCodeViewComponent, selector: "ama-ng-otp-code-view", inputs: ["parentForm", "otpForm"] }, { kind: "component", type: ActionButtonsComponent, selector: "ama-ng-action-buttons", inputs: ["leftButton", "rightButton"] }, { kind: "component", type: AdvancedPasswordComponent, selector: "ama-ng-login-advanced-password", inputs: ["parentForm", "passwordForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: TotpViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-totp-view', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"loginForm\">\n  <p>\n    <span class=\"mandatory-indicator\">*</span>\n    <ng-container i18n=\"@@login.mandatory.asterix\">Mandatory</ng-container>\n  </p>\n  <label class=\"form-label\" i18n=\"@@login.totp.description\"\n    >Enter the code received in the authenticator app\n    <span class=\"mandatory-indicator\">*</span>\n  </label>\n  <!-- Hidden input field to permit autofill -->\n  <input id=\"usernameInput\" />\n  <div class=\"mb-5\">\n    <ama-ng-otp-code-view [parentForm]=\"loginForm\" [otpForm]=\"loginForm.get('totp')\"></ama-ng-otp-code-view>\n  </div>\n  <ama-ng-login-advanced-password\n    [parentForm]=\"loginForm\"\n    [passwordForm]=\"loginForm.get('password')\"\n  ></ama-ng-login-advanced-password>\n  <div class=\"form-text text-muted password-help-text\" i18n=\"@@login.totp.password.help\"\n    >Enter your sign-in password</div\n  >\n\n  <ama-ng-action-buttons [leftButton]=\"leftButton\" [rightButton]=\"rightButton\"> </ama-ng-action-buttons>\n</form>\n", styles: [":root{--df-navbar-height: 3.5rem}.password-help-text{margin-top:-1rem}#usernameInput{visibility:hidden;width:0px;height:0px}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.UntypedFormBuilder }, { type: LoginActionsService }, { type: FormErrorService }] });

class LoginComponent {
    constructor(store, loginActions, clpService, clpLoaderService, loginConfigService) {
        this.store = store;
        this.loginActions = loginActions;
        this.clpService = clpService;
        this.clpLoaderService = clpLoaderService;
        this.loginConfigService = loginConfigService;
        this.LOGIN_UI_STATE = LoginUiState;
        this.HTTP_STATUS = HTTP_STATUS;
        this.loginUiState = LoginUiState.form;
        this.viewReady = false;
        this.mfaSelfRegistrationActivated = false;
        this.cdr = inject(ChangeDetectorRef);
        this.subscription = new Subscription();
        this.ssoStatus$ = this.store.pipe(select(getSSOStatus));
        this.userSignedIn$ = this.store.pipe(select(getUserSignedIn));
        this.ddnaDevices$ = this.store.pipe(select(getDdnaDevices));
        this.mfaAvailable$ = this.store.pipe(select(getMfaAvailable));
        this.officeList$ = this.store.pipe(select(getOfficeList));
        this.subscription.add(this.store.pipe(select(getForgetPwdState)).subscribe((newForgetPwdState) => {
            this.forgetPwdState = newForgetPwdState;
        }));
        this.subscription.add(this.store.pipe(select(getLoginInformation)).subscribe((newLoginInformation) => {
            this.loginInformation = newLoginInformation;
        }));
        this.subscription.add(this.userSignedIn$.subscribe((isUserSignedIn) => {
            if (isUserSignedIn) {
                if (this.loginInformation.rememberMe) {
                    this.loginActions.setLoginInfo({
                        username: this.loginInformation.username,
                        officeId: this.loginInformation.officeId,
                        dutyCode: this.loginInformation.dutyCode,
                        rememberMe: this.loginInformation.rememberMe
                    });
                }
                else {
                    if (this.loginActions.readLoginInfo() != null) {
                        this.loginActions.removeLoginInfo();
                    }
                }
            }
        }));
        if (this.checkValidatePasswordMode()) {
            this.loginActions.initValidatePwdFlow();
        }
        else {
            this.loginActions.updateLoginStorage(this.loginActions.readLoginInfo());
        }
        this.loginConfigService
            .getConfig()
            .pipe(filter((loginConfig) => !!loginConfig), distinctUntilChanged(), take(1))
            .subscribe((loginConfig) => {
            this.loginConfig = loginConfig;
            this.viewReady = true;
            loginConfig.clpConfig
                .pipe(filter((clpConfig) => !!clpConfig), distinctUntilChanged(), take(1))
                .subscribe((clpConfig) => {
                this.mfaSelfRegistrationActivated = clpConfig.loginParameters.mfaSelfRegistrationActivated ?? true;
                this.clpLoaderService.loadClpAPI(clpConfig.baseUrl);
                this.clpService.initClpConfig(clpConfig, loginConfig);
            });
        });
        this.subscription.add(this.store.select(getLoginUiState).subscribe((uiState) => {
            this.loginUiState = uiState;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * Check if we are in the validate password flow (by looking at if an ACTION=VALIDATE is present in the url).
     * Returns false if the validation has been already done or cancelled
     * @return if we are in validate password mode
     */
    checkValidatePasswordMode() {
        return (this.forgetPwdState === undefined &&
            new RegExp('[?&]ACTION=VALIDATE', 'i').exec(window.location.href.toUpperCase()) != null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginComponent, deps: [{ token: i1.Store }, { token: LoginActionsService }, { token: ClpService }, { token: ClpLoaderService }, { token: LoginConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.12", type: LoginComponent, selector: "ama-ng-login", ngImport: i0, template: "<div id=\"loginForm\" *ngIf=\"viewReady\">\n  @if (loginUiState === LOGIN_UI_STATE.form) {\n    <ama-ng-login-login-view [loginInformation]=\"loginInformation\"> </ama-ng-login-login-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.jumpLogin) {\n    <ama-ng-jump-login [loginInfo]=\"loginInformation\"> </ama-ng-jump-login>\n  } @else if (loginUiState === LOGIN_UI_STATE.formOtp) {\n    <ama-ng-login-otp-view\n      [loginInformation]=\"loginInformation\"\n      [mfaSelfRegistrationActivated]=\"mfaSelfRegistrationActivated\"\n    ></ama-ng-login-otp-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formPhone) {\n    <ama-ng-login-phone-view\n      [loginInformation]=\"loginInformation\"\n      [mfaSelfRegistrationActivated]=\"mfaSelfRegistrationActivated\"\n    >\n    </ama-ng-login-phone-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formCode) {\n    <ama-ng-login-phone-code-view\n      [loginInformation]=\"loginInformation\"\n      [mfaSelfRegistrationActivated]=\"mfaSelfRegistrationActivated\"\n    >\n    </ama-ng-login-phone-code-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formDdna) {\n    <ama-ng-login-ddna-view [ddnaDevices]=\"ddnaDevices$ | async\"></ama-ng-login-ddna-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.authenticatorApp) {\n    <ama-ng-authenticator-view> </ama-ng-authenticator-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.authenticatorQrCode) {\n    <ama-ng-authenticator-qrcode-view></ama-ng-authenticator-qrcode-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.authenticatorValidationCode) {\n    <ama-ng-authenticator-code-view [loginInformation]=\"loginInformation\"></ama-ng-authenticator-code-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.forgetPwd) {\n    <ama-ng-login-forget-pwd [loginInformation]=\"loginInformation\"> </ama-ng-login-forget-pwd>\n  } @else if (loginUiState === LOGIN_UI_STATE.expiredPwd) {\n    <ama-ng-login-expired-pwd [loginInformation]=\"loginInformation\"></ama-ng-login-expired-pwd>\n  } @else if (loginUiState === LOGIN_UI_STATE.officeList) {\n    <ama-ng-login-office-list\n      [loginInformation]=\"loginInformation\"\n      [officeList]=\"officeList$ | async\"\n    ></ama-ng-login-office-list>\n  } @else if (loginUiState === LOGIN_UI_STATE.validatePwd) {\n    <ama-ng-login-validate-pwd></ama-ng-login-validate-pwd>\n  } @else if (loginUiState === LOGIN_UI_STATE.sso) {\n    <ama-ng-login-sso-view\n      [loginConfig]=\"loginConfig\"\n      [ssoStatus]=\"ssoStatus$ | async\"\n      [userSignedIn]=\"userSignedIn$ | async\"\n    ></ama-ng-login-sso-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.mfaSelfSelection) {\n    <ama-ng-mfa-self-selection-view\n      [loginInformation]=\"loginInformation\"\n      [mfaAvailable]=\"mfaAvailable$ | async\"\n    ></ama-ng-mfa-self-selection-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formTotp) {\n    <ama-ng-totp-view [loginInformation]=\"loginInformation\"></ama-ng-totp-view>\n  }\n</div>\n", dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AuthenticatorViewComponent, selector: "ama-ng-authenticator-view" }, { kind: "component", type: AuthenticatorQrCodeComponent, selector: "ama-ng-authenticator-qrcode-view" }, { kind: "component", type: AuthenticatorCodeViewComponent, selector: "ama-ng-authenticator-code-view", inputs: ["loginInformation"] }, { kind: "component", type: LoginViewComponent, selector: "ama-ng-login-login-view", inputs: ["loginInformation"] }, { kind: "component", type: OtpViewComponent, selector: "ama-ng-login-otp-view", inputs: ["loginInformation", "mfaSelfRegistrationActivated"] }, { kind: "component", type: DdnaViewComponent, selector: "ama-ng-login-ddna-view", inputs: ["ddnaDevices"] }, { kind: "component", type: ForgetPwdComponent, selector: "ama-ng-login-forget-pwd", inputs: ["loginInformation"] }, { kind: "component", type: ExpiredPasswordComponent, selector: "ama-ng-login-expired-pwd", inputs: ["loginInformation"] }, { kind: "component", type: ValidatePwdComponent, selector: "ama-ng-login-validate-pwd" }, { kind: "component", type: SSOViewComponent, selector: "ama-ng-login-sso-view", inputs: ["loginConfig", "ssoStatus", "userSignedIn"] }, { kind: "component", type: PhoneViewComponent, selector: "ama-ng-login-phone-view", inputs: ["loginInformation", "mfaSelfRegistrationActivated"] }, { kind: "component", type: PhoneCodeViewComponent, selector: "ama-ng-login-phone-code-view", inputs: ["loginInformation", "mfaSelfRegistrationActivated"] }, { kind: "component", type: JumpLoginComponent, selector: "ama-ng-jump-login", inputs: ["loginInfo"] }, { kind: "component", type: OfficeListComponent, selector: "ama-ng-login-office-list", inputs: ["loginInformation", "officeList"] }, { kind: "component", type: MfaSelfSelectionViewComponent, selector: "ama-ng-mfa-self-selection-view", inputs: ["loginInformation", "mfaAvailable"] }, { kind: "component", type: TotpViewComponent, selector: "ama-ng-totp-view", inputs: ["loginInformation"] }, { kind: "pipe", type: i4.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ama-ng-login', template: "<div id=\"loginForm\" *ngIf=\"viewReady\">\n  @if (loginUiState === LOGIN_UI_STATE.form) {\n    <ama-ng-login-login-view [loginInformation]=\"loginInformation\"> </ama-ng-login-login-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.jumpLogin) {\n    <ama-ng-jump-login [loginInfo]=\"loginInformation\"> </ama-ng-jump-login>\n  } @else if (loginUiState === LOGIN_UI_STATE.formOtp) {\n    <ama-ng-login-otp-view\n      [loginInformation]=\"loginInformation\"\n      [mfaSelfRegistrationActivated]=\"mfaSelfRegistrationActivated\"\n    ></ama-ng-login-otp-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formPhone) {\n    <ama-ng-login-phone-view\n      [loginInformation]=\"loginInformation\"\n      [mfaSelfRegistrationActivated]=\"mfaSelfRegistrationActivated\"\n    >\n    </ama-ng-login-phone-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formCode) {\n    <ama-ng-login-phone-code-view\n      [loginInformation]=\"loginInformation\"\n      [mfaSelfRegistrationActivated]=\"mfaSelfRegistrationActivated\"\n    >\n    </ama-ng-login-phone-code-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formDdna) {\n    <ama-ng-login-ddna-view [ddnaDevices]=\"ddnaDevices$ | async\"></ama-ng-login-ddna-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.authenticatorApp) {\n    <ama-ng-authenticator-view> </ama-ng-authenticator-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.authenticatorQrCode) {\n    <ama-ng-authenticator-qrcode-view></ama-ng-authenticator-qrcode-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.authenticatorValidationCode) {\n    <ama-ng-authenticator-code-view [loginInformation]=\"loginInformation\"></ama-ng-authenticator-code-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.forgetPwd) {\n    <ama-ng-login-forget-pwd [loginInformation]=\"loginInformation\"> </ama-ng-login-forget-pwd>\n  } @else if (loginUiState === LOGIN_UI_STATE.expiredPwd) {\n    <ama-ng-login-expired-pwd [loginInformation]=\"loginInformation\"></ama-ng-login-expired-pwd>\n  } @else if (loginUiState === LOGIN_UI_STATE.officeList) {\n    <ama-ng-login-office-list\n      [loginInformation]=\"loginInformation\"\n      [officeList]=\"officeList$ | async\"\n    ></ama-ng-login-office-list>\n  } @else if (loginUiState === LOGIN_UI_STATE.validatePwd) {\n    <ama-ng-login-validate-pwd></ama-ng-login-validate-pwd>\n  } @else if (loginUiState === LOGIN_UI_STATE.sso) {\n    <ama-ng-login-sso-view\n      [loginConfig]=\"loginConfig\"\n      [ssoStatus]=\"ssoStatus$ | async\"\n      [userSignedIn]=\"userSignedIn$ | async\"\n    ></ama-ng-login-sso-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.mfaSelfSelection) {\n    <ama-ng-mfa-self-selection-view\n      [loginInformation]=\"loginInformation\"\n      [mfaAvailable]=\"mfaAvailable$ | async\"\n    ></ama-ng-mfa-self-selection-view>\n  } @else if (loginUiState === LOGIN_UI_STATE.formTotp) {\n    <ama-ng-totp-view [loginInformation]=\"loginInformation\"></ama-ng-totp-view>\n  }\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.Store }, { type: LoginActionsService }, { type: ClpService }, { type: ClpLoaderService }, { type: LoginConfigService }] });

class LoginEffects {
    constructor(actions$, loginConfig) {
        this.actions$ = actions$;
        this.loginConfig = loginConfig;
        this.loginInfo$ = createEffect(() => this.actions$.pipe(ofType(LOGIN_ACTION.SIGN_IN_END), map$1((action) => {
            if (this.config && this.config.onSuccess) {
                this.config.onSuccess(action.payload);
            }
        })), { dispatch: false });
        this.errors$ = createEffect(() => this.actions$.pipe(ofType(CLP_ACTION.ERROR_RECEIVED), map$1((action) => this.onError(action))), { dispatch: false });
        this.passwordRulesErrors$ = createEffect(() => this.actions$.pipe(ofType(CLP_ACTION.PASSWORD_RULES_ERROR_RECEIVED), map$1((action) => this.onError(action))), { dispatch: false });
        this.clpInit$ = createEffect(() => this.actions$.pipe(ofType(CLP_ACTION.CLP_INITIALIZED), map$1((action) => {
            if (this.config && this.config.onClpInit) {
                this.config.onClpInit(action.payload);
            }
        })), { dispatch: false });
        this.loginConfig
            .getConfig()
            .pipe(filter(conf => !!conf), distinctUntilChanged(), take(1))
            .subscribe(config => {
            this.config = config;
        });
    }
    onError(action) {
        if (this.config && this.config.onError) {
            this.config.onError(action.payload);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginEffects, deps: [{ token: i1$2.Actions }, { token: LoginConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Actions }, { type: LoginConfigService }] });

class LoginModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.12", ngImport: i0, type: LoginModule, declarations: [LoginComponent,
            LoginViewComponent,
            OtpViewComponent,
            DdnaViewComponent,
            ForgetPwdComponent,
            ExpiredPasswordComponent,
            ValidatePwdComponent,
            SSOViewComponent,
            AdvancedPasswordComponent,
            NewPasswordComponent,
            PhoneViewComponent,
            PhoneCodeViewComponent,
            JumpLoginComponent,
            OfficeListComponent,
            MfaSelfSelectionViewComponent,
            TotpViewComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            DfAdvancedInputModule, i1.StoreFeatureModule, i1$2.EffectsFeatureModule, NgbTooltipModule,
            DfPopoverModule,
            DfAlertModule,
            DfSelectModule,
            NgbTypeaheadModule,
            PasswordTooltipIndicatorComponent,
            PasswordStrengthIndicatorComponent,
            CapsLockDirective,
            DfSelectModule,
            OtpCodeViewComponent,
            AuthenticatorViewComponent,
            AuthenticatorQrCodeComponent,
            AuthenticatorCodeViewComponent,
            ActionButtonsComponent], exports: [LoginComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginModule, providers: [
            ReactiveFormUtilsService,
            LoginActionsService,
            ClpService,
            UserManagementService,
            LoginConfigService,
            FormErrorService,
            RequestStatusService
        ], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            DfAdvancedInputModule,
            StoreModule.forFeature(LOGIN_FEATURE, loginReducer),
            EffectsModule.forFeature([LoginEffects]),
            NgbTooltipModule,
            DfPopoverModule,
            DfAlertModule,
            DfSelectModule,
            NgbTypeaheadModule,
            PasswordTooltipIndicatorComponent,
            PasswordStrengthIndicatorComponent,
            DfSelectModule,
            OtpCodeViewComponent,
            AuthenticatorViewComponent,
            AuthenticatorQrCodeComponent,
            AuthenticatorCodeViewComponent,
            ActionButtonsComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.12", ngImport: i0, type: LoginModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        DfAdvancedInputModule,
                        StoreModule.forFeature(LOGIN_FEATURE, loginReducer),
                        EffectsModule.forFeature([LoginEffects]),
                        NgbTooltipModule,
                        DfPopoverModule,
                        DfAlertModule,
                        DfSelectModule,
                        NgbTypeaheadModule,
                        PasswordTooltipIndicatorComponent,
                        PasswordStrengthIndicatorComponent,
                        CapsLockDirective,
                        DfSelectModule,
                        OtpCodeViewComponent,
                        AuthenticatorViewComponent,
                        AuthenticatorQrCodeComponent,
                        AuthenticatorCodeViewComponent,
                        ActionButtonsComponent
                    ],
                    declarations: [
                        LoginComponent,
                        LoginViewComponent,
                        OtpViewComponent,
                        DdnaViewComponent,
                        ForgetPwdComponent,
                        ExpiredPasswordComponent,
                        ValidatePwdComponent,
                        SSOViewComponent,
                        AdvancedPasswordComponent,
                        NewPasswordComponent,
                        PhoneViewComponent,
                        PhoneCodeViewComponent,
                        JumpLoginComponent,
                        OfficeListComponent,
                        MfaSelfSelectionViewComponent,
                        TotpViewComponent
                    ],
                    providers: [
                        ReactiveFormUtilsService,
                        LoginActionsService,
                        ClpService,
                        UserManagementService,
                        LoginConfigService,
                        FormErrorService,
                        RequestStatusService
                    ],
                    exports: [LoginComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AuthenticateRequest, AuthenticatorAppRequest, AuthenticatorQrCodeRequest, AuthenticatorValidationCodeRequest, CLP_ACTION, CapsLockDirective, ChangeAccount, ChangePasswordAndLoginRequest, CloseForceSignIn, ClpErrorReceived, ClpInit, ClpInitialized, ClpLoaderService, ClpService, DdnaCheckEnd, DdnaCheckStart, DdnaNeeded, DdnaRequest, ErrorReceived, ExpiredPassword, FormError, FormErrorService, HTTP_STATUS, IdentifyRequest, InitForgetPwdFlow, InitJumpLoginFlow, InitValidatePwdFlow, JumpLoginRequest, LOGIN_ACTION, LoginActionsService, LoginAlertModel, LoginAlertType, LoginComponent, LoginConfigService, LoginModule, LoginRequestSSO, MFA_ID, MfaSelfSelection, OFFICE_ID_REGEXP, OfficeList, OtpEmulateErrorReceived, OtpErrorReceived, OtpNeeded, OtpNeededImpersonate, OtpRequest, OttNeededImpersonate, PasswordRulesErrorReceived, PasswordRulesReceived, PasswordRulesRequest, PasswordStrengthIndicatorComponent, PasswordTooltipIndicatorComponent, PhoneNumberNeeded, PhoneNumberRequest, ResetPasswordEnd, ResetPasswordRequest, SelectedMFA, SignInEnd, TotpNeeded, TotpRequest, UpdateLoginStorage, UserManagementService, Utils, ValidatePasswordEnd, ValidatePasswordRequest, ValidationCodeNeeded, ValidationCodeRequest, getLoginInformation };
